import {TranslationTree} from '../types';

const zh: TranslationTree = {
    premiumRoyalties: {
        "accrued": "本月累计",
        "accruedNote": "此为限额和审核前的估算金额，暂不可提现。",
        "held": "待审核",
        "heldNote": "包含往月金额。暂扣金额须经批准。",
        "adjustments": "本月调整",
        "adjustmentsNote": "因限额和资金变化而减少的金额。",
        "settlementNote": "版税在月末及审核通过后入账，再按配置的结算等待期转为可用余额。",
        "pending": "待结算版税",
        "externalNotice": "只有在 VocalCentric 内查看才可能产生版税。打开或下载此文件不计入。",
        "offlineNotice": "版税计量需要联网。离线播放不计入。",
        "internalNote": "内部歌曲版税遵循艺人及合作方的付款流程。",
        "available": "可用余额"
},
    live: {
        "director": "指挥",
        "directorControls": "指挥控制",
        "directorHint": "这些控制会为房间内所有人关闭麦克风声音，并停止录制这些麦克风。歌手可以自行重新打开麦克风。",
        "muteSection": "静音声部",
        "muteForEveryone": "为所有人静音",
        "endForEveryone": "为所有人结束",
        "endConfirm": "为所有人结束本次排练？正在录制的片段将停止，所有人将离开通话。",
        "notifyPending": "你已连接。成员通知尚未发送，我们会自动重试。",
        "liveNow": "正在直播",
        "liveNowJoin": "正在直播 · 加入",

        "openRoom": "打开实时排练",
        "viewRoom": "查看通话",
        "beforeJoin": "加入前",
        "you": "你",
        "muted": "麦克风已关闭",
        "closePreview": "关闭预览",
        "mixer": "你的混音",
        "joining": "正在加入…",
        "ended": "本次排练已结束。",
        "noOtherParticipants": "其他歌手加入后将显示在这里。",
        "noTakes": "暂无录音。",
        "captureUnavailable": "录音暂不可用。你仍可进行实时排练。",
        "armed": "录音已就绪",
        "timing": "时钟估计（± 毫秒）",
        "timingHint": "录音对齐时间为估计值。发布前请检查每次录音；设备和音频延迟仍需校准。",
        "publishHint": "发布将更新此歌曲段落中选定的声部。",
        "quality": "音频连接",
        "excellent": "极佳",
        "good": "良好",
        "poor": "较差",
        "lost": "已断开",
        "unknown": "测量中",
        "title": "实时排练",
        "start": "开始实时排练",
        "join": "加入排练",
        "headphones": "我正在使用有线耳机。",
        "headphonesWarning": "有线耳机的延迟更低。扬声器可能产生回声或啸叫，蓝牙可能增加延迟。请调低扬声器音量，不唱歌时将麦克风静音。",
        "consent": "允许本次排练录制我的麦克风，用于创建自定义和声。关闭麦克风会停止录音。",
        "waiting": "等待指挥开始排练。",
        "reopen": "重新开放排练",
        "connected": "已连接",
        "recording": "正在录制麦克风",
        "monitorHint": "这些混音控制仅改变您听到的声音，不会影响其他歌手或录音。",
        "volume": "音量",
        "mute": "静音",
        "solo": "独奏",
        "soprano": "女高音",
        "alto": "女低音",
        "tenor": "男高音",
        "bass": "男低音",
        "unassigned": "未分配",
        "micOff": "关闭麦克风",
        "micOn": "开启麦克风",
        "retryUploads": "重试上传已保存录音",
        "leave": "离开排练",
        "song": "歌曲",
        "section": "歌曲段落",
        "record": "录制片段",
        "stop": "停止录制",
        "end": "结束排练",
        "refreshTakes": "刷新录音",
        "takes": "已录制片段",
        "selectTake": "选择录音",
        "publish": "创建自定义和声",
        "joinFailed": "无法加入。请检查麦克风权限后重试。",
        "commandFailed": "排练已更改或指令失败。请刷新后重试。",
        "connectionLost": "连接中断。应用保持运行时，录音可能继续保存在本地。",
        "captureFailed": "无法继续录音。已保存音频会被保留。请重新加入以录制下一段。",
        "uploadPending": "音频已保存在此设备。连接后请重试上传。",
        "published": "已创建自定义和声。打开歌曲的和声播放器即可练习。",
        "publishFailed": "请从同一录制片段中为每个声部选择一个已完成的录音，然后重试。"
},
    common: {
        login: '登录',
        register: '注册',
        signUp: '创建账户',
        proceed: '继续',
        confirm: '确认',
        verify: '验证',
        forgotPassword: '忘记密码',
        settings: '设置',
        logout: '退出登录',
        profile: '个人资料',
        myApplications: '我的申请',
        myInvites: '我的邀请',
        operationSuccessful: '操作成功',
        yourEmail: '你的邮箱',
        resendOtp: '重新发送验证码',
        resendOtpIn: '{{time}} 后可重新发送验证码',
        preferences: '偏好设置',
        preferredCurrency: '首选货币',
        preferredLanguage: '首选语言',
        saveCurrency: '保存货币',
        saveLanguage: '保存语言',
        save: '保存',
        tryAgain: '重试',
        share: '分享',
        cancel: '取消',
        close: '关闭',
        delete: '删除',
        loading: '加载中...',
    },
    auth: {
        welcomeBack: '欢迎回来！',
        loginSubtitle: '请输入你的信息以访问仪表盘',
        email: '邮箱',
        password: '密码',
        enterYourEmail: '请输入邮箱',
        enterYourPassword: '请输入密码',
        noAccount: '还没有账户？',
        haveAccount: '已有账户？',
        alreadyHaveAccount: '已有账户？',
        forgotPasswordPrompt: '请输入你的邮箱地址',
        welcomeToVocalcentric: '欢迎使用 VocalCentric！',
        registerSubtitle: '填写信息以创建账户',
        registerSubtitleMinimal: '几秒钟即可创建账户',
        selectPart: '选择声部',
        firstName: '名',
        lastName: '姓',
        username: '用户名',
        phoneNumber: '手机号',
        firstNamePlaceholder: '名',
        lastNamePlaceholder: '姓',
        usernamePlaceholder: '用户名',
        phonePlaceholder: '手机号',
        confirmPassword: '确认密码',
        confirmPasswordPlaceholder: '请确认密码',
        referral: '推荐码',
        confirmOtp: '确认验证码',
        otpPrompt: '请输入发送到 {{email}} 的验证码',
        forgotPasswordTitle: '忘记密码',
        newPassword: '新密码',
        newPasswordSubtitle: '请输入你的新密码',
    },
    modals: {
        mobileAppRequired: {
            afterInstall: '安装后，重新打开此链接并点击“打开应用”，即可从上次的位置继续。',
            title: '继续使用应用',
            description: '为获得最佳移动体验，请打开应用。',
            openApp: '打开应用',
            playStore: 'Google Play',
            appStore: 'App Store',
            continueWeb: '继续使用网页版',
            close: '关闭移动应用提示',
        },
        manageServiceTypes: {
            title: '管理服务类型',
            description: '创建、更新或删除该诗班用于排期的自定义服务类型。',
            loading: '正在加载服务类型...',
            noDescription: '暂无描述',
            empty: '该诗班尚未添加任何自定义服务类型。',
            emptyHint: '使用右侧表单添加第一个类型。',
            edit: '编辑',
            delete: '删除',
            editServiceType: '编辑服务类型',
            createServiceType: '创建服务类型',
            editHint: '在下方更新服务类型详情。',
            createHint: '为该诗班添加新的自定义服务类型。',
            name: '名称',
            namePlaceholder: '例如：主日礼拜',
            descriptionLabel: '描述',
            descriptionPlaceholder: '可选说明该服务类型的用途。',
            recurrence: '重复规则',
            weekday: '星期',
            firstServiceDate: '首次服务日期',
            monthlyPattern: '每月模式',
            dayOfMonth: '每月日期',
            weekOfMonth: '第几周',
            month: '月份',
            day: '日期',
            serviceDate: '服务日期',
            recurrencePreview: '重复预览',
            monthlyModesHint: '若是每月第 1/2/5 个星期几，请使用“每月第 N 个星期几”。',
            saving: '保存中...',
            creating: '创建中...',
            saveChanges: '保存更改',
            confirmDeleteDescription: '删除该服务类型会同时移除使用它的日期分配。是否继续？',
            updateAction: '更新',
            createAction: '创建',
            weekdays: {
                sunday: '周日',
                monday: '周一',
                tuesday: '周二',
                wednesday: '周三',
                thursday: '周四',
                friday: '周五',
                saturday: '周六',
            },
            months: {
                january: '一月',
                february: '二月',
                march: '三月',
                april: '四月',
                may: '五月',
                june: '六月',
                july: '七月',
                august: '八月',
                september: '九月',
                october: '十月',
                november: '十一月',
                december: '十二月',
            },
            weekOrdinals: {
                first: '第1',
                second: '第2',
                third: '第3',
                fourth: '第4',
                fifth: '第5',
            },
            recurrenceTypes: {
                weekly: '每周',
                biweekly: '每两周',
                monthly: '每月',
                annual: '每年',
                oneTime: '一次性',
            },
            monthlyModes: {
                dayOfMonth: '每月固定日期',
                nthWeekday: '每月第 N 个星期几',
            },
            summary: {
                weeklyOn: '每周 {{weekday}}',
                biweeklyOn: '每两周 {{weekday}}',
                biweeklyFrom: '每两周 {{weekday}}{{suffix}}',
                fromDate: '（自 {{date}} 起）',
                monthlyNthWeekday: '每月 {{ordinal}} 个{{weekday}}',
                monthlyDay: '每月第 {{day}} 日',
                annualOn: '每年 {{month}}{{day}}日',
                oneTimeOn: '一次性：{{date}}',
                oneTimeNotSet: '未设置一次性服务日期',
                noRecurrence: '未配置重复规则',
            },
            validation: {
                enterName: '请输入服务类型名称',
                chooseWeekday: '请选择星期',
                chooseFirstServiceDate: '请选择首次服务日期',
                chooseDayOfMonth: '请选择每月日期',
                chooseWeekOfMonth: '请选择第几周',
                chooseMonthAndDay: '请选择月份和日期',
                chooseServiceDate: '请选择服务日期',
            },
            toast: {
                loadFailed: '加载服务类型失败',
                updated: '服务类型已更新',
                created: '服务类型已创建',
                saveFailed: '无法{{action}}服务类型',
                deleted: '服务类型已删除',
                deleteFailed: '删除服务类型失败',
            },
        },
        whitelist: {
            status: {
                approvedTitle: '申请已通过',
                pendingTitle: '申请审核中',
                rejectedTitle: '申请被拒绝',
                applyTitle: '申请白名单',
                reapplyTitle: '重新申请白名单',
                approvedMessage: '你的白名单申请已通过。你现在可以使用专业资料工具。',
                pendingMessage: '你的申请正在审核中。管理员将在 48 小时内完成审核。',
                rejectedMessage: '你之前的申请未通过。现在可以更新资料并重新申请。',
            },
            applicationStatus: '申请状态',
            fillToApply: '请完整填写后提交申请。',
            closeAria: '关闭白名单申请弹窗',
            loadingStatus: '正在加载申请状态...',
            uploadHint: '上传一段展示你技能与能力水平的视频。',
            socialPlaceholder: '输入社交媒体主页 *',
            socialLabel: '社交媒体账号',
            reasonPlaceholder: '你为什么想加入白名单？*',
            reasonLabel: '申请理由',
            websitePlaceholder: '网站链接',
            websiteLabel: '网站链接（可选）',
            submitting: '提交中...',
            apply: '申请',
            reapply: '重新申请',
            unknownState: '无法确定当前白名单申请状态。',
            toast: {
                submitted: '白名单申请提交成功',
                submitFailed: '无法提交白名单申请',
            },
        },
        director: {
            status: {
                approvedTitle: '申请已通过',
                pendingTitle: '申请审核中',
                rejectedTitle: '申请被拒绝',
                applyTitle: '申请导演角色',
                reapplyTitle: '重新申请导演角色',
                approvedMessage: '你的导演申请已通过。你现在可以创建并管理诗班。',
                pendingMessage: '你的申请正在审核中。管理员将在 48 小时内完成审核。',
                rejectedMessage: '你之前的申请未通过。现在可以更新资料并重新申请。',
            },
            applicationStatus: '申请状态',
            fillToApply: '请完整填写后提交申请。',
            closeAria: '关闭导演申请弹窗',
            loadingStatus: '正在加载申请状态...',
            uploadHint: '上传一段展示你领导力与音乐指导能力的视频。',
            socialPlaceholder: '输入社交媒体主页 *',
            socialLabel: '社交媒体账号',
            reasonPlaceholder: '你为什么想成为导演？*',
            reasonLabel: '申请理由',
            websitePlaceholder: '网站链接',
            websiteLabel: '网站链接（可选）',
            apply: '申请',
            reapply: '重新申请',
            unknownState: '无法确定当前导演申请状态。',
            toast: {
                submitted: '导演申请提交成功',
                submitFailed: '无法提交导演申请',
            },
        },
        shareSetlist: {
            title: '分享“{{name}}”',
            description: '管理可见性、已选歌曲，并复制该歌单的公开分享链接。',
            visibility: '可见性',
            makePublic: '将歌单设为公开',
            selectedSongs: '已选歌曲',
            remove: '移除',
            moveSongUp: '上移歌曲',
            moveSongDown: '下移歌曲',
            emptySongs: '该歌单暂无歌曲。',
            addMode: '添加方式',
            manualEntry: '手动',
            importFromText: '从文本导入',
            importTextLabel: 'WhatsApp 歌单文本',
            importTextPlaceholder: '在这里粘贴类似 WhatsApp 的歌单消息...',
            songSource: '歌曲来源',
            search: '搜索',
            manualYoutube: '手动添加（YouTube）',
            publicDomain: '公共领域',
            searchPlaceholder: '搜索歌曲...',
            selectLabelPlaceholder: '为歌曲选择标签',
            addSongWithLabel: '按标签添加歌曲',
            addExternalSong: '添加外部歌曲',
            addPublicDomainSong: '添加公共领域歌曲',
            previewImport: '预览导入',
            previewingImport: '预览中...',
            importPreview: '导入预览',
            importPreviewSummary: '{{count}} 首歌曲可导入',
            importToSetlist: '导入到歌单',
            importingSetlist: '导入中...',
            showAddSongs: '显示添加歌曲',
            hideAddSongs: '隐藏添加歌曲',
            shareLink: '分享链接',
            copyLink: '复制链接',
            public: '公开',
            private: '私密',
            toast: {
                linkCopied: '链接已复制到剪贴板！',
                visibilityUpdated: '歌单已设为{{visibility}}',
                updateVisibilityFailed: '更新可见性失败',
                noSongSelected: '未选择歌曲',
                songAlreadyExists: '该歌曲已在歌单中',
                selectLabel: '请为歌曲选择标签',
                songAdded: '歌曲已添加到歌单',
                errorOccurred: '发生错误',
                songRemoved: '歌曲已从歌单移除',
                removeSongFailed: '移除歌曲失败',
                reorderSongFailed: '歌曲重新排序失败',
                enterImportText: '请先粘贴歌单文本再预览',
                importPreviewReady: '导入预览已生成',
                importPreviewFailed: '预览导入歌单失败',
                nothingNewToImport: '解析出的歌曲都已存在于当前歌单中',
                importSuccess: '已将 {{count}} 首歌曲导入歌单',
                importFailed: '导入歌曲到歌单失败',
            },
        },
        addSongToRehearsal: {
            title: '添加歌曲到排练',
            description: '选择歌曲来源或从原始文本导入，然后将其添加到本次排练。',
            songSource: '歌曲来源',
            search: '搜索',
            manualYoutube: '手动添加（YouTube）',
            publicDomain: '公共领域',
            searchPlaceholder: '搜索歌曲...',
            cancel: '取消',
            adding: '添加中...',
            importing: '导入中...',
            addToRehearsal: '添加到排练',
            fallbackArtist: '未知艺术家',
            fallbackGenre: '未知',
            destination: '排练分组',
            additionalSongs: '其他歌曲',
            untitledSetlist: '未命名歌单',
            toast: {
                selectSongFirst: '请先选择一首歌曲',
                songAdded: '歌曲已添加到排练',
                addFailed: '添加歌曲到排练失败',
                enterImportText: '请先粘贴歌单文本再进行预览',
                importPreviewReady: '导入预览已生成',
                importPreviewFailed: '预览导入歌曲失败',
                importSuccess: '已向排练添加 {{count}} 首歌曲',
                importFailed: '将导入歌曲添加到排练失败',
            },
        },
        shareSetlistWithChoir: {
            title: '分享“{{name}}”',
            description: '选择一个诗班，并可选择覆盖共享歌单名称或排期。',
            chooseChoir: '选择诗班',
            loadingChoirs: '正在加载你的诗班...',
            searchPlaceholder: '按名称、ID 或 UUID 搜索',
            loading: '加载中...',
            noMatches: '无匹配结果',
            nameOptional: '名称（可选）',
            defaultNamePlaceholder: '主日礼拜',
            scheduledForOptional: '计划时间（可选）',
            cancel: '取消',
            sharing: '分享中...',
            shareToChoir: '分享给诗班',
            toast: {
                loadChoirsFailed: '无法加载你的诗班',
                sharedToChoir: '已分享给 {{name}}',
                shareFailed: '分享歌单失败',
            },
        },
        confirmation: {
            title: '确认',
            description: '你确定要继续吗？',
            confirm: '确认',
            cancel: '取消',
        },
        addChoirSeats: {
            title: '为诗班增加席位',
            description: '选择要为该诗班增加的席位数量。',
            seats: '席位',
            seatsOption: '{{count}} 个席位',
            cancel: '取消',
            adding: '添加中...',
            addSeats: '添加席位',
            toast: {
                chooseSeats: '请选择席位数量',
                completePaymentInNewTab: '请在新标签页完成支付',
                addFailed: '无法为诗班增加更多席位',
            },
        },
        manageChoirEntitlements: {
            title: 'Premium 席位共享',
            sourceDescription: '从此诗班的 Premium 订阅分配席位，或创建安全兑换码。',
            recipientDescription: '兑换共享 Premium 席位的诗班提供的安全代码。',
            directTitle: '分配给诗班',
            recipientChoir: '接收诗班 ID',
            recipientChoirPlaceholder: '诗班 UUID',
            seats: '席位',
            allocate: '分配席位',
            codeTitle: '创建兑换码',
            codeDescription: '代码会立即预留席位，且只能由一个诗班兑换。',
            generateCode: '创建代码',
            generatedCode: '请安全地分享此代码',
            allocations: '席位分配',
            noAllocations: '尚无席位分配。',
            unredeemedCode: '未兑换代码',
            additionalSeats: '额外席位',
            increase: '增加',
            code: '兑换码',
            codePlaceholder: 'VC-...',
            redeemCode: '兑换代码',
            toast: {
                loadFailed: '无法加载席位分配',
                actionFailed: '无法更新 Premium 席位共享',
                allocated: 'Premium 席位已分配',
                codeGenerated: 'Premium 席位代码已创建',
                increased: 'Premium 席位分配已增加',
                redeemed: 'Premium 席位代码已兑换',
            },
        },
        createSchedule: {
            title: '创建新排期',
            description: '创建一个排期区间，并设置该诗班的分配选项。',
            scheduleLabel: '排期标签',
            scheduleLabelPlaceholder: '七月排期',
            startDate: '开始日期',
            endDate: '结束日期',
            autoAssignMembers: '自动分配成员',
            perPartCount: '每个声部人数',
            cancel: '取消',
            creating: '创建中...',
            createSchedule: '创建排期',
            toast: {
                fillAllFields: '请填写所有字段',
                created: '排期已创建！',
                createFailed: '创建排期失败',
            },
        },
        inviteChoirMember: {
            title: '邀请诗班成员',
            description: '发送邀请并为新成员分配默认声部。',
            email: '邮箱',
            emailPlaceholder: 'user@example.com',
            assignPart: '分配声部',
            addCustomPart: '+ 添加自定义声部',
            cancel: '取消',
            sendInvitation: '发送邀请',
            linkDescription: '复制一个诗班邀请链接并发送给多人。',
            copyInvitationLink: '复制邀请链接',
            copyingLink: '正在复制...',
            toast: {
                provideEmailAndPart: '请提供邮箱和声部',
                invitationSent: '邀请已发送',
                sendFailed: '发送邀请失败',
                linkCopied: '邀请链接已复制',
                linkFailed: '复制邀请链接失败',
            },
        },
        generateShareLink: {
            title: '生成分享链接',
            description: '选择公开和声链接在复制前应保持有效的时长。',
            expiration: '有效期',
            cancel: '取消',
            generating: '生成中...',
            generateLink: '生成链接',
            options: {
                oneDay: { label: '1 天', hint: '24 小时后过期' },
                sevenDays: { label: '7 天', hint: '适合短周期审核' },
                thirtyDays: { label: '30 天', hint: '适合排练分享' },
                ninetyDays: { label: '90 天', hint: '更长时间的排练访问' },
                never: { label: '永不过期', hint: '链接将不会过期' },
            },
        },
        renameHarmonyPart: {
            title: '重命名和声声部',
            description: '重命名或重新分配此移调声部，而不更改源录音。',
            partName: '声部名称',
            save: '保存名称',
            saving: '正在保存...',
        },
        serviceDays: {
            title: '配置服务日期',
            description: '为每周每一天分配服务类型，或标记为无服务。',
            empty: '当前没有可用的服务类型，因此无法为每一天进行分配。',
            emptyHint: '请先创建一个非循环的每周服务类型，然后再回来配置每周服务日期。',
            createServiceType: '创建服务类型',
            noServiceOption: '-- 无服务 --',
            cancel: '取消',
            saving: '保存中...',
            saveChanges: '保存更改',
            weekdays: {
                sunday: '周日',
                monday: '周一',
                tuesday: '周二',
                wednesday: '周三',
                thursday: '周四',
                friday: '周五',
                saturday: '周六',
            },
            toast: {
                loadServiceTypesFailed: '加载服务类型失败',
                loadExistingDaysFailed: '加载现有服务日期失败',
                updated: '服务日期已更新',
                errorOccurred: '发生错误',
            },
        },
        shareHarmonyLink: {
            title: '生成分享链接',
            description: '选择和声分享链接应保持有效的时长。',
            closeAria: '关闭分享链接设置',
            expiration: '有效期',
            linkExpiry: '链接过期时间：',
            cancel: '取消',
            generating: '生成中...',
            generateLink: '生成链接',
            options: {
                oneDay: '1 天',
                sevenDays: '7 天',
                thirtyDays: '30 天',
                ninetyDays: '90 天',
                never: '永不过期',
            },
        },
        reportContribution: {
            title: '举报贡献',
            description: '请选择最能说明该贡献需要审核的原因。',
            cancel: '取消',
            submitReport: '提交举报',
            reasons: {
                wrongPart: '声部错误',
                wrongSection: '段落错误',
                lowQualityAudio: '音频质量低',
                poorPerformance: '表现较差',
                spamOrIrrelevant: '垃圾信息或无关内容',
                offensiveContent: '冒犯性内容',
            },
        },
        reportMarketplaceSong: {
            title: '举报商城歌曲',
            description: '请选择最能说明该歌曲需要审核的原因。',
            detailsPlaceholder: '添加可选说明',
            cancel: '取消',
            submitReport: '提交举报',
            reasons: {
                plagiarizedSong: '歌曲抄袭',
                copyrightIssue: '版权问题',
                misleadingMetadata: '误导性元数据',
                poorAudioQuality: '音频质量差',
                offensiveContent: '冒犯性内容',
                spamOrIrrelevant: '垃圾信息或无关内容',
                other: '其他',
            },
        },
        requestContribution: {
            title: '发起贡献请求',
            selectedSong: '已选择：{{title}} - {{artist}}',
            noSongSelected: '尚未选择歌曲。请先搜索歌曲。',
            searchPlaceholder: '搜索歌曲（站内或外部）',
            selectPart: '选择声部',
            section: '段落',
            songKeyOptional: '调性（可选）',
            bountyXpOptional: '赏金 XP（可选）',
            additionalNotesOptional: '附加备注（可选）',
            cancel: '取消',
            submitting: '提交中...',
            submitRequest: '提交请求',
            toast: {
                selectSongAndPartType: '请选择歌曲和声部类型',
                submitted: '贡献请求已提交',
                submitFailed: '提交请求失败',
            },
        },
        submitContribution: {
            title: '提交贡献',
            selectedSong: '已选择：{{title}} - {{artist}}',
            noSongSelected: '尚未选择歌曲。请先搜索歌曲。',
            searchPlaceholder: '搜索歌曲（站内或外部）',
            selectPart: '选择声部',
            sectionPlaceholder: '段落（例如：副歌、桥段）',
            uploadMode: '上传方式：',
            file: '文件',
            record: '录音',
            uploadYourAudio: '上传你的音频',
            cancel: '取消',
            submitting: '提交中...',
            submitContribution: '提交贡献',
            toast: {
                recordingUploadFailed: '录音上传失败',
                completeAllFields: '提交前请填写完整所有字段。',
                submittedSuccessfully: '你的贡献已成功提交！',
                submissionFailed: '提交失败',
            },
        },
        submitChallengeEntry: {
            title: '提交参赛作品',
            description: '上传你的挑战表演并提交到排行榜。',
            uploadVideo: '上传挑战参赛视频',
            captionPlaceholder: '向大家介绍你的参赛作品',
            cancel: '取消',
            submitting: '提交中...',
            submitEntry: '提交参赛作品',
        },
        updateDefaultPart: {
            title: '选择你的默认声部和用户名！',
            description: '你希望演唱或演奏哪个声部？这将作为你的默认声部。',
            selectDefaultPart: '选择默认声部',
            chooseUsername: '选择用户名',
            usernameValidation: '用户名长度需为 3-15 个字符，且只能包含字母、数字和下划线。',
            chooseDifferentUsername: '请选择不同的用户名后继续。',
            usernameTaken: '该用户名已被占用。',
            loading: '...加载中',
            setDefaultPart: '设置默认声部',
            toast: {
                profileUpdated: '资料更新成功',
            },
        },
        challengeVote: {
            title: '投票',
            description: '输入你的评审意见',
            commentPlaceholder: '评论',
            score: '评分 {{score}}%',
            disqualify: '取消资格',
            cancel: '取消',
            submitting: '提交中...',
            submitVote: '提交投票',
        },
        deleteHarmonyConfirm: {
            cancel: '取消',
            delete: '删除',
            deleting: '删除中...',
        },
        shareSchedule: {
            title: '分享排期',
            description: '生成可分享的公开排期链接，或将当前排期下载为 PDF。',
            closeAria: '关闭排期分享弹窗',
            publicScheduleLink: '公开排期链接',
            publicScheduleHint: '选择公开链接在生成后应保持有效的时长。',
            linkExpiry: '链接过期时间',
            generating: '生成中...',
            generateLink: '生成链接',
            regenerateLink: '重新生成链接',
            generatedLink: '已生成链接',
            readyToShare: '可分享',
            copyLink: '复制链接',
            openLink: '打开链接',
            generateToReveal: '生成链接后，可在此显示可分享的公开排期 URL。',
            pdfDownload: 'PDF 下载',
            pdfDescription: '将当前排期下载为可打印的 PDF。',
            pdfHint: '当指挥需要固定的可打印副本，而不是实时公开页面时可使用此功能。',
            preparingPdf: '正在准备 PDF...',
            downloadPdf: '下载 PDF',
            options: {
                oneDay: '1 天',
                sevenDays: '7 天',
                thirtyDays: '30 天',
                ninetyDays: '90 天',
                never: '永不过期',
            },
            toast: {
                linkCopied: '链接已复制到剪贴板',
            },
        },
        fullScreen: {
            confirmationIllustrationAlt: '确认插图',
            passwordResetSuccess: '恭喜，你的密码已重置。',
            login: '登录',
        },
        postSignupOnboarding: {
            welcomeToVocalcentric: '欢迎来到 VocalCentric',
            skipForNow: '暂时跳过',
            back: '返回',
            continue: '继续',
            steps: {
                welcome: {
                    title: '快速完成你的初始设置',
                    description: 'VocalCentric 帮助你练习声部、与诗班更高效排练、发现歌曲与分轨，并通过社区参与持续成长。',
                    items: {
                        practiceWithStems: '使用分轨和独立声部练习',
                        prepareRehearsals: '准备排练并组织歌单',
                        collaborate: '在诗班、项目和社区中协作',
                        buildConsistency: '通过结构化音乐流程建立稳定习惯',
                    },
                },
                interests: {
                    title: '你来这里是为了什么？',
                    description: '可选一项或多项，以个性化你的起步体验。',
                },
                role: {
                    title: '你如何使用 VocalCentric？',
                    description: '可选，但能帮助我们更好地引导你。',
                },
                recommendation: {
                    title: '推荐起点',
                    description: '基于你的选择，这是最适合开始的第一站。',
                    recommendedLabel: '推荐',
                    exploreEverythingInstead: '改为先浏览全部内容',
                },
            },
            toast: {
                saveFailed: '无法保存引导偏好设置',
            },
        },
        personalizedOnboarding: {
            title: '个性化设置',
            skipForNow: '暂时跳过',
            back: '返回',
            continue: '继续',
            finish: '完成设置',
            saveFailed: '无法保存引导进度',
            intentTitle: '你来这里是为了什么？',
            intentDescription: '可选一项或多项，以个性化你的起步体验。',
            roleTitle: '你如何使用 VocalCentric？',
            roleDescription: '可选，但能帮助我们更好地引导你。',
            profileTitle: '设置你的起步路径',
            profileDescription: '这些快速选择会个性化你的下一步。',
            usernameStepTitle: '设置你的用户名',
            usernameStepDescription: '这能帮助协作者找到你，并保持资料一致。',
            partStepTitle: '选择你的角色',
            partStepDescription: '选择你的主要角色（如男高、女低、钢琴手等）以获得更精准引导。',
            nameStepTitle: '添加你的姓名',
            nameStepDescription: '请使用真实的名和姓，方便其他成员识别你。',
            recommendationTitle: '你的最佳下一步',
            recommendationDescription: '从这里开始，更快到达你的首个价值动作。',
            recommendedLabel: '推荐',
            exploreInstead: '改为先浏览首页',
            selectPart: '选择角色',
            usernameLabel: '用户名',
            usernamePlaceholder: '设置用户名',
            usernameRequired: '用户名为必填项',
            usernameValidation: '用户名需为 3-30 个字符，仅支持字母、数字和下划线。',
            usernameTaken: '该用户名已被占用。',
            usernameValidationUnavailable: '暂时无法验证用户名。',
            firstNameLabel: '名',
            lastNameLabel: '姓',
            firstNamePlaceholder: '名',
            lastNamePlaceholder: '姓',
            firstNameRequired: '名为必填项。',
            lastNameRequired: '姓为必填项。',
            defaultNameValidation: '请替换默认的 New User 名称。',
            roleOptions: {
                choir_member: {label: '诗班成员', description: '我主要作为诗班成员排练和演出。'},
                vocalist: {label: '独唱歌手 / 艺人', description: '我想要工具来提升个人演出工作流。'},
                choir_director: {label: '诗班指挥/管理员', description: '我希望管理排练、成员和诗班流程。'},
                vocal_coach: {label: '声乐教练 / 教师', description: '我想教授学生并管理课程、班级和作业。'},
                producer: {label: '制作人', description: '我向市场贡献歌曲与 stems。'},
                project_owner: {label: '项目拥有者', description: '我创建项目并邀请他人协作。'},
                collaborator: {label: '协作者', description: '我探索 gigs/项目，并保持专业资料以获取机会。'},
                exploring: {label: '先看看', description: '我想先走最快的引导路径，之后再细化。'},
            },
            intentOptions: {
                practice_part: {label: '练习我的声部', description: '使用 stems 和聚焦播放快速锁定你的声部。'},
                join_manage_choir: {label: '加入或管理诗班', description: '在同一处管理成员、声部和诗班活动。'},
                prepare_rehearsals: {label: '准备排练', description: '用歌单、日程和歌曲管理让排练更高效。'},
                discover_songs_stems: {label: '发现歌曲与 stems', description: '浏览歌曲、艺术家和排练相关音乐资源。'},
                improve_vocal_skills: {label: '提升我的歌唱能力', description: '通过结构化练习建立稳定进步。'},
                teach_students: {label: '教授学生', description: '组织课程、布置练习并跟踪学生进度。'},
                explore_community_challenges: {label: '探索社区与挑战', description: '参与贡献、reels 与挑战互动。'},
                work_on_projects: {label: '参与项目', description: '发现协作机会并管理项目工作流。'},
                just_explore: {label: '随便看看', description: '我想先逛一逛，看看最适合我的内容。'},
                contribute_stems: {label: '贡献歌曲与 stems', description: '上传可用于市场的内容并维护你的目录。'},
                recruit_collaborators: {label: '招募协作者', description: '为进行中的机会邀请合适的贡献者。'},
            },
            recommendations: {
                director_first_choir: {title: '创建你的第一个诗班', description: '先创建诗班空间，再在其中建立排练流程。', ctaLabel: '创建诗班'},
                coach_first_workspace: {title: '创建你的教学空间', description: '先建立独立教学空间，再添加课程和学生班级。', ctaLabel: '开始教学'},
                producer_upload_song: {title: '上传你的第一首歌', description: '上传功能仅对已白名单账户开放。请前往账号上传页面开始。', ctaLabel: '打开上传'},
                project_owner_first_project: {title: '创建你的第一个项目', description: '先创建项目，再邀请协作者开展实际工作。', ctaLabel: '创建项目'},
                collaborator_discover_projects: {title: '探索进行中的项目', description: '发现与你资料匹配的 gigs 与协作机会。', ctaLabel: '打开项目'},
                projects_first_step: {title: '开始你的第一个项目流程', description: '打开项目模块，快速发现活跃协作机会。', ctaLabel: '打开项目'},
                community_first_step: {title: '探索社区挑战', description: '先参与一个挑战，快速体验 VocalCentric 的价值。', ctaLabel: '打开挑战'},
                practice_general: {title: '先听你的独立声部', description: '从你选择的声部开始，获得更精准的练习引导。', ctaLabel: '播放我的声部'},
                explore_first_practice: {title: '开始探索 VocalCentric', description: '浏览核心模块并完成一个动作，找到最适合你的路径。', ctaLabel: '立即探索'},
            },
        },
        upgrade: {
            takeYourChoralExperience: '让你的合唱体验',
            toNextLevel: '更上一层楼',
            premiumDescription: '升级到高级版可解锁一系列专属功能，帮助你全面提升声乐训练和带领能力。',
            advancedRehearsalTools: '高级排练工具：',
            advancedRehearsalDescription: '通过高级功能掌控排练流程，例如可自定义热身、分声部轨道（女高、女低、男高、男低）以及可变速度控制，攻克难点段落。',
            directorsToolkit: '指挥工具包：',
            directorsToolkitDescription: '借助专属功能成为更强的合唱带领者，包括乐谱标注、向成员分享演出笔记，以及用于追踪个人和团队进度的高级分析。',
            seats: '席位：',
            seatsDescription: '为诗班成员增加或减少席位。',
            notDirector: '你不是该诗班的指挥，因此无法升级。',
            choirBillingAdminTitle: '联系你的诗班管理员',
            contactChoirAdmin: '此诗班订阅需要处理。使用此功能前，请联系诗班管理员或账单成员更新诗班套餐或付款。',
            upgrade: '升级',
            toast: {
                planNotFound: '未找到套餐',
            },
        },
        upload: {
            clickToUploadDocument: '点击上传文档',
            supportedFormats: 'Pdf、txt、ppt、docx（最大 20MB）',
            upload: '上传',
            cancel: '取消',
        },
        setRehearsalSongKey: {
            title: '设置歌曲调号',
            description: '为这首歌曲选择默认调号。你可以使用自动移调功能按需调整各声部。',
            note: '注意：这不会更改歌曲原始调号，只会设置本次排练的默认调号。',
            songKey: '歌曲调号',
            placeholder: '为本次排练选择歌曲调号',
            setKey: '设置调号',
            toast: {
                selectSongKey: '请选择歌曲调号',
            },
        },
        addCustomSection: {
            title: '添加自定义段落',
            description: '输入要添加的段落名称，例如 Intro、Bridge 或 Tag。',
            sectionName: '段落名称',
            placeholder: '例如：Bridge',
            addSection: '添加段落',
        },
        addCustomPart: {
            title: '添加自定义声部',
            description: '选择要添加到此段落的和声声部。',
            partName: '声部名称',
            placeholder: '选择默认声部',
            addPart: '添加声部',
        },
        duplicateMidiPart: {
            title: '复制 MIDI 轨道',
            description: '选择该 MIDI 复制后要成为的声部。复制完成后你仍可在 MIDI 编辑器中继续修改。',
            targetPart: '目标声部',
            selectPart: '选择声部',
            destinationInterval: '目标音程',
            duplicate: '复制',
            intervals: {
                '0': '同旋律',
                '4': '上方三度',
                '-4': '下方三度',
                '7': '上方五度',
                '-7': '下方五度',
            },
        },
        addSongToSetlist: {
            title: '添加歌曲到歌单',
            description: '选择或创建歌单以包含这首歌曲。',
            createNewSetlist: '+ 创建新歌单',
            songSource: '歌曲来源',
            backToExisting: '← 返回已有歌单',
            source: {
                search: '搜索',
                manualYoutube: '手动（YouTube）',
                publicDomain: '公共领域',
            },
            selectLabelPlaceholder: '为这首歌曲选择标签...',
            setlistNamePlaceholder: '新歌单名称',
            searchSongsPlaceholder: '搜索歌曲...',
            noSongs: '暂无歌曲',
            songCount: '{{count}} 首歌曲',
            createAndAdd: '创建并添加',
            addToSetlists: '添加到歌单',
            toast: {
                setlistUpdatedSuccessfully: '歌单更新成功',
                noChangesMade: '未做任何更改',
                failedToUpdateSetlists: '更新歌单失败',
                selectLabelForSong: '请为这首歌曲选择标签',
                completeRequiredFields: '请完成必填项',
                newSetlistCreatedAndSongAdded: '新歌单已创建并添加歌曲',
                failedToCreateSetlist: '创建歌单失败',
            },
        },
    },
    components: {
        autoCompleteSearch: {
            fromSpotify: '来自 Spotify',
            fromLibrary: '来自曲库',
            nothingFound: '未找到结果。',
        },
        manualSongInput: {
            unlabeled: '未标注',
            youtubeLink: 'YouTube 链接',
            songTitle: '歌曲标题',
            artistName: '艺术家名称',
            invalidYoutubeLink: '无效的 YouTube 链接。',
            youtubeThumbnailAlt: 'YouTube 缩略图',
            selectLabelForSong: '为歌曲选择标签',
        },
        publicSongInput: {
            unlabeled: '未标注',
            songTitle: '歌曲标题',
            composerOrSource: '作曲者或来源',
            selectLabelForSong: '为歌曲选择标签',
        },
        searchInput: {
            searchAlt: '搜索',
            clearAlt: '清除搜索',
            defaultPlaceholder: '搜索歌曲、艺术家、乐谱、专辑',
        },
        songSearchInput: {
            searchForSongs: '搜索歌曲...',
            selectedSong: '已选择：{{title}} – {{artist}}',
        },
        songArt: {
            userAlt: '用户',
        },
        passwordInput: {
            updatePassword: '更新密码',
        },
        planCard: {
            currentPlan: '当前套餐',
            payment: '支付',
            nextBillPrefix: '你的下一次账单为 ',
            on: ' 于 ',
            perMonth: '每月',
            processing: '处理中...',
            active: '当前使用',
            upgrade: '升级',
            downgrade: '降级',
        },
        floatingSupport: {
            openSupportMenuAria: '打开支持菜单',
            support: '支持',
            needHelp: '需要帮助吗？',
            weAreHereForYou: '我们随时为你提供帮助。',
            closeSupportMenuAria: '关闭支持菜单',
            contactSupport: '联系支持',
            sendUsAMessageFromTheApp: '在应用内给我们留言',
            emailUs: '发送邮件给我们',
            accountDeletion: '账户删除',
            googleAccountDeletionSteps: 'Google 账户删除步骤',
            tipPrefix: '提示：按',
            escKey: 'Esc',
            tipSuffix: '关闭。',
        },
        switchInput: {
            useSetting: '使用此设置',
        },
        mobileSidebar: {
            search: '搜索',
        },
        customPopover: {
            menuAlt: '菜单',
            select: '选择',
            searchPlaceholder: '搜索...',
            nothingFound: '未找到结果',
        },
        partSelectDropdown: {
            selectPart: '选择声部',
            fromLibrary: '来自资料库',
            noPartsFound: '未找到声部。',
        },
        keySelectDropdown: {
            selectSongKey: '选择歌曲调号',
            fromLibrary: '来自资料库',
            noKeysFound: '未找到调号。',
        },
        creditCard: {
            cardNumberLabel: '卡号',
            cardNumberPlaceholder: '输入你的卡号',
            cardTypeIconAlt: '{{name}} 图标',
            cvvLabel: 'CVV',
            cvvPlaceholder: 'CVV',
            expiryDateLabel: '到期日期',
            expiryDatePlaceholder: 'MM/YY',
        },
        practiseCards: {
            allSectionsSubmitted: '所有分段均已提交，做得很好！',
            progress: '进度：已提交 {{submittedCount}} / {{totalSections}} 个分段',
            nothingHereYet: '这里还没有内容',
        },
        upgrade: {
            previewOnlyMessage: '你目前只能预览原始音轨。升级到高级套餐可查看全部音轨。',
            upgradeToSeeAllTracks: '升级以查看全部音轨',
        },
        toast: {
            musicAlt: '音乐',
        },
        choirCard: {
            leaveChoir: '离开诗班',
            choirAlt: '诗班',
            choirAvatarAlt: '诗班头像',
            members: '{{count}} 位成员',
            noMembers: '暂无成员',
            created: '创建于：',
            toast: {
                choirDeleted: '诗班删除成功',
            },
        },
        audioPlayer: {
            vocalPlaying: '人声播放中',
            expandToFullView: '展开为全屏视图',
            fullscreenAlt: '全屏',
            playbackSpeed: '速度+',
            speed: {
                slow: '慢速',
                normal: '正常',
                faster: '更快',
                fastest: '最快',
            },
        },
        audioController: {
            repeatAlt: '重复',
            pauseAlt: '暂停',
            playAlt: '播放',
            micAlt: '麦克风',
            speakerAlt: '扬声器',
            initialTime: '00:00',
        },
        multiTrackWaveform: {
            mute: '静音',
            solo: '独奏',
            pause: '暂停',
            play: '播放',
            sync: '同步',
        },
        header: {
            userAvatarAlt: '用户头像',
            premium: '高级版',
            moduleHelp: {
                openHelpAria: '打开 {{module}} 的帮助视频',
                firstVisit: '第一次使用 {{module}}？查看引导',
                watchGuide: '需要帮助？查看引导',
                watchGuideShort: '帮助',
                videoTitle: '{{module}} 使用引导',
                primaryAction: '前往 {{module}}',
                openInNewTab: '在新标签页打开',
                close: '关闭',
                unavailable: '该模块帮助视频尚未配置。请配置模块视频 URL 后启用。',
                guidance: {
                    community_challenges: '打开一个挑战，查看说明，然后在准备好时提交或分享。',
                    community_reels: '浏览 Reels 了解社区动态，有内容可分享时再创建或互动。',
                    community_contributions: '浏览社区贡献，打开一个内容进行聆听、评论或参与。',
                    community_requests: '查看开放请求，并贡献与你技能匹配的声部或 stem。',
                    choirs_overview: '先创建诗班，再依次完成排练、歌单、排期、成员与集成模块。',
                    choir_rehearsals: '完成排练设置后，进入歌单模块整理每次服事的曲目流程。',
                    choir_setlists: '歌单准备完成后，请更新排期以对齐排练与服事安排。',
                    choir_schedule: '排期已就绪，下一步请分配成员与声部职责。',
                    choir_members: '成员配置完成后，进入集成模块准备外部流程同步。',
                    choir_integrations: '完成集成后，返回排练模块进入日常循环。',
                    choir_rehearsal_runthrough: '本次走台结束后，请进入评审环节查看提交并反馈。',
                    projects_discover: '先创建项目，统一管理角色、预算与协作流程。',
                    projects_create: '项目已创建，前往“我的项目”继续推进。',
                    projects_mine: '在“我的项目”中处理邀请与申请，加快组队。',
                    projects_invites: '先处理邀请，再查看申请并筛选合适协作者。',
                    projects_applications: '处理完申请后，进入项目详情继续执行。',
                    project_overview: '先查看项目总览，再进入申请列表评估候选人。',
                    project_applications: '在这里筛选成员，下一步前往成员管理。',
                    project_members: '成员确认后，继续到预算模块。',
                    project_budget: '预算设置完成后，继续到协议模块。',
                    project_agreements: '跟进协议状态后，前往邀请模块补齐角色。',
                    project_invites: '完成剩余邀请后，返回总览监控项目进度。',
                    uploads: '填写歌曲信息并上传至少一个可用 stem，然后提交到商城或社区流程。',
                },
                whatToDoNext: {
                    title: '下一步操作',
                    steps: {
                        choirs_overview: '诗班总览',
                        choir_rehearsals: '排练',
                        choir_setlists: '歌单',
                        choir_schedule: '排期',
                        choir_members: '成员',
                        choir_integrations: '集成',
                        choir_rehearsal_runthrough: '走台',
                        choir_rehearsal_review: '提交评审',
                    },
                    copy: {
                        choirs_overview: '先创建诗班，再进入排练开始每周流程。',
                        choir_rehearsals: '先设定排练目标与曲目重点，然后继续到歌单模块。',
                        choir_setlists: '确定每次排练或服事的曲目后，再安排排期。',
                        choir_schedule: '确认日期与时间段后，再分配成员与声部。',
                        choir_members: '完成成员与职责分配后，继续配置集成。',
                        choir_integrations: '完成外部集成后，返回排练进入下一轮循环。',
                        choir_rehearsal_runthrough: '结束本次走台后，继续到评审页面进行反馈和确认。',
                    },
                    cta: {
                        choirs_overview: '前往创建诗班',
                        choir_rehearsals: '前往歌单',
                        choir_setlists: '前往排期',
                        choir_schedule: '前往成员',
                        choir_members: '前往集成',
                        choir_integrations: '前往排练',
                        choir_rehearsal_runthrough: '前往评审',
                    },
                },
            },
            quickStart: {
                label: '快速开始',
                eyebrow: '引导采用',
                title: '你的下一步产品价值',
                progress: '已完成 {{completed}} / {{total}}',
                primaryBadge: '推荐下一步',
                cta: '打开步骤',
                header: {
                    early: {
                        badge: '开始阶段',
                        title: '{{role}}设置指南',
                        description: '先完成基础设置，VocalCentric 才能围绕你组织正确的工作流。',
                    },
                    mid: {
                        badge: '进行中',
                        title: '{{role}}采用指南',
                        description: '基础已经到位。先完成下一步推荐动作，再逐步扩展到更多模块。',
                    },
                    mature: {
                        badge: '设置已完成',
                        title: '{{role}}成长指南',
                        description: '核心设置已经完成。接下来用这些步骤加深你在 VocalCentric 中的使用深度。',
                    },
                },
                phaseLabels: {
                    early: '初始阶段',
                    mid: '扩展中',
                    mature: '已建立',
                },
                groups: {
                    completeSetup: '完成设置',
                    recommendedNext: '推荐下一步',
                    exploreMore: '继续探索',
                    completed: '已完成',
                },
                roles: {
                    choirDirector: '诗班指挥',
                    choirMember: '诗班成员',
                    vocalist: '歌手',
                    producer: '制作人',
                    projectOwner: '项目负责人',
                    collaborator: '协作者',
                    explorer: '探索者',
                },
                categories: {
                    profile: '资料',
                    practice: '练习',
                    choirs: '合唱团',
                    projects: '项目',
                    community: '社区',
                    uploads: '上传',
                },
                items: {
                    chooseRole: {
                        title: '选择你如何使用 VocalCentric',
                        description: '先设置你的角色，系统才能优先展示正确的工作流。',
                    },
                    choosePart: {
                        title: '设置你的主要声部或乐器',
                        description: '默认声部会影响练习、stem 和合唱引导体验。',
                    },
                    confirmUsername: {
                        title: '确认你的用户名',
                        description: '在开始跨模块协作前，让别人能够找到你的资料。',
                    },
                    hearPart: {
                        title: '单独听你的声部',
                        description: '打开曲库并切换到你的 stem，让第一次聆听就有价值。',
                    },
                    submitPractice: {
                        title: '提交第一次练习',
                        description: '完成一次真实练习流程，让进度变成实际使用。',
                    },
                    tryGames: {
                        title: '试玩快速游戏',
                        description: '进入短小的听音、音准和乐理游戏。',
                    },
                    joinChoir: {
                        title: '加入一个合唱团',
                        description: '浏览可加入的合唱团并发出一次加入申请。',
                    },
                    createChoir: {
                        title: '创建你的第一个合唱团',
                        description: '先建立合唱团空间，再管理排练、成员和歌单。',
                    },
                    createRehearsal: {
                        title: '创建一次排练',
                        description: '从合唱团设置进入真实可执行的排练流程。',
                    },
                    createSetlist: {
                        title: '创建一个歌单',
                        description: '先整理歌曲，再安排更完整的排练或服事计划。',
                    },
                    inviteMember: {
                        title: '邀请第一位成员',
                        description: '先带一个人进来，让协作真正开始。',
                    },
                    uploadFirstSong: {
                        title: '上传第一首歌曲或 stem',
                        description: '进入上传流程，为市场内容管线提交素材。',
                    },
                    createProject: {
                        title: '创建第一个项目',
                        description: '先建立项目，为角色、交付和协作提供清晰空间。',
                    },
                    applyToProject: {
                        title: '申请一个项目',
                        description: '浏览正在进行的机会并提交一次匹配的申请。',
                    },
                    inviteProjectCollaborator: {
                        title: '邀请一位协作者',
                        description: '先补齐一个项目角色，让工作从设置进入执行。',
                    },
                    joinChallenge: {
                        title: '参与一个社区挑战',
                        description: '完成一次社区动作，让产品价值超出你的主路径。',
                    },
                },
            },
        },
        breadcrumb: {
            home: '首页',
            community: '社区',
            marketplace: '商城',
            choirs: '诗班',
            teaching: '学校',
            projects: '项目',
            rehearsals: '排练',
            accountInformation: '账户信息',
            vocalContributions: '声乐贡献',
            uploads: '上传',
            requestSongs: '点歌请求',
            requestRole: '申请角色',
            notifications: '通知',
            transactionHistory: '交易记录',
            search: '搜索',
        },
        routeItems: {
            songLibrary: '歌曲库',
            community: '社区',
            marketplace: '商城',
            rehearsals: '排练',
            exercises: '练习',
            choirs: '诗班',
            projects: '项目',
            requestSongs: '点歌请求',
            personal: '个人',
            vocalContributions: '声乐贡献',
            setlists: '歌单',
            settings: '设置',
            accountInformation: '账户信息',
            requestRole: '申请角色',
            transactionHistory: '交易记录',
            notifications: '通知',
        },
        memberTableItem: {
            userAlt: '用户',
            menu: {
                makeModerator: '设为管理员',
                markWorshipLeadCandidate: '设为自动领唱',
                removeWorshipLeadCandidate: '移除自动领唱',
                removeMember: '移除成员',
            },
            confirmation: {
                grantModeratorPrivileges: '该成员将可以创建和调整排练日程，并管理成员的加入与移除。是否继续并授予管理员权限？',
                markWorshipLeadCandidate: '是否将该成员设为自动生成领唱分配的候选人？',
                removeWorshipLeadCandidate: '是否将该成员从自动生成领唱分配中移除？',
                approveRequest: '你要批准此请求吗？',
                rejectRequest: '你要拒绝此请求吗？',
            },
            toast: {
                songAddedToRehearsals: '歌曲已添加到排练',
                memberMadeModeratorSuccessfully: '成员已成功设为管理员',
                userSuspendedSuccessfully: '用户已成功停用',
                userBlockedSuccessfully: '用户已成功拉黑',
                userRemovedSuccessfully: '用户已成功移除',
                memberMarkedWorshipLeadSuccessfully: '成员已设为自动领唱候选人',
                memberRemovedWorshipLeadSuccessfully: '成员已从自动领唱候选人中移除',
                memberLeadCandidateUpdateFailed: '更新自动领唱候选人失败',
                requestApprovedSuccessfully: '请求已成功批准',
                requestRejectedSuccessfully: '请求已成功拒绝',
                upgradeSeatsToApproveRequest: '可用席位不足。请升级席位后再批准该请求。',
            },
        },
        memberTable: {
            name: '姓名',
            email: '邮箱',
            part: '声部',
            dateJoined: '加入日期',
        },
        communityCard: {
            upvoteFailed: '点赞失败',
            songTitle: '歌曲标题',
            expandToFullView: '展开到全屏视图',
            fullscreenAlt: '全屏',
            songArtAlt: '歌曲封面',
            missingPartAlt: '缺少声部',
            partNeeded: '需要声部',
            topContributors: '主要贡献者',
            contributorFallback: '贡献者',
            contributorAvatarAlt: '贡献者头像',
            seeAllContributions: '查看全部贡献',
        },
        communityCards: {
            loadFailed: '加载社区贡献失败',
            errorGeneric: '获取社区贡献时发生错误。',
            searchBySongTitle: '按歌曲标题搜索',
            all: '全部',
            errorAlt: '错误',
            emptyAlt: '暂无贡献',
            emptyDescription: '未找到符合搜索条件的社区贡献。',
            emptyPrompt: '想从社区获取帮助吗？',
            requestContribution: '请求贡献',
            loadMore: '加载更多',
        },
        requestCards: {
            loadFailed: '加载请求失败',
            searchBySongTitle: '按歌曲标题搜索',
            all: '全部',
            emptyAlt: '暂无贡献',
            emptyDescription: '未找到符合搜索条件的社区贡献。',
            emptyPrompt: '想从社区获取帮助吗？',
            requestContribution: '请求贡献',
            loadMore: '加载更多',
        },
    },
    account: {
        currencyUpdated: '首选货币已更新。',
        languageUpdated: '首选语言已更新。',
        unableToUpdateCurrency: '无法更新首选货币。',
        unableToUpdateLanguage: '无法更新首选语言。',
    },
    accountInfo: {
        breadcrumbBase: '账户信息',
        actions: {
            editProfile: '编辑资料',
            updateCard: '更新银行卡',
        },
        sections: {
            subscription: '订阅',
            payments: '支付',
            marketplace: '商城',
            community: '社区',
            privacy: '隐私',
            help: '帮助',
        },
        links: {
            availablePlans: '可用套餐',
            managePlans: '管理套餐',
            orderHistory: '订单历史',
            savedPaymentCard: '已保存的支付卡',
            myPurchases: '我的购买',
            myOrders: '我的订单',
            uploadSong: '上传歌曲',
            myListings: '我的上架',
            earnings: '收益',
            myChallenges: '我的挑战',
            notifications: '通知',
            support: 'VocalCentric 支持',
        },
        languages: {
            en: '英语',
            es: '西班牙语',
            fr: '法语',
            zh: '中文',
        },
        activePlan: {
            title: '当前套餐',
            yourPlan: '你的套餐',
            freePlan: '免费套餐',
            referralCopied: '推荐链接已复制到剪贴板',
            nextBill: '你的下一次账单为 {{price}}，日期 {{date}}',
            currentlyFree: '你当前使用免费套餐，',
            upgradeToPremium: '升级到高级版',
        },
        editProfile: {
            updated: '资料更新成功',
            selectDefaultPart: '选择默认声部',
            enterCountry: '输入国家',
            country: '国家',
            update: '更新',
        },
        payment: {
            title: '已保存的支付卡',
            subtitle: '管理一次性购买的支付信息。若要管理月度订阅支付，请前往账户总览。',
        },
        changePassword: {
            title: '修改密码',
            step1Subtitle: '要设置新的 VocalCentric 密码，请先重新输入旧密码。',
            enterOldPassword: '输入旧密码',
            step2Subtitle: '请输入发送到你邮箱的验证码。',
            step3Subtitle: '请设置你偏好的新密码',
            success: '恭喜，你已成功修改密码。',
        },
        challenges: {
            subtitle: '管理你的挑战历史，并完成现金奖励挑战的资金步骤。',
            create: '创建挑战',
            empty: '你还没有创建任何挑战。',
            explore: '探索社区',
            entries: '参赛',
            interests: '感兴趣',
            created: '创建于',
            fundingRequired: '需要资金',
            view: '查看',
            funding: '筹资中...',
            fundNow: '立即资助',
            updating: '更新中...',
            moveToUpcoming: '移至即将开始',
            filters: {
                all: '全部',
                active: '进行中',
                upcoming: '即将开始',
                closed: '已结束',
                draft: '草稿',
            },
            sort: {
                highestReward: '最高奖励',
                latest: '最新',
                mostEntries: '最多参赛',
            },
            table: {
                title: '标题',
                status: '状态',
                entries: '参赛数',
                reward: '奖励',
                dates: '日期',
                action: '操作',
            },
            status: {
                active: '进行中',
                upcoming: '即将开始',
                closed: '已结束',
                draft: '草稿',
                pendingWinner: '待定获胜者',
            },
            toast: {
                fundingWindowOpened: '资助窗口已打开。请完成支付以将挑战推进到进行中状态。',
                fundingInitialized: '资助初始化成功。',
                alreadyFunded: '该挑战已完成资助，状态已刷新。',
                fundingFailed: '初始化挑战资助失败。',
                movedToUpcoming: '挑战已成功移至即将开始。',
                moveToUpcomingFailed: '将挑战移至即将开始失败。',
            },
        },
    },
    dashboard: {
        new: '最新',
        newDescription: '最新添加的歌曲',
        popular: '热门',
        popularDescription: '最受欢迎的歌曲',
        albums: '专辑',
        albumsDescription: '全部专辑',
        artists: '艺术家',
        artistsDescription: '全部艺术家',
        genres: '流派',
        genresDescription: '全部流派',
        addSongToRehearsalPrompt: '确定要将这首歌添加到排练吗？',
        gettingStarted: {
            label: '入门设置',
            progress: '已完成 {{completed}} / {{total}}',
            primaryCta: '打开建议模块',
            resumeCta: '继续 onboarding',
            nextActions: {
                selectRole: '选择你的角色，以便个性化你的工作区。',
                selectPart: '选择你的声部，以启用更聚焦的练习默认设置。',
                confirmUsername: '确认用户名，方便协作者找到你。',
                takeFirstAction: '完成第一个引导操作以结束 onboarding。',
                completed: '你已全部设置好。',
            },
        },
        songGuide: {
            eyebrow: '歌曲库引导',
            notNow: '稍后再说',
            resume: '继续',
            progress: '第 {{completed}} / {{total}} 步',
            hint: '完成高亮动作以解锁下一步',
            empty: {
                eyebrow: '从这里开始',
                title: '暂时没有可用歌曲',
                body: '当歌曲可用后，我们会在这里引导你完成首次试听与排练动作。',
            },
            steps: {
                open_song: {
                    title: '从列表播放一首歌',
                    body: '点击任意歌曲行以打开播放并开始你的首次试听流程。',
                },
                switch_stem: {
                    title: '切换到独立 stem',
                    body: '在播放器中选择你的声部，让练习从正确的 stem 开始。',
                },
                open_multitrack: {
                    title: '打开多轨全屏视图',
                    body: '进入多轨视图后，可更聚焦每个 stem 并更好地排练。',
                },
                close_multitrack: {
                    title: '关闭多轨全屏视图',
                    body: '退出全屏回到歌曲列表，继续后续引导步骤。',
                },
                add_to_rehearsal: {
                    title: '将歌曲加入排练',
                    body: '先把一首歌加入排练，让该模块连接到你的真实工作流。',
                },
                view_in_rehearsal: {
                    title: '在排练中打开歌曲',
                    body: '进入排练，完成歌曲端到端流程。',
                },
            },
        },
        search: {
            noResultForKeyword: '未找到关键词 {{keyword}} 的结果',
        },
        albumDetail: {
            fetchFailed: '加载专辑失败：',
            breadcrumb: '专辑 > {{title}}',
            breadcrumbLoading: '专辑 > 加载中...',
            notFound: '未找到专辑 ...',
            bannerAlt: '专辑横幅',
            albumLabel: '专辑',
            byLabel: '作者：',
            releasedYearLabel: '发行年份：',
            songNumberLabel: '歌曲数量：',
            albumDurationLabel: '专辑时长：',
        },
        artistDetail: {
            breadcrumbNamed: '艺术家 > {{name}}',
            breadcrumbLoading: '艺术家 > 加载中...',
            empty: '未找到艺术家 ...',
            label: '艺术家',
            bioLabel: '简介：',
            tags: {
                popular: {
                    title: '热门',
                    description: '最受欢迎的歌曲',
                },
                albums: {
                    title: '专辑',
                    description: '全部专辑',
                },
            },
        },
        cards: {
            songArtworkAlt: '{{title}} 封面',
            albumArtAlt: '专辑封面',
            albumLabel: '专辑',
            artistLabel: '艺术家',
        },
        songTable: {
            title: '标题',
            album: '专辑',
            genre: '流派',
            votes: '票数',
            duration: '时长',
            action: '操作',
            single: '单曲',
            viewInRehearsal: '在排练中查看',
            addToRehearsal: '添加到排练',
            addToSetlist: '添加到歌单',
            viewCommunityReels: '查看社区 Reels',
            likeOrVote: '点赞或投票',
            toast: {
                songAddedToRehearsals: '歌曲已添加到排练',
                songAlreadyInRehearsals: '歌曲已在排练列表中',
            },
        },
        topHits: {
            song: '歌曲',
            votes: '票数',
            duration: '时长',
            actions: '操作',
            rehearsed: '已排练',
            addToRehearsal: '添加到排练',
            iconAlt: '图标',
        },
        topResult: {
            title: '最佳结果',
            artist: '艺术家',
            albumWithTitle: '专辑 · {{title}}',
            songWithTitle: '歌曲 · {{title}}',
            choirWithBio: '诗班 · {{bio}}',
            choirFallback: '诗班',
        },
        searchGroup: {
            artists: '艺术家',
            albums: '专辑',
            contributionRequests: '贡献请求',
            communityContributions: '社区贡献',
            choirs: '诗班',
        },
    },
    projects: {
        breadcrumbBase: '项目',
        discover: '发现',
        discoverDescription: '浏览开放项目',
        myProjects: '我的项目',
        myProjectsDescription: '你拥有的项目',
        myInvites: '我的邀请',
        myInvitesDescription: '你被邀请的角色',
        myApplications: '我的申请',
        myApplicationsDescription: '你已申请的角色',
        headerSubtitle: '组建临时团队，发现进行中的机会，并在需要时将已接受的协作者转入工作区。',
        createProject: '创建项目',
        discoverInner: '发现',
        searchPlaceholder: '搜索项目、艺术家、演出、制作',
        allModes: '全部模式',
        remote: '远程',
        physical: '线下',
        hybrid: '混合',
        compensation: '报酬',
        paid: '付费',
        unpaid: '不付费',
        allRoles: '全部角色',
        allCountries: '全部国家',
        noOpenProjects: '没有符合筛选条件的开放项目。',
        myProjectsEmpty: '你还没有创建任何项目。',
        roleFallback: '角色',
        detailsUnavailable: '项目详情不可用',
        locationLabel: '地点：',
        unavailable: '不可用',
        components: {
            projectCard: {
                positionsRequested: '已请求 {{count}} 个岗位',
                requirementsOnDetailView: '项目需求可在详情页查看',
                more: '更多',
                projectAlt: '项目',
                paidOpportunity: '付费机会',
                unpaidCollaboration: '无偿协作',
                projectOwnerAvatarAlt: '项目所有者头像',
                byOwner: '由 {{owner}} 发布',
                needsLabel: '需求：',
                openSlots: '{{count}} 个开放名额',
            },
            userProfileHover: {
                userFollowed: '已关注该用户。',
                userUnfollowed: '已取消关注该用户。',
                unableToFollowUser: '无法关注该用户。',
                unableToUnfollowUser: '无法取消关注该用户。',
                vocalcentricMember: 'VocalCentric 成员',
                followersCount: '粉丝：{{count}}',
                followingCount: '关注中：{{count}}',
                viewProfile: '查看资料',
                follow: '关注',
                unfollow: '取消关注',
            },
            applicantProfileCard: {
                applicant: '申请者',
                unknownApplicant: '未知申请者',
                noPublicProfileSnapshotAttached: '未附加公开个人资料快照。',
                noHeadlineProvided: '未提供标题。',
                featuredWork: '精选作品',
                shortlistApplication: '加入候选名单',
                acceptApplication: '接受申请',
                rejectApplication: '拒绝申请',
                viewFullProfile: '查看完整资料',
            },
        },
        table: {
            project: '项目',
            role: '角色',
            status: '状态',
            actions: '操作',
        },
        actions: {
            viewProject: '查看项目',
            viewApplication: '查看申请',
        },
        invites: {
            empty: '当前没有等待你的邀请制项目角色。',
            fallbackProjectTitle: '项目邀请',
            invitedBy: '邀请人',
            invitedByLabel: '邀请人：',
            invitationStatus: '邀请状态',
            projectStatus: '项目状态',
            visibility: '可见性',
            sent: '发送时间',
        },
        applications: {
            empty: '你还没有申请任何项目角色。',
            fallbackProjectTitle: '项目申请',
            ownedBy: '拥有者',
            ownerLabel: '所有者：',
            applicationStatus: '申请状态',
            projectStatus: '项目状态',
            visibility: '可见性',
            submitted: '提交时间',
            message: '消息',
            noNote: '未附加备注。',
        },
        createForm: {
            createProject: '创建项目',
            editProject: '编辑项目',
            updateProject: '更新项目',
            saveProject: '保存项目',
            create: '创建',
            update: '更新',
            projectNotFound: '未找到项目。',
            ownerOnlyEdit: '只有项目所有者可以编辑该项目。',
            projectBrief: '项目简介',
            projectBriefDescription: '定义协作的核心信息，以及创作者应如何发现该项目。',
            editDescription: '更新项目简介、可用性设置与协作规则。',
            createDescription: '发布聚焦的协作需求，无需绑定到诗班结构。',
            projectTitle: '项目标题',
            projectTitlePlaceholder: '主日现场乐队、录音室和声招募、复活节制作演员招募',
            projectDescription: '项目描述',
            projectDescriptionPlaceholder: '描述演出需求、风格、排练预期以及申请者需要了解的信息。',
            projectType: '项目类型',
            selectProjectType: '选择项目类型',
            location: '地点',
            locationPlaceholder: '拉各斯、阿布贾、远程、伦敦',
            country: '国家',
            countryPlaceholder: '尼日利亚、美国、英国',
            compensationDetails: '报酬细节',
            selectCompensationDetails: '选择报酬细节',
            projectSettings: '项目设置',
            projectSettingsDescription: '设置创作者如何接触该项目，以及你期望的投入方式。',
            visibility: '可见性',
            visibilityDescription: '控制该项目是否公开。',
            public: '公开',
            private: '私密',
            engagementMode: '参与方式',
            engagementModeDescription: '选择协作者参与项目的方式。',
            remote: '远程',
            physical: '线下',
            hybrid: '混合',
            compensation: '报酬',
            compensationDescription: '设置该机会是否付费。',
            paid: '付费',
            unpaid: '不付费',
            projectBudget: '项目预算',
            projectBudgetDescription: '为付费角色设置总体预算上限，以便跟踪角色承诺金额。',
            totalBudget: '总预算',
            applicationAccess: '申请访问',
            applicationAccessDescription: '选择整个项目是开放申请还是仅邀请回复。',
            open: '开放',
            inviteOnly: '仅邀请',
            projectStatus: '项目状态',
            projectStatusDescription: '控制项目以草稿开始、开放申请或进入审核阶段。',
            rolesNeeded: '所需角色',
            rolesNeededDescription: '添加你需要的岗位，并设置每个角色的申请方式。',
            roleN: '角色 {{index}}',
            done: '完成',
            remove: '移除',
            pluralSuffix: '个',
            openApplication: '开放申请',
            edit: '编辑',
            roleType: '角色类型',
            selectRole: '选择角色',
            quantity: '数量',
            category: '类别',
            chooseRoleTypeHint: '请选择角色类型以自动确定类别',
            openApplicationDescription: '决定该角色对所有人可见，还是仅对受邀创作者可见。',
            roleBudget: '角色预算',
            roleBudgetDescription: '设置该角色的{{type}}预算。',
            payment: '付款',
            revenueSharePercentage: '收益分成比例',
            minimumBudget: '最低预算',
            budget: '预算',
            maximumBudget: '最高预算',
            roleNotes: '角色备注',
            roleNotesPlaceholder: '试音要求、风格要求、设备说明、可用时间要求等。',
            addRole: '添加角色',
            toast: {
                projectUpdated: '项目更新成功',
                projectCreated: '项目创建成功',
                saveFailed: '无法{{action}}项目',
            },
        },
        projectDetail: {
            ownerOnlyBudget: '只有项目所有者可以管理预算设置。',
            ownerOnlyApplications: '只有项目所有者可以在这里审核申请。',
            ownerOnlyInvites: '只有项目所有者可以在这里管理邀请。',
            common: {
                collaborator: '协作者',
                compensation: '报酬',
                updated: '更新',
                view: '查看',
                submitted: '提交时间',
                reviewed: '审核时间',
                message: '消息',
                noMessage: '未附加消息。',
                portfolio: '作品集',
                openPortfolio: '打开作品集',
                auditionMedia: '试音媒体',
                openAuditionMedia: '打开试音媒体',
                socialMedia: '社交媒体',
                openProfile: '打开资料',
                auditionPreview: '试音预览',
                reviewNotes: '审核备注',
            },
            budget: {
                breadcrumbTitle: '预算',
                onlyPaid: '预算管理仅适用于付费项目。',
                enterValidAmount: '请输入有效的非负预算金额。',
                updated: '项目预算已更新。',
                updateFailed: '无法更新项目预算',
                settingsTitle: '预算设置',
                settingsSubtitle: '设置项目预算并监控角色承诺，再新增付费角色。',
                projectBudget: '项目预算',
                enterTotalBudget: '输入总预算',
                currency: '货币',
                saveBudget: '保存预算',
                snapshotTitle: '预算概览',
                notSet: '未设置',
                committed: '已承诺',
                remaining: '剩余',
                overrun: '承诺金额超出预算 {{amount}}。',
            },
            agreements: {
                breadcrumbTitle: '协议',
                title: '协议',
                ownerSubtitle: '通过一次结账为所有符合条件的协议完成资金流程。',
                viewerSubtitle: '查看你在该项目中的报酬和付款进度。',
                noEligibleFunding: '没有可资助的协议。',
                mixedCurrencies: '可资助协议币种不一致，无法一次结账处理。',
                fundingInitialized: '项目资助已初始化。',
                fundingInitFailed: '无法初始化项目资助',
                onlyPaid: '该项目未配置付费补偿协议。',
                fundEligible: '资助可用协议',
                openMembers: '打开成员',
                confirmWithSummary: '这将为 {{summary}} 初始化一次结账。是否继续？',
                confirmDefault: '这将为所有可用协议初始化一次结账。是否继续？',
                continue: '继续',
                noneAssigned: '你当前尚未分配任何补偿协议。',
                addPayoutPrompt: '请添加收款账户，以便该协议处理后接收项目转账。',
                setupPayout: '设置收款账户',
                withdrawalLabel: '提现：',
                withdrawalRequested: '已申请',
                withdrawalPending: '待申请',
                payoutSetupRequired: '需要先设置收款账户',
                },
            agreementDetail: {
                breadcrumbTitle: '协议详情',
                agreementTitle: '协议 #{{id}}',
                detailsLoadFailed: '无法加载协议详情。',
                payee: '收款方',
                compensation: '补偿方式',
                escrow: '托管',
                payout: '打款',
                financialActivity: '资金活动',
                noFinancialEvents: '暂无资金事件记录。',
                payoutSnapshot: '打款快照',
                gross: '总额',
                platformFee: '平台费用',
                netPayout: '净打款',
                na: '不适用',
                fundAgreement: '为协议注资',
                requestRelease: '申请放款',
                refund: '退款',
                ownerActionsRestricted: '当前仅限项目所有者操作。打款流程需依次完成所有者放款申请、你的提现申请以及管理员处理。',
                payoutSetupRequired: '管理员处理转账前需要先完成收款账户设置。',
                withdrawalRequestedOn: '已于 {{date}} 提交提现申请。',
                requestWithdrawal: '申请提现',
                confirmReleaseTitle: '确认申请放款',
                confirmReleaseDescription: '该操作会将打款提交给管理员确认并处理。资金不会立即支付给协作者。',
                confirmRefundTitle: '退回托管资金',
                confirmRefundDescription: '托管中的资金将被标记为已退款，且该协议会被取消。',
                toast: {
                    notEligibleForFunding: '该协议当前不符合注资条件。',
                    fundingInitialized: '注资流程已初始化。',
                    initializeFundingFailed: '无法初始化注资流程',
                    releaseRequested: '已提交放款申请。打款前需要管理员确认。',
                    requestReleaseFailed: '无法提交放款申请',
                    escrowRefundProcessed: '托管退款已处理。',
                    processRefundFailed: '无法处理退款',
                    withdrawalRequested: '提现申请已提交。管理员现在可以处理你的打款。',
                    requestWithdrawalFailed: '无法提交提现申请',
                },
            },
            compensationPanel: {
                compensation: '补偿方式',
                notCreated: '未创建',
                noAgreement: '无协议',
                agreement: '协议',
                escrow: '托管',
                payout: '打款',
                pendingAgreement: '待创建协议',
                percentageRevenueShare: '{{percentage}}% 收入分成',
                pendingAmount: '待定金额',
                createAgreement: '创建协议',
                viewAgreement: '查看协议',
                flowHint: {
                    noAgreement: '该协作者尚未创建协议。',
                    completed: '协议已完成，打款已处理。',
                    payoutFailed: '打款失败，需要管理员重试。',
                    releaseRequested: '已申请放款，等待管理员处理打款。',
                    escrowSyncing: '款项已到账，托管记录同步中。',
                    escrowHeld: '资金已托管，可发起放款申请。',
                    cancelledRefunded: '协议已取消，托管资金已退款。',
                    awaitingFunding: '等待注资后该协议将进入托管流程。',
                },
            },
            header: {
                defaultShareTitle: 'VocalCentric 项目',
                defaultShareText: '来看看 VocalCentric 上的这个项目。',
                projectLinkCopied: '项目链接已复制。',
                unableToShareProjectLink: '无法分享项目链接。',
                projectArtAlt: '项目封面',
                global: '全球',
                positionsRequested: '共需 {{count}} 个席位',
                shareProject: '分享项目',
                editProject: '编辑项目',
                tags: {
                    roles: {title: '角色', description: '角色要求'},
                    applications: {title: '申请', description: '项目申请'},
                    members: {title: '成员', description: '已接受协作者'},
                    budget: {title: '预算', description: '项目预算'},
                    invites: {title: '邀请', description: '管理项目邀请'},
                    agreements: {title: '协议', description: '补偿跟踪'},
                },
            },
            members: {
                breadcrumbTitle: '成员',
                title: '成员',
                subtitle: '查看当前在该项目中活跃的已接受协作者。',
                unpaidCollaboration: '无偿协作',
                pendingAmount: '待定金额',
                compensationAgreementCreated: '补偿协议已创建。',
                createAgreementFailed: '无法创建协议',
                empty: '该项目暂无已接受且活跃的协作者。',
                assignedCollaborator: '已分配协作者',
                joined: '加入时间',
                agreement: '协议',
                manage: '管理',
                createAgreement: '创建协议',
                noAgreementAssigned: '未分配协议',
                noAgreement: '无协议',
            },
            applications: {
                breadcrumbTitle: '申请',
                title: '申请',
                subtitle: '审核收到的申请，并聚焦你当前需要处理的阶段。',
                paidHint: '已接受协作者可在成员页面发起资助。',
                statusUpdated: '申请状态已更新为 {{status}}。',
                updateFailed: '无法更新申请',
                loadDetailsFailed: '无法加载申请详情',
                empty: '该项目暂无申请。',
                noMatchFilter: '没有与筛选条件匹配的 {{status}} 申请。',
                noNote: '未附加备注。',
                shortlist: '加入候选',
                accept: '接受申请',
                reject: '拒绝申请',
                viewDetails: '查看申请详情',
                applicant: '申请人',
                applicantProfile: '申请人资料',
                closeModalAria: '关闭申请弹窗',
                filters: {
                    all: '全部申请',
                    pending: '待处理',
                    shortlisted: '已候选',
                    accepted: '已接受',
                    rejected: '已拒绝',
                    withdrawn: '已撤回',
                },
            },
            applicationDetail: {
                breadcrumbTitle: '申请详情',
                notFound: '未找到项目申请。',
                snapshotTitle: '申请快照',
                backToApplications: '返回申请列表',
            },
            overview: {
                breadcrumbTitle: '概览',
                collaborationRolesLabel: '协作角色',
                applyToCollaborate: '申请协作',
                applyToCollaborateSubtitle: '选择匹配你技能的角色并提交申请。',
                ownerManagementLabel: '所有者管理',
                roleManagement: '角色管理',
                roleManagementSubtitle: '为该项目创建和管理协作角色。',
                addRole: '添加角色',
                inviteOnly: '仅邀请',
                inviteOnlyHint: '该角色仅接受项目所有者直接邀请的申请。',
                openSlots: '{{count}} 个空缺',
                overrunDriver: '超预算主因',
                inviteParticipants: '邀请参与者',
                editRole: '编辑角色',
                deleteRole: '删除角色',
                selected: '已选择',
                apply: '申请',
                projectSnapshot: '项目快照',
                owner: '所有者',
                visibility: '可见性',
                applicationAccess: '申请访问',
                projectType: '项目类型',
                currentOverrun: '当前超预算：{{amount}}',
                workspaceBridge: '工作区桥接',
                workspaceBridgeSubtitle: '将该项目关联到合唱团工作区并同步已接受成员。',
                syncFundedRequirementPrefix: '仅当所有付费协议都标记为',
                funded: '已资助',
                syncFundedRequirementSuffix: '后，才可同步成员。',
                useExistingChoir: '使用现有合唱团',
                createChoirFromProject: '从项目创建合唱团',
                useProjectTitleAsChoirName: '使用项目标题作为合唱团名称',
                choirName: '合唱团名称',
                enterChoirName: '输入合唱团名称',
                createAndLinkChoir: '创建并关联合唱团',
                choirWorkspace: '合唱团工作区',
                selectDirectedChoir: '选择你管理的合唱团',
                linkChoir: '关联合唱团',
                membersToSync: '待同步成员',
                noActiveMembers: '当前没有可同步的活跃成员。',
                contributor: '贡献者',
                selectAll: '全选',
                clear: '清空',
                syncSeatsHint: '可用席位：{{available}} • 已选成员：{{selected}}',
                syncSeatsExceededHint: '已选成员超过可用席位（已选 {{selected}}，可用 {{available}}）。请减少选择或升级席位。',
                syncSelectedMembers: '同步所选成员',
                linkedChoirWorkspace: '已关联合唱团工作区：{{choir}}',
                syncedMembers: '已同步成员：{{count}}',
                linkedNoSyncedYet: '关联成功。尚未同步任何成员。',
                noExtraNotesYet: '暂无额外说明。',
                viewerState: {
                    label: '访客状态',
                    memberTitle: '你已在该项目中',
                    memberBody: '你当前是该项目中的活跃协作者。',
                    applicationSubmittedTitle: '申请已提交',
                    applicationSubmittedBody: '你的申请正在审核中，所有者会尽快更新你。',
                    inviteAccessTitle: '已获得邀请访问',
                    inviteAccessBody: '你可以查看并申请可邀请访问的项目角色。',
                    inviteAccessPrivateBody: '你可通过邀请访问该私有项目。',
                    limitedAccessTitle: '访问受限',
                    limitedAccessBody: '该项目为私有。你需要邀请才能申请角色。',
                },
                unavailable: {
                    alreadyMember: '你已被分配到该项目。',
                    alreadyApplied: '你已提交过该项目申请。',
                    inviteRequired: '该角色仅邀请可用。请联系所有者获取邀请链接。',
                    notAccepting: '该项目当前状态为 {{status}}，暂不接受申请。',
                    roleUnavailable: '该角色当前不可申请。',
                },
                toast: {
                    invalidReelLink: '加载前请输入有效的 reel 链接。',
                    reelNoPlayableMedia: '该 reel 没有可播放的媒体清单。',
                    resolveReelFailed: '暂时无法加载 reel 媒体。',
                    chooseRoleBeforeApply: '提交申请前请先选择角色。',
                    applicationSent: '申请发送成功。',
                    submitApplicationFailed: '无法提交你的申请。',
                    selectChoirToLink: '请选择要关联的合唱团。',
                    choirLinked: '合唱团已关联到项目工作区。',
                    linkChoirFailed: '无法关联合唱团工作区。',
                    enterChoirName: '创建前请输入合唱团名称。',
                    resolveCreatedChoirFailed: '无法解析新创建的合唱团。',
                    choirCreatedAndLinked: '合唱团创建并关联成功。',
                    createAndLinkFailed: '无法创建并关联合唱团工作区。',
                    linkBeforeSync: '同步成员前请先关联合唱团工作区。',
                    selectMembersToSync: '请至少选择一名成员进行同步。',
                    notEnoughSeatsForSelection: '已选成员超过合唱团可用席位。请减少选择或升级席位。',
                    membersSynced: '成员同步成功。',
                    membersSyncedCount: '成功同步 {{count}} 名成员。',
                    syncChoirFailed: '无法将项目成员同步到合唱团工作区。',
                    chooseRoleBeforeAdd: '保存前请先选择角色类型。',
                    roleAdded: '角色添加成功。',
                    roleUpdated: '角色更新成功。',
                    addRoleFailed: '无法保存角色。',
                    roleDeleted: '角色删除成功。',
                    deleteRoleFailed: '无法删除角色。',
                    enterInviteEmail: '请输入有效的受邀邮箱地址。',
                },
                applyModal: {
                    title: '申请 {{role}}',
                    description: '补充有助于所有者快速决策的背景信息。',
                    openCount: '{{count}} 个空缺',
                    messageLabel: '留言',
                    messagePlaceholder: '请介绍你自己、可用时间，以及你为何适合该角色。',
                    portfolioLabel: '作品集链接',
                    portfolioPlaceholder: 'Spotify、YouTube、网站、EPK',
                    auditionMediaSource: '试音媒体来源',
                    auditionSource: {
                        external: '外部 URL',
                        upload: 'VocalCentric 上传',
                        reel: 'VocalCentric Reel 链接',
                    },
                    auditionLinkLabel: '试音链接',
                    auditionLinkPlaceholder: 'Drive、YouTube、Dropbox',
                    uploadReady: '上传已就绪。所有者可在申请审核中直接预览该媒体。',
                    uploadHint: '上传试音片段。VC 将提供 HLS/DASH 播放清单。',
                    reelUrlLabel: 'Reel 链接',
                    reelUrlPlaceholder: 'https://.../reel/<reel-id>',
                    loadReel: '加载 Reel',
                    loading: '加载中...',
                    reelLinked: 'Reel 关联成功。所有者可直接在线预览该媒体。',
                    socialMediaLabel: '社媒链接',
                    socialMediaPlaceholder: 'Instagram、TikTok、X、Facebook',
                    submitApplication: '提交申请',
                    submitting: '提交中...',
                    applicationsUnavailable: '当前不可申请',
                    close: '关闭',
                },
                addRoleModal: {
                    addTitle: '添加角色',
                    editTitle: '编辑角色',
                    addDescription: '在此添加新角色。邀请触达在专用的“邀请”标签页中管理。',
                    editDescription: '在此更新该角色。邀请触达在专用的“邀请”标签页中管理。',
                    roleType: '角色类型',
                    selectRole: '选择角色',
                    quantity: '数量',
                    applicationAccess: '申请访问',
                    accessOpen: '开放',
                    accessInviteOnly: '仅邀请',
                    category: '分类',
                    chooseRoleTypeToDeriveCategory: '选择角色类型以推导分类',
                    roleBudget: '角色预算',
                    payment: '付款',
                    setBudgetForRole: '为该角色设置 {{paymentType}} 预算。',
                    revenueSharePercentage: '分成比例',
                    revenueSharePlaceholder: '15',
                    fixedBudget: '固定预算',
                    budgetRange: '预算区间',
                    budget: '预算',
                    minimumBudget: '最低预算',
                    maximumBudget: '最高预算',
                    projectedOverrunWarning: '警告：预计承诺超出预算 {{amount}}。',
                    projectedCommitmentAfterSave: '保存后预计承诺：{{projected}} / {{budget}}。',
                    roleNotes: '角色说明',
                    roleNotesPlaceholder: '试音期望、风格要求、设备说明、可用时间要求。',
                    saveChanges: '保存更改',
                    saveRole: '保存角色',
                },
                inviteModal: {
                    title: '邀请加入 {{role}}',
                    description: '为该仅邀请角色发送直接邮箱邀请。',
                    openCount: '{{count}} 个空缺',
                    inviteeEmail: '受邀邮箱',
                    inviteeEmailPlaceholder: '你@示例.com',
                },
                deleteModal: {
                    title: '删除角色',
                    description: '从该项目中移除 {{role}}。仅当该角色没有已占用名额时可执行。',
                    deleteRole: '删除角色',
                },
            },
            invites: {
                breadcrumbTitle: '邀请',
                title: '邀请',
                subtitle: '跟踪待处理角色邀请，并在一个地方管理邀请流程。',
                revoked: '邀请已撤销。',
                resent: '邀请已重发。',
                updateFailed: '无法更新邀请',
                chooseRoleAndEmail: '请选择角色并输入邮箱地址。',
                addRoleFirst: '请先将该角色添加到项目，再邀请协作者。',
                sent: '邀请发送成功。',
                sendFailed: '无法发送邀请',
                sendInvite: '发送邀请',
                sendNewTitle: '发送新邀请',
                sendNewDescription: '选择角色并通过邮箱发送直接邀请。',
                chooseRole: '选择角色',
                emailPlaceholder: '创建者@示例.com',
                noMatchFilters: '当前筛选下没有匹配的邀请。',
                empty: '该项目尚未发送任何角色邀请。',
                resend: '重发邀请',
                revoke: '撤销邀请',
                invitee: '被邀请人',
                filters: {
                    all: '全部邀请',
                    pending: '待处理',
                    applied: '已申请',
                    revoked: '已撤销',
                },
            },
        },
    },
    choir: {
        belongTo: '我加入的',
        belongToDescription: '你所属的合唱团',
        canJoin: '可加入合唱团',
        canJoinDescription: '你可以加入的合唱团',
        managedByYou: '你管理的',
        managedByYouDescription: '你正在管理的合唱团',
        headerSubtitle: '查看你所属和你管理的合唱团',
        createChoir: '创建合唱团',
        emptyStart: '还在等什么？你可以自己发起并主导全场！',
        createAChoir: '创建合唱团',
        becomeDirector: '成为指挥',
        emptySeenAll: '你已经走了很远，基本都看过了',
        join: '加入',
        noJoinedChoirYet: '你还没有加入任何合唱团',
        joinAChoir: '加入合唱团',
        requestToJoin: '申请加入合唱团',
        publicPage: {
            feedTab: '动态',
            setlistsTab: '歌单',
            resourcesTab: '资源',
            joinTab: '加入',
            feedTitle: '公开动态',
            setlistsTitle: '公开歌单',
            resourcesTitle: '公开资源',
            joinTitle: '加入这个合唱团',
            joinSubtitle: '创建账号或登录后申请访问。',
            noPublicPosts: '暂无公开动态。',
            noPublicSetlists: '暂无公开歌单。',
            noPublicResources: '暂无公开资源。',
            signUpToJoin: '注册并申请访问',
            signInToJoin: '已有账号？登录',
            joinClosed: '此合唱团目前不接受加入申请。',
            resourceFrom: '来自 {{name}}',
            publicProfileLoadFailed: '无法加载此合唱团页面。',
            feedLoadFailed: '无法加载公开动态。',
            setlistsLoadFailed: '无法加载公开歌单。',
            postTopic: '发布主题',
            postTopicPlaceholder: '分享该合唱团的话题',
            postTopicFailed: '发布主题失败，请重试。',
            newUpdates: '{{count}} 条新动态',
            follow: '关注',
            following: '已关注',
            followersCount: '{{count}} 位关注者',
            followed: '已关注合唱团。',
            unfollowed: '已取消关注合唱团。',
            followFailed: '无法更新合唱团关注状态。',
        },
        claimPage: {
            eyebrow: '合唱团目录',
            title: '认领此合唱团',
            description: '将 {{name}} 连接到您管理的内部合唱团。VocalCentric 管理员会在任何变更前审核您的证明。',
            unavailable: '此公开合唱团不可用或已不能认领。',
            signInTitle: '登录后认领此合唱团',
            signInDescription: '选择您管理的内部合唱团，并提供您代表此合唱团的证明。',
            signIn: '登录',
            signUp: '创建账户',
            noChoirs: '请先创建内部合唱团，然后返回此处提交认领。',
            createChoir: '创建合唱团',
            choirLabel: '您的内部合唱团',
            proofUrlLabel: '证明网址（可选）',
            proofNoteLabel: '证明说明（可选）',
            proofHint: '请提供网址或说明。认领将由人工审核。',
            submit: '提交认领审核',
            submitting: '正在提交认领...',
            submitFailed: '无法提交此认领。',
            submittedTitle: '认领已提交',
            submittedDescription: '您的认领正在审核中。获批后目录页面会跳转至您的内部合唱团。',
        },
        planBadge: {
            premium: 'Premium',
            free: '免费',
        },
        paywall: {
            upgradeRequiredTitle: '需要升级合唱团',
            upgradeRequiredBody: '升级此合唱团后可继续。',
            rehearsalLimitReached: '免费合唱团最多可创建 {{limit}} 次排练。升级此合唱团后可添加更多。',
            setlistLimitReached: '免费合唱团最多可创建 {{limit}} 个歌单。升级此合唱团后可添加更多。',
            memberLimitReached: '免费合唱团最多可拥有 {{limit}} 名成员。升级此合唱团后可添加更多成员。',
            privateSetlistsRequireUpgrade: '免费合唱团的歌单默认为公开。升级此合唱团后可将歌单设为私密。',
            profileVisibilityRequiresUpgrade: '免费合唱团资料必须在加入合唱团页面保持公开。升级此合唱团后可隐藏资料。',
            rehearsalResourcesExpired: '免费合唱团排练资源可使用 {{days}} 天。升级此合唱团后可继续使用歌词、自定义和声、幻灯片和练习工具。',
            harmonyVisibilityRequiresUpgrade: '免费合唱团的自定义和声默认为公开。升级此合唱团后可使用私密或仅限合唱团的和声。',
            rehearsalLimitTitle: '已达到排练上限（{{current}}/{{limit}}）',
            setlistLimitTitle: '已达到歌单上限（{{current}}/{{limit}}）',
            memberLimitTitle: '已达到成员上限（{{current}}/{{limit}}）',
            privateSetlistsTitle: '私密歌单需要升级',
            rehearsalResourcesExpiredTitle: '资源访问已过期',
            profileVisibilityTitle: '资料可见性已锁定',
            harmonyVisibilityTitle: '和声可见性已锁定',
        },
        guide: {
            eyebrow: '合唱团引导',
            resume: '继续引导',
            notNow: '暂不',
            progress: '第 {{completed}} / {{total}} 步',
            join: {
                title: '加入一个合唱团',
                body: '选择一个合唱团并提交申请，开始参与其中。',
            },
            create: {
                title: '创建合唱团',
                body: '先创建一个合唱团，然后开启排练，开始每周流程。',
            },
        },
        rehearsalGuide: {
            eyebrow: '排练引导',
            resume: '继续引导',
            notNow: '暂不',
            progress: '第 {{completed}} / {{total}} 步',
            create: {
                title: '创建你的第一次排练',
                body: '先开启一次排练，让你的合唱团从基础设置进入真正的协作流程。',
            },
        },
        setlistsGuide: {
            eyebrow: '歌单引导',
            resume: '继续引导',
            notNow: '暂不',
            progress: '第 {{completed}} / {{total}} 步',
            create: {
                title: '创建你的第一个歌单',
                body: '先创建一个合唱团歌单，把歌曲整理好，再继续安排更完整的排期。',
            },
            rehearsal: {
                title: '从歌单创建一次排练',
                body: '把这个歌单转成一次真实排练，让歌曲真正进入合唱团的工作流程。',
            },
        },
        scheduleGuide: {
            eyebrow: '排班引导',
            resume: '继续引导',
            notNow: '暂不',
            progress: '第 {{completed}} / {{total}} 步',
            serviceDays: {
                title: '先设置聚会日期',
                body: '先添加聚会日期，VocalCentric 才能为你的合唱团生成可用的排班。',
            },
            create: {
                title: '创建你的第一个排班',
                body: '先创建排班，让成员看到分配安排和即将到来的服事。',
            },
        },
        membersGuide: {
            eyebrow: '成员引导',
            resume: '继续引导',
            notNow: '暂不',
            progress: '第 {{completed}} / {{total}} 步',
            invite: {
                title: '邀请你的第一位成员',
                body: '先邀请一位成员，让合唱团从基础设置进入真正的协作状态。',
            },
        },
        rehearsalSongsGuide: {
            eyebrow: '排练歌曲引导',
            resume: '继续引导',
            notNow: '暂不',
            progress: '第 {{completed}} / {{total}} 步',
            add_song: {
                title: '先把歌曲加入这次排练',
                body: '先把歌曲加入排练，合唱团才能基于真实的歌曲清单开始工作。',
            },
            open: {
                title: '打开一首排练歌曲',
                body: '先打开第一首歌曲，让合唱团从准备阶段进入真正的排练流程。',
            },
        },
        rehearsalRunthroughGuide: {
            eyebrow: '排练流程引导',
            resume: '继续引导',
            notNow: '暂不',
            progress: '第 {{completed}} / {{total}} 步',
            add_lyrics: {
                title: '为这首歌添加歌词',
                body: '先上传或粘贴歌词，让成员可以基于结构化内容进行练习。',
            },
            upload_reference_audio: {
                title: '上传参考音频',
                body: '先添加一份适合合唱团的参考音频，让成员练习时使用正确版本。',
            },
            add_custom_harmony: {
                title: '添加自定义和声',
                body: '先建立合唱和声声部，让成员能够针对真实编排进行练习。',
            },
            review_submission: {
                title: '审核一份成员提交',
                body: '打开一份成员练习提交并给出反馈，让排练闭环真正跑起来。',
            },
            open_practise: {
                title: '打开这首歌的练习页',
                body: '进入练习标签页，开始根据合唱编排录制你的声部。',
            },
            record_practice_section: {
                title: '录制你的第一个段落',
                body: '先录制一个段落，真正开始提交练习，而不是只浏览歌曲内容。',
            },
            submit_practice: {
                title: '提交你的练习',
                body: '提交第一份练习录音，让指挥可以审核并完成这次排练闭环。',
            },
        },
        management: {
            detailHeader: {
                rehearsalsTitle: '排练',
                rehearsalsDescription: '每周六',
                setlistsTitle: '歌单',
                setlistsDescription: '合唱团歌单',
                setlistsExtra: '歌单',
                scheduleTitle: '排班',
                scheduleDescription: '合唱团阶段排班',
                scheduleExtra: '排班',
                membersTitle: '成员',
                membersExtra: '成员',
                feedsTitle: '动态',
                feedsExtra: '动态',
                integrateTitle: '集成',
                integrateDescription: '集成',
            },
            edit: {
                title: '编辑合唱团',
            },
            rehearsals: {
                title: '合唱团排练',
                createRehearsal: '创建排练',
                deleteRehearsal: '删除排练',
                empty: '你还没有为该合唱团创建任何排练',
                noPermission: '你没有创建排练的权限',
                toast: {
                    deleted: '合唱团排练已删除',
                    deleteFailed: '删除合唱团排练失败',
                    choirIdRequired: '需要合唱团 ID',
                },
            },
            createRehearsal: {
                title: '创建排练',
                manualMode: '手动模式',
                fromSetlist: '从歌单导入',
                rehearsalTitle: '排练标题',
                rehearsalTitleOptional: '排练标题（可选）',
                shortDescription: '简短描述',
                shortDescriptionOptional: '简短描述（可选）',
                pasteSetlistLink: '粘贴歌单链接',
                pasteSetlistLinkPlaceholder: '在此粘贴歌单链接',
                usingSetlist: '使用{{kind}}歌单',
                choirSetlistKind: '合唱团',
                personalSetlistKind: '个人',
                addSongsPrompt: '将歌曲添加到排练中。',
                searchSongsPlaceholder: '搜索要添加到排练的歌曲',
                removeSong: '移除',
                songsInSetlist: '歌单中的歌曲',
                notAvailable: '—',
                external: '外部',
                internal: '内部',
                addSelectedSong: '添加歌曲',
                additionalResourcesOptional: '附加资源（可选）',
                additionalResourcesPrompt: '是否还要添加其他资源？',
                uploadResources: '点击从电脑或手机上传学习资源',
                date: '日期',
                from: '从',
                fromOptional: '从（可选）',
                to: '到',
                toOptional: '到（可选）',
                virtual: '线上',
                physical: '线下',
                setReminder: '设置提醒',
                setReminderOptional: '设置提醒（可选）',
                selectReminderTime: '选择提醒时间',
                createButton: '创建排练',
                reminders: {
                    oneHour: '1 小时前',
                    twoHours: '2 小时前',
                    threeHours: '3 小时前',
                    fourHours: '4 小时前',
                    fiveHours: '5 小时前',
                    sixHours: '6 小时前',
                    twelveHours: '12 小时前',
                    twentyFourHours: '24 小时前',
                },
                toast: {
                    fillRequired: '请填写所有必填项',
                    created: '排练创建成功',
                    createFailed: '创建排练失败',
                    choirSetlistNotFound: '未找到合唱团歌单',
                    loadChoirSetlistFailed: '加载合唱团歌单失败',
                    setlistNotFound: '未找到歌单',
                    fetchSetlistFailed: '获取歌单失败',
                },
            },
            setlists: {
                title: '合唱团歌单',
                newChoirSetlist: '新建合唱团歌单',
                empty: '当前还没有合唱团歌单。',
                copyLink: '复制链接',
                createRehearsalFromSetlist: '从该歌单创建排练',
                delete: '删除',
                linked: '已关联',
                sharedBy: '分享者：{{name}}',
                songCount: '{{count}} 首歌曲',
                updatedDate: '更新于：{{date}}',
                searchPlaceholder: '按歌单、歌曲或元数据搜索',
                searchEmpty: '没有匹配的合唱团歌单。',
                searchFailed: '无法搜索合唱团歌单',
                loadFailed: '加载合唱团歌单失败',
                linkCopied: '链接已复制到剪贴板！',
                deleted: '合唱团歌单已删除',
                deleteFailed: '删除歌单失败',
                createModal: {
                    title: '创建合唱团歌单',
                    description: '先填写一个名称，之后你还可以继续添加歌曲并用于排练。',
                    nameLabel: '歌单名称',
                    namePlaceholder: '周日排练歌单',
                    confirm: '创建歌单',
                    creating: '创建中...',
                    toast: {
                        created: '合唱团歌单已创建',
                        createFailed: '创建合唱团歌单失败',
                    },
                },
                manageModal: {
                    title: '管理“{{name}}”',
                    description: '查看这份合唱团歌单中的歌曲，并按需添加或移除歌曲。',
                    viewOnlyDescription: '查看这份合唱团歌单中的歌曲。',
                    viewOnlyNotice: '只有合唱团指挥和版主可以编辑这份歌单。',
                    addSongs: '添加歌曲',
                    shareLink: '歌单链接',
                },
            },
            rehearsalSongs: {
                title: '排练歌曲',
                resourcesTitle: '学习资源',
                resourcesDescription: '本次曲目的乐谱、文档和音频。',
                addResources: '添加资源',
                closeResourceUpload: '完成',
                resourceType: '资源类型',
                documentResource: '文档',
                scoreResource: '乐谱',
                resourceLabel: '资源标签（可选）',
                resourceLabelPlaceholder: '例如：主日热身指南',
                uploadDocuments: '上传乐谱或文档',
                uploadMusicXml: '上传 MusicXML 乐谱',
                musicXmlDescription: '支持 MusicXML、XML 或 MXL',
                uploadMidiOptional: '上传 MIDI（可选）',
                uploadDryRun: '上传音频',
                dryRunAudio: '音频',
                previewResource: '预览资源',
                playResource: '播放音频',
                practiceDryRun: '练习 {{name}}',
                openLyrics: '打开 {{title}} 的歌词',
                openPractice: '打开 {{title}} 的练习',
                openPracticeReview: '打开 {{title}} 的练习审核',
                editDryRun: '编辑 {{name}}',
                dryRunLyrics: '排练音频歌词',
                dryRunLyricsPlaceholder: '添加该排练音频的歌词或排练备注…',
                listenEntireAudio: '收听完整音频',
                listenSegment: '收听指定片段',
                segmentStart: '开始（秒）',
                segmentEnd: '结束（秒）',
                invalidListenSegment: '片段结束时间必须晚于开始时间。',
                deleteResource: '删除 {{name}}',
                deleteResourceConfirm: '从本次排练中删除 {{name}}？',
                playYouTubeReference: '在 YouTube 上播放 {{title}}',
                youtubePlayer: 'YouTube 播放器',
                viewListenAudit: '查看收听记录',
                listenAudit: '收听记录',
                listenAuditSummary: '{{listeners}} 位收听者 • {{listens}} 次收听',
                listenAuditDescription: '查看哪些成员已收听本次排练。',
                loadingListenAudit: '正在加载收听记录…',
                listenAuditLoadFailed: '无法加载收听记录。',
                noListens: '暂无收听记录。',
                nudgeChoir: '提醒合唱团',
                nudgingChoir: '正在发送提醒…',
                nudgeSent: '已向 {{count}} 位合唱团成员发送提醒。',
                nudgeFailed: '无法发送提醒。',
                audioPlaybackUnavailable: '音频目前无法播放。',
                openInNewTab: '在新标签页中打开',
                noResources: '尚未添加学习资源。',
                setlistResource: '歌单资源',
                resourceOpenFailed: '无法打开该排练资源。',
                addSetlists: '添加歌单',
                addSetlistsDescription: '附加一个或多个合唱团歌单中的歌曲和资源。',
                addSelectedSetlists: '添加所选歌单',
                addingSetlists: '正在添加歌单…',
                setlistsLoadFailed: '无法加载合唱团歌单。',
                setlistsAdded: '歌单已添加到排练',
                setlistsAddFailed: '无法添加所选歌单。',
                noSetlistsAvailable: '所有可用歌单都已附加。',
                additionalSongs: '其他歌曲',
                expandSetlist: '展开 {{name}}',
                collapseSetlist: '收起 {{name}}',
                songsInSetlist: '{{count}} 首歌曲',
                noSongsInSetlist: '该歌单中没有歌曲。',
                savingResources: '正在保存资源…',
                resourcesSaved: '排练资源已更新',
                resourcesSaveFailed: '无法更新排练资源',
                addSong: '添加歌曲',
                addToRehearsal: '添加到排练',
                startRehearsal: '开始排练',
                startingRehearsal: '正在开始排练',
                deleteConfirm: '删除该排练歌曲？',
                moveSongUp: '上移歌曲',
                moveSongDown: '下移歌曲',
                songActions: '{{title}} 操作',
                currentSongSettings: '调性：{{key}} • 收听目标：{{target}}',
                noKeySet: '未设置',
                entireSong: '整首歌曲',
                openCustomHarmonies: '自定义和声',
                songSettings: '歌曲设置',
                songSettingsDescription: '设置 {{title}} 的排练详情。',
                songKey: '歌曲调性',
                songLabel: '排练标签',
                songLabelPlaceholder: '例如：重唱或奉献',
                listenTarget: '收听目标',
                youtubeReference: 'YouTube 参考',
                deleteSong: '删除歌曲',
                savingSettings: '正在保存设置…',
                settingsNoChanges: '歌曲设置没有变化。',
                settingsSaved: '歌曲设置已更新。',
                settingsPartiallySaved: '部分歌曲设置无法更新。',
                settingsSaveFailed: '无法更新歌曲设置。',
                toast: {
                    removed: '歌曲已从排练中移除',
                    removeFailed: '移除歌曲失败',
                    choirIdRequired: '需要合唱团 ID',
                    reorderFailed: '排练歌曲重新排序失败',
                },
            },
            members: {
                title: '成员 {{seatCount}} / {{maxSeatCount}}',
                addSeats: '添加席位',
                manageSharedSeats: '共享席位',
                redeemSharedSeats: '兑换席位代码',
                addMember: '添加成员',
                addMembersPage: '添加成员',
                searchPlaceholder: '搜索成员',
                searchEmpty: '没有匹配的成员。',
                actions: '操作',
                tabs: {
                    all: {
                        title: '全部',
                        description: '合唱团现有成员',
                    },
                    invite: {
                        title: '邀请',
                        description: '已邀请加入合唱团的成员',
                    },
                    requests: {
                        title: '申请',
                        description: '加入合唱团的申请',
                    },
                },
                empty: {
                    members: '你的合唱团还没有成员，不如邀请一些人加入吧 🙂',
                    invitations: '当前没有待处理邀请，不如邀请更多人加入吧 🙂',
                    requests: '当前没有待处理申请，不如邀请更多人加入吧 🙂',
                    inviteCta: '邀请新成员',
                },
                invitations: {
                    fetchFailed: '获取邀请失败',
                    deleted: '邀请已删除',
                    deleteFailed: '删除邀请失败',
                    resent: '邀请已重发',
                    resendFailed: '重发邀请失败',
                },
                badges: {
                    awarded: '徽章授予成功',
                    awardButton: '授予徽章',
                    confirmation: '确定要给该用户授予 {{type}} 徽章吗？',
                    typeLabel: '{{type}} 徽章',
                },
            },
            integrations: {
                title: '工具',
                connect: '连接',
                platforms: {
                    whatsapp: {
                        name: 'WhatsApp',
                        description: '热门即时通讯应用，支持消息与群组沟通。',
                        toast: '连接 WhatsApp',
                    },
                    calendar: {
                        name: '日历',
                        description: '连接日历以同步活动与提醒。',
                        toast: '连接日历',
                    },
                    telegram: {
                        name: 'Telegram',
                        description: '支持频道与群组沟通的即时通讯应用。',
                        toast: '连接 Telegram',
                    },
                },
            },
            feeds: {
                loadFailed: '获取合唱团动态失败：',
                emptyTitle: '暂无动态',
                emptyDescription: '大家最近有点安静，快去带动一下吧！',
                startPractising: '开始练习',
                loadMore: '加载更多帖子',
                newUpdates: '{{count}} 条新动态',
                log: {
                    normalizedFeeds: '已标准化动态：',
                },
                comment: {
                    placeholder: '写评论',
                    post: '发布',
                    logPost: '发布评论中',
                },
                composer: {
                    placeholder: '与合唱团分享动态',
                    internal: '仅成员',
                    public: '仅公开',
                    both: '成员和公众',
                    post: '发布动态',
                },
                mentions: {
                    loading: '正在加载可提及的人...',
                    empty: '暂无可提及的人',
                },
                references: {
                    loading: '正在加载引用...',
                    empty: '未找到歌单或排练',
                },
                engagement: {
                    like: '点赞',
                    likeWithCount: '点赞（{{count}}）',
                    comment: '评论',
                    noComments: '暂无评论。',
                    loadingComments: '正在加载评论...',
                    loadingReplies: '正在加载回复...',
                    viewReplies: '查看回复（{{count}}）',
                    viewMoreComments: '查看更多评论',
                    viewMoreReplies: '查看更多回复',
                    hideReplies: '收起回复',
                    reply: '回复',
                    replyPlaceholder: '写回复',
                    posting: '发布中...',
                    signInToEngage: '请登录后点赞或评论。',
                    loadCommentsFailed: '评论加载失败。',
                    postFailed: '评论发布失败。',
                    updateLikeFailed: '点赞更新失败。',
                    deleteFeed: '删除动态',
                    editFeed: '编辑动态',
                    feedActions: '动态操作',
                    report: '举报',
                    editFeedPrompt: '编辑这条动态',
                    editCommentPrompt: '编辑这条评论',
                    reportFeedConfirm: '向合唱团管理员举报这条动态？',
                    reportCommentConfirm: '向合唱团管理员举报这条评论？',
                    reportReasonPrompt: '请选择最符合问题的举报原因。',
                    reportReason: {
                        spam: '垃圾信息',
                        abuse: '辱骂性内容',
                        harassment: '骚扰',
                        other: '其他',
                    },
                    submitReport: '提交举报',
                    submittingReport: '提交中...',
                    reported: '举报已提交。',
                    alreadyReported: '已举报',
                    reportFailed: '无法提交举报。',
                    updated: '已更新。',
                    updateFailed: '无法保存更改。',
                    deleteFeedConfirm: '删除这条动态？',
                    deleteCommentConfirm: '删除这条评论？',
                    deleted: '已删除',
                    deleteFailed: '删除失败。',
                },
                moderation: {
                    openQueue: '审核举报',
                    title: '动态举报',
                    description: '审核该合唱团中被举报的动态和评论。',
                    pending: '待处理',
                    resolved: '已解决',
                    dismissed: '已驳回',
                    empty: '此队列中暂无举报。',
                    feed: '动态',
                    comment: '评论',
                    author: '作者：{{email}}',
                    reporter: '举报人：{{email}}',
                    view: '在动态中查看',
                    remove: '删除内容',
                    resolve: '解决',
                    dismiss: '驳回',
                    removeConfirm: '删除此内容并解决针对它的所有举报？',
                    removed: '内容已删除，举报已解决。',
                    updated: '举报已更新。',
                    loadFailed: '无法加载动态举报。',
                    updateFailed: '无法更新举报。',
                    removeFailed: '无法删除被举报的内容。',
                    previous: '上一页',
                    next: '下一页',
                },
                card: {
                    welcome: '👋 欢迎来到 Refinery 合唱团！',
                    practiceSubmitted: '🎤 {{name}} 刚提交了《{{song}}》的练习',
                    practiceApproved: '✅ {{name}} 的《{{song}}》练习已通过审核',
                    practiceNeedsImprovement: '❗ {{name}} 的《{{song}}》练习需要改进',
                    rehearsalActivity: '📝 {{name}} 创建了《{{song}}》的排练',
                    defaultUpdate: '{{name}} 发布了一条动态',
                    unknownTypeLog: '未知动态类型：{{type}}',
                    pinned: '置顶',
                },
            },
            schedule: {
                title: '合唱团排班',
                document: '文档',
                manageServiceTypes: '管理服事类型',
                manageServiceTypesAria: '创建并管理服事类型',
                setServiceDays: '设置服事日期',
                createSchedule: '创建排班',
                reshuffleAssignments: '重新分配排班',
                reshuffleUnavailable: '尚未创建排班，无法重新分配',
                shareSchedule: '分享排班',
                shareUnavailable: '尚未创建排班，无法分享',
                deleteSchedule: '删除排班',
                deleteUnavailable: '尚未创建排班，无法删除',
                noServiceDays: '尚未定义服事日期。',
                noScheduleYet: '尚未创建排班',
                getStarted: '先为该合唱团添加第一个排班吧。',
                addSinger: '添加歌手',
                replaceSinger: '替换歌手',
                chooseReplacementFor: '为以下位置选择替换者：',
                chooseSingerFor: '为以下位置选择歌手：',
                leadSection: '主唱分组',
                deleteService: '删除服事',
                deleteServiceDescription: '从当前排班中删除 {{service}}？仅删除该次排班实例，不会删除服事类型本身。',
                thisService: '该服事',
                deleting: '删除中...',
                removeSingerPrompt: '将 {{singer}} 从 {{part}} 中移除？',
                reshufflePrompt: '使用当前已有服事并按每个声部 {{count}} 名歌手重新分配所有当前排班？',
                deleteSchedulePrompt: '删除当前合唱团排班？这将移除该排班下所有周次、服事、领唱与 BGV 分配。',
                toast: {
                    downloadPdfFailed: '下载排班 PDF 失败，请重试。',
                    publicLinkReady: '公开排班链接已生成',
                    publicLinkFailed: '生成公开排班链接失败',
                    scheduleDeleted: '排班已删除',
                    deleteScheduleFailed: '删除排班失败',
                    reshuffled: '排班已重新分配',
                    reshuffleFailed: '重新分配排班失败',
                    serviceTypeUpdated: '服事类型已更新',
                    serviceTypeUpdateFailed: '更新服事类型失败',
                    serviceDeleted: '服事已删除',
                    serviceDeleteFailed: '删除服事失败',
                    serviceAdded: '服事已添加',
                    serviceAddFailed: '添加服事失败',
                    scheduleUpdated: '排班已更新',
                    assignmentUpdateFailed: '更新分配失败',
                    singerRemoved: '歌手已移除',
                    singerRemoveFailed: '移除歌手失败',
                },
                components: {
                    lead: '主唱',
                    noLeadAssigned: '尚未分配主唱。',
                    assignLead: '分配主唱',
                    assignLeadComingSoon: '分配主唱（即将支持）',
                    noSingerAssigned: '尚未分配歌手。',
                    addVoiceSectionSinger: '添加{{section}}',
                    addVoiceSectionSingerComingSoon: '添加{{section}}（即将支持）',
                    replaceSinger: '替换歌手',
                    replaceSingerComingSoon: '替换歌手（即将支持）',
                    removeSinger: '移除歌手',
                    removeSingerComingSoon: '移除歌手（即将支持）',
                    unassignedSinger: '未分配歌手',
                    assigned: '已分配',
                    open: '空缺',
                    total: '总计',
                    sopranoShort: 'S',
                    altoShort: 'A',
                    tenorShort: 'T',
                    bassShort: 'B',
                    changeServiceTypeTooltip: '更改该服事的类型',
                    deleteScheduledServiceTooltip: '删除该已排期服事',
                    addServiceToWeek: '为本周添加服事',
                },
                modals: {
                    serviceType: '服事类型',
                    onlyChoirServiceTypes: '此处仅可选择该合唱团创建的服事类型。',
                    noChoirServiceTypes: '暂无该合唱团专属服事类型。',
                    customName: '自定义名称',
                    customNamePlaceholder: '例如：特别即兴服事',
                    customNameHint: '选择已有服事类型，或输入一次性自定义名称。',
                    serviceDateTime: '服事日期与时间',
                    selectExistingServiceType: '选择现有服事类型',
                    saveChanges: '保存更改',
                    saving: '保存中...',
                    adding: '添加中...',
                    addService: {
                        title: '添加服事',
                        description: '为本周添加一场服事。',
                        descriptionWithWeek: '为 {{week}}（{{start}} – {{end}}）添加一场服事。',
                        action: '添加服事',
                    },
                    updateServiceType: {
                        title: '更改服事类型',
                        description: '更新该已排期服事的类型。',
                    },
                    recurrence: {
                        weekly: '每周 {{day}}',
                        biweekly: '每两周的 {{day}}',
                        monthlyNthWeekday: '每月第 {{ordinal}} 个{{day}}',
                        monthlyDayOfMonth: '每月 {{day}} 日',
                        annual: '每年 {{month}}{{day}} 日',
                        oneTime: '于 {{date}} 一次性',
                        none: '未设置重复',
                    },
                    noEligibleSingers: '该声部暂无可分配歌手。',
                    saveSinger: '保存歌手',
                },
            },
        },
    },
    community: {
        breadcrumbBase: '社区',
        challenges: '挑战',
        challengesDescription: '创建、发现并参与挑战活动。',
        vocalPerformances: '声乐表演',
        vocalPerformancesDescription: '来自不同艺术家的声乐表演合集。',
        reels: '短视频',
        reelsDescription: '展示声乐表演的短视频合集。',
        welcomeTitle: '欢迎来到社区',
        welcomeSubtitle: '在不同颜色中找到你的偏好',
        searchChallenges: '搜索挑战',
        noChallengesFound: '未找到挑战。',
        challengeTitleLabel: '挑战标题',
        entriesLabel: '参赛数量',
        rewardLabel: '挑战奖励',
        challengeLinkCopied: '挑战链接已复制到剪贴板',
        unableToShareChallenge: '暂时无法分享挑战',
        challengeLeaderboard: {
            breadcrumb: '挑战排行榜',
            breadcrumbNamed: '{{title}} > 排行榜',
            title: '排行榜',
            subtitle: '参赛作品按评委加权得分排序，点赞数作为同分时的加权因素。',
            empty: '暂无排行榜数据。',
            entryAlt: '参赛作品',
            anonymous: '匿名',
            noCaption: '无文案',
            scoreLabel: '得分：',
            votesLikes: '{{votes}} 票 · {{likes}} 赞',
        },
        challengeEditor: {
            createTitle: '创建挑战',
            editTitle: '编辑挑战',
            createSubtitle: '为社区设置一个新的挑战。',
            editSubtitle: '更新挑战元数据和时间安排。',
            ownerOnly: '只有挑战创建者可以编辑此挑战。',
            form: {
                titleLabel: '标题',
                titlePlaceholder: '挑战标题',
                rewardTypeLabel: '奖励类型',
                rewardTypeCash: '现金',
                rewardTypePrize: '奖品',
                startDateLabel: '开始时间',
                endDateLabel: '结束时间',
                rewardAmountLabel: '奖励金额',
                rewardAmountCashPlaceholder: '100',
                rewardAmountPrizePlaceholder: '0',
                rewardCurrencyLabel: '奖励币种',
                entryTypeLabel: '报名类型',
                entryTypeOpen: '公开',
                entryTypeInviteOnly: '仅限邀请',
                participationTypeLabel: '参与类型',
                participationTypeIndividual: '个人',
                participationTypeChoir: '合唱团',
                maxParticipantsLabel: '最多参与者',
                maxParticipantsPlaceholder: '不限',
                minXpLabel: '最低 XP',
                maxXpLabel: '最高 XP',
                xpPlaceholder: '可选',
                descriptionLabel: '描述',
                descriptionPlaceholder: '描述这个挑战',
                rewardDescriptionLabel: '奖励说明',
                rewardDescriptionPlaceholder: '可选奖励细节',
                rulesLabel: '规则与指南',
                rulesPlaceholder: '挑战规则',
            },
            uploads: {
                promoVideoLabel: '上传宣传视频',
                promoVideoHint: '必填。可从该视频自动生成缩略图。',
                thumbnailLabel: '上传挑战缩略图',
                thumbnailHint: '可选。如不提供，将使用宣传视频生成的缩略图。',
                thumbnailPreview: '缩略图预览',
                thumbnailAlt: '挑战缩略图',
            },
            actions: {
                saving: '保存中...',
                updateChallenge: '更新挑战',
                createChallenge: '创建挑战',
            },
            toasts: {
                updated: '挑战更新成功。',
                created: '挑战创建成功。',
                saveFailed: '保存挑战失败。',
            },
        },
        challengeComments: {
            title: '社区评论',
            empty: '暂无社区评论。',
            you: '你',
            avatarAlt: '头像',
            reply: '回复',
            loading: '加载中...',
            hideReplies: '收起回复',
            viewReplies: '查看回复{{suffix}}',
            replyPlaceholder: '写一条回复...',
            commentPlaceholder: '添加评论...',
            send: '发送',
        },
        challengeReviewsModal: {
            title: '评审与评论',
            communityMember: '社区成员',
            avatarAlt: '头像',
            moderatorReviewBadge: '评委评审',
            noPreviewVideo: '无预览视频',
            moderatorReviews: '评委评审',
            hide: '收起',
            show: '展开',
            emptyModeratorReviews: '暂无评委评审',
            voteAndReview: '评委打分与评语（评审反馈）',
            scoreLabel: '分数 {{score}}%',
            reviewInputPlaceholder: '填写评委评语...',
            vote: '投票',
            voted: '已投票',
            voting: '投票中...',
        },
        reelsComments: {
            title: '评论',
            empty: '这里还没有评论',
            avatarAlt: '头像',
            loading: '加载中...',
            hideReplies: '收起回复',
            viewReplies: '查看回复（{{count}}）',
            reply: '回复',
            replyingTo: '正在回复 @{{username}}...',
            commentPlaceholder: '添加评论...',
            send: '发送',
            follow: '关注',
            following: '已关注',
            profileFutureFeatures: '关注、查看资料（后续功能）',
            fetchMoreFailed: '加载更多评论失败：',
            fetchFailed: '加载评论失败：',
            likeUpdateFailed: '更新点赞状态失败：',
            fetchRepliesFailed: '加载回复失败：',
            replyPostFailed: '发布回复失败：',
            commentPostFailed: '发布评论失败：',
        },
        challengeDetails: {
            title: '挑战详情',
            notFound: '未找到挑战。',
            reward: '奖励',
            entries: '参赛数',
            duration: '时长',
            challengeTitle: '挑战 - {{title}}',
            startsIn: '挑战将在以下时间后开始：',
            upcomingDescription: '该挑战将在 {{days}} 天后开始。在此期间，邀请你的朋友一起参与吧。',
            upcomingAlt: '即将开始的挑战',
            mascotAlt: '挑战吉祥物',
            noCaption: '无文案',
            noDescription: '未提供描述。',
            noEntriesYet: '暂无参赛作品。',
            noRulesSpecified: '挑战创建者尚未提供规则。',
            noReferenceVideo: '未提供参考视频。',
            noReviewComment: '无评审评论',
            noReviewsAvailable: '暂无评审。',
            noModeratorsAssigned: '尚未分配评委。',
            noDisqualifiedEntries: '暂无被取消资格的参赛作品。',
            noModerationLogs: '暂无审核日志。',
            noReasonProvided: '未提供原因',
            noDetails: '无详情',
            unknown: '未知',
            notResolved: '未解析',
            prize: '奖项',
            challengeMeta: '挑战信息',
            creator: '创建者：{{creator}}',
            entriesCount: '参赛数：{{count}}',
            moderatorsCount: '评委数：{{count}}',
            moderatorWeight: '评委权重：{{weight}}%',
            moderatorWeightRow: '{{email}} · 权重 {{weight}}%',
            resolvedEmail: '已解析邮箱：{{email}}',
            challengeWindow: '挑战时间窗：{{start}} - {{end}}',
            informationTitle: '挑战信息',
            referenceVideo: '参考视频',
            openReferenceMedia: '打开参考媒体',
            engagementRules: '参与规则',
            shareYourChallenge: '分享你的挑战',
            shareToGetEntries: '分享挑战以开始收集参赛作品。',
            submitEntryTitle: '提交参赛作品',
            submitEntrySubtitle: '上传你的挑战演唱并提交到排行榜。',
            uploadEntryVideo: '上传挑战参赛视频',
            captionOptional: '文案（可选）',
            captionPlaceholder: '告诉大家你的参赛内容',
            moderators: '评委',
            moderator: '评委',
            moderatorReviews: '评委评审',
            moderatorReviewComment: '评委评语',
            entryReviews: '参赛评审',
            voteScore: '投票分数：{{score}}%',
            optionalReviewComment: '可选评审评论',
            makeReviewPublic: '公开该评审',
            disqualifiedEntries: '取消资格的参赛作品',
            moderationActivity: '审核动态',
            activity: '活动',
            upcomingChallenge: '即将开始的挑战',
            expressInterestHint: '表达兴趣以获取通知并展示参与意向。',
            interestAlreadyExpressed: '已表达兴趣。',
            interestedUsers: '感兴趣用户：{{count}}',
            likes: '点赞',
            likesCount: '{{count}} 个赞',
            showLess: '收起',
            showMore: '... 更多',
            entryDisqualified: '该参赛作品已被取消资格。',
            viewReviewsAndComments: '查看评审与评论',
            assignModeratorsSubtitle: '为该挑战分配并管理协同评委。',
            inviteParticipants: '邀请参与者',
            inviteParticipantsSubtitle: '通过邮箱邀请个人，或通过 ID 邀请合唱团。',
            inviteUserEmail: '参与者邮箱',
            inviteChoirId: '合唱团 ID',
            enterUsernameOrEmail: '输入用户名或邮箱',
            alreadyVotedOnEntry: '你已对该作品投票。',
            anonymous: '匿名',
            communityMember: '社区成员',
            public: '公开',
            private: '私密',
            scorePrefix: '分数 {{score}}',
            shareJoinText: '来参加这个挑战：{{title}}',
            you: '你',
            actions: {
                submitting: '提交中...',
                expressInterest: '表达兴趣',
                interestExpressed: '已表达兴趣',
                enterChallenge: '参加挑战',
                shareChallenge: '分享挑战',
                vote: '投票',
                voted: '已投票',
                editChallenge: '编辑挑战',
                manageModerators: '管理评委',
                leaderboard: '排行榜',
                share: '分享',
                resolve: '解析',
                assigning: '分配中...',
                assignModerator: '分配评委',
                inviting: '邀请中...',
                inviteUser: '邀请用户',
                inviteChoir: '邀请合唱团',
                remove: '移除',
                submitEntry: '提交参赛作品',
                submitVote: '提交投票',
                disqualify: '取消资格',
                loadReviews: '加载评审',
                submitReview: '提交评审',
            },
            countdown: {
                days: '天',
                hours: '时',
                minutes: '分',
                seconds: '秒',
            },
            aria: {
                openLeaderboard: '打开排行榜',
                openChallengeInformation: '打开挑战信息',
                shareChallenge: '分享挑战',
                copyChallengeLink: '复制挑战链接',
                voteOnEntry: '为作品投票',
                alreadyVotedOnEntry: '你已对该作品投票',
                likes: '点赞',
                viewReviewsAndComments: '查看评审与评论',
                previousEntry: '上一条作品',
                nextEntry: '下一条作品',
                submitChallengeEntry: '提交挑战参赛作品',
            },
            prompts: {
                disqualifyReason: '请输入取消资格原因（至少 5 个字符）：',
            },
            toasts: {
                entrySubmitted: '参赛作品提交成功。',
                entrySubmitFailed: '提交参赛作品失败。',
                interestExpressed: '表达兴趣成功。',
                interestFailed: '表达兴趣失败。',
                userNotFound: '未找到该用户名对应的用户。',
                userLookupFailed: '按用户名查找用户失败。',
                resolveModeratorFirst: '请先解析有效的评委邮箱。',
                moderatorAssigned: '评委分配成功。',
                assignModeratorFailed: '分配评委失败。',
                moderatorRemoved: '评委移除成功。',
                removeModeratorFailed: '移除评委失败。',
                inviteCreated: '挑战邀请创建成功。',
                inviteFailed: '创建挑战邀请失败。',
                enterInviteTarget: '请先输入有效邀请对象。',
                voteSubmitted: '投票提交成功。',
                voteFailed: '投票提交失败。',
                disqualified: '取消资格成功。',
                disqualifyFailed: '取消资格失败。',
                reviewTooShort: '评审评论至少需要 3 个字符。',
                reviewSubmitted: '评审提交成功。',
                reviewFailed: '提交评审失败。',
                linkCopied: '挑战链接已复制到剪贴板。',
                shareFailed: '当前无法分享挑战。',
                copyFailed: '当前无法复制挑战链接。',
                likeUpdateFailed: '当前无法更新点赞状态。',
            },
            entryAlt: '参赛作品',
            entryAvatarAlt: '参赛头像',
            entryByActor: '参赛作品 #{{entryId}}{{actorPart}}',
            byActor: '操作者 {{actor}}',
            moderatorSharePrompt: '分享这个挑战以吸引更多参赛作品。',
        },
        contribution: {
            breadcrumb: '贡献 > {{title}}',
            unknownTitle: '未知标题',
            filters: {
                all: '全部',
                searchByUsername: '按贡献者用户名搜索',
                updating: '更新中',
            },
            empty: {
                needHelp: '该声部暂时还没有贡献内容。需要帮助来推进吗？',
                requestHelp: '为该声部请求帮助',
                beFirst: '该声部暂时还没有贡献内容。成为第一个贡献者吧！',
                submitContribution: '提交你的贡献',
            },
            pagination: {
                prev: '上一页',
                next: '下一页',
                pageOf: '第 {{page}} 页，共 {{total}} 页',
            },
            error: {
                generic: '发生错误',
            },
        },
        requests: {
            title: '请求',
            searchBySongTitle: '按歌曲标题搜索',
            loadMore: '加载更多',
            filters: {
                all: '全部',
            },
            empty: {
                alt: '暂无请求',
                description: '当前筛选条件下没有找到请求。',
                prompt: '想向社区请求某个声部的贡献吗？',
                cta: '请求贡献',
            },
            error: {
                alt: '错误',
                loadFailed: '加载请求失败',
            },
        },
        requestDetail: {
            comingSoon: '请求详情即将上线。',
            error: {
                generic: '发生错误',
            },
        },
        reelDetails: {
            title: 'Reel 详情',
            invalidId: '无效的 Reel ID。请使用 UUID 风格的 Reel 链接。',
        },
        reelsFeed: {
            swipeUp: '向上滑动',
            clipboardUnsupported: '当前不支持剪贴板 API',
            linkShared: '链接分享成功！',
            linkShareFailed: '分享链接失败',
            linkCopied: '链接已复制到剪贴板！',
            linkCopyFailed: '复制链接失败',
        },
    },
    marketplace: {
        loadSongsFailed: '加载商城歌曲失败',
        noListings: '当前没有可用的商城上架内容。',
        goBack: '返回',
        title: '标题',
        artist: '艺术家',
        access: '访问权限',
        price: '价格',
        duration: '时长',
        action: '操作',
        accessPremium: '高级会员',
        accessMasterOnly: '仅 Master',
        accessStems: '分轨',
        premiumPreview: '高级 / 试听',
        buyRent: '购买/租用',
        orders: {
            loadFailed: '加载商城订单失败',
            empty: '你还没有任何商城订单。',
            browseMarketplace: '浏览商城',
            title: '我的订单',
            subtitle: '查看商城结账记录、支付状态，以及返回已解锁歌曲的快捷入口。',
            columns: {
                order: '订单',
                status: '状态',
                amount: '金额',
                date: '日期',
            },
            unavailable: '不可用',
            viewOrder: '查看订单',
        },
        purchases: {
            loadFailed: '加载商城购买记录失败',
            empty: '你还没有任何有效的商城购买记录。',
            browseMarketplace: '浏览商城',
            title: '我的购买',
            subtitle: '你通过直购、租赁或完成商城结账已解锁的歌曲。',
            paid: '已支付',
            owned: '已购买',
            rental: '租赁',
            masterOnly: '仅 Master',
            stemsIncluded: '包含分轨',
            unavailable: '不可用',
            openSong: '打开歌曲',
        },
        orderDetail: {
            loadFailed: '加载商城订单失败',
            notFound: '未找到商城订单',
            marketplaceOrder: '商城订单',
            backToOrders: '返回订单',
            openSong: '打开歌曲',
            status: '状态',
            entitlement: '权益：',
            expires: '到期：',
            payment: '支付',
            provider: '支付渠道：',
            reference: '参考号：',
            accessScope: '访问范围',
            orderSuffix: '订单',
            detailsTitle: '订单详情',
            detailsSubtitle: '该商城交易的参考信息。',
            orderType: '订单类型',
            created: '创建时间',
            updated: '更新时间',
            song: '歌曲',
        },
        orderModal: {
            referenceCopied: '参考号已复制到剪贴板',
            copyPaymentReferenceAria: '复制支付参考号',
            copyReference: '复制参考号',
        },
        listings: {
            loadFailed: '加载商城上架列表失败',
            updated: '商城上架信息已更新。',
            updateFailed: '更新商城上架信息失败',
            loadOrdersFailed: '加载上架订单失败',
            listingForfeited: '已放弃该上架。',
            appealSubmitted: '申诉已提交。',
            reportResponseFailed: '提交举报响应失败',
            empty: '你还没有创建可用于商城上架的社区歌曲。',
            title: '我的上架',
            subtitle: '管理你创建歌曲在商城中的可见性、定价与订单流转。',
            table: {
                listing: '上架',
                revenue: '收入',
            },
            stats: {
                activeListings: '已激活上架',
                stillDraft: '{{count}} 个仍为草稿',
                premiumEnabled: '已启用高级解锁',
                premiumHint: '支持订阅解锁的上架内容',
                revenue: '收入',
                zeroUsd: 'USD 0.00',
                revenueHint: '当前累计的商城直接收入',
                loadedOrders: '已加载订单',
                loadedOrdersHint: '本次会话已查看的卖家订单',
            },
            buySummary: '购买 {{price}}',
            rentSummary: '租赁 {{price}}{{duration}}',
            notConfigured: '未配置',
            listed: '已上架',
            processingHint: '后台处理仍在进行中，处理完成后将自动解锁上架。',
            noneYet: '暂无',
            editListing: '编辑上架',
            viewOrders: '查看订单',
            health: {
                processing: '处理中',
                ready: '就绪',
                reported: '已被举报',
                draft: '草稿',
                needsAccessPath: '缺少访问路径',
                premiumOnly: '仅高级订阅',
                missingRentalDays: '缺少租赁天数',
                missingBuyPrice: '缺少购买价格',
                missingRentPrice: '缺少租赁价格',
            },
            editor: {
                title: '编辑上架',
                byline: '{{title}} - {{artist}}',
                processingHint: '该歌曲仍在后台处理中。打包完成前将保持禁用上架。',
                songReport: '歌曲举报',
                reportedForReview: '已提交审核',
                lastReported: '最近举报于 {{date}}',
                open: '开放',
                adminRequestedExplanation: '管理员已要求你对此上架内容进行说明。你可以提交申诉或放弃上架。',
                explanationPlaceholder: '请说明该上架内容应继续保留的原因',
                submitting: '提交中...',
                submitAppeal: '提交申诉',
                forfeitListing: '放弃上架',
                creatorResponseStatus: '创作者响应状态：{{status}}',
                listSong: '上架歌曲',
                premiumAccess: '高级访问',
                enableSale: '启用售卖',
                salePricePlaceholder: '售卖价格（最小货币单位）',
                enableRent: '启用租赁',
                rentPricePlaceholder: '租赁价格（最小货币单位）',
                rentalDurationPlaceholder: '租赁时长（天）',
                accessScope: '访问范围',
                currency: '币种',
                saving: '保存中...',
                saveListing: '保存上架',
            },
            sellerOrders: {
                title: '卖家订单',
                fallbackSubtitle: '该上架内容的商城订单',
                orders: '订单数',
                paidRevenue: '已支付收入',
                listedScope: '上架范围',
                noneYet: '暂无',
                empty: '该上架内容暂时还没有商城订单。',
            },
        },
        earnings: {
            loadFailed: '加载商城收益失败',
            unavailable: '当前无法获取商城收益数据。',
            title: '收益',
            subtitle: '你的社区歌曲上架在商城中的总收入与创作者分成收益。',
            reportingWindow: '统计窗口',
            chart: {
                listings: '上架数',
                active: '激活数',
                premium: '高级',
                paidSongs: '付费歌曲',
                orders: '订单',
                royalties: '分成',
                series: {
                    listingHealth: '上架健康度',
                    marketplaceActivity: '商城活跃度',
                    royaltyEvents: '分成事件',
                },
            },
            filters: {
                allTime: '全部时间',
                start: '开始',
                now: '现在',
                from: '从',
                to: '到',
                apply: '应用',
                reset: '重置',
            },
            cards: {
                totalEarnings: {
                    title: '总收益',
                    multiMarketValue: '{{count}} 个市场',
                    singleCurrencyNote: '商城总收入',
                    multiCurrencyNote: '多币种直接收入',
                },
                creatorRoyalty: {
                    title: '创作者分成',
                    multiLedgerValue: '{{count}} 个账本',
                    singleCurrencyNote: '你的分成收益',
                    multiCurrencyNote: '多币种创作者分成',
                },
                totalTracks: {
                    title: '歌曲总数',
                    note: '{{count}} 个活跃上架',
                },
                totalEngagement: {
                    title: '总互动量',
                    note: '{{orders}} 笔订单 • {{events}} 次分成事件',
                },
                projectContribution: {
                    title: '项目贡献',
                    pendingValue: '{{count}} 笔待处理',
                    noPendingValue: '无待处理打款',
                    pendingNote: '来自项目贡献的待处理打款',
                    noPendingNote: '当前没有等待提现/后台处理的项目贡献打款',
                },
            },
            analytics: {
                title: '概览分析',
                subtitle: '查看所选时间窗口内的商城活跃度、上架健康度和创作者分成覆盖。',
            },
            topSongs: {
                title: '收益最高歌曲',
                subtitle: '所选窗口内商城总收入领先的歌曲。',
                empty: '暂无产生收益的歌曲。',
                goToListings: '前往我的上架',
            },
            table: {
                revenue: '收入',
                orders: '订单',
                openSong: '打开 {{song}}',
            },
            royalty: {
                title: '创作者分成明细',
                subtitle: '所选窗口内，已结算社区歌曲分成事件带来的创作者收益。',
                emptyTitle: '暂无分成事件',
                emptyDescription: '当付费购买/租赁订单结算入分成账本后，将在此显示分成记录。',
                table: {
                    currency: '货币',
                    royalty: '分成',
                    events: '事件',
                    eventsCount: '{{count}} 次事件',
                },
            },
            coverage: {
                title: '覆盖说明',
                description: '这里的分成总额已包含已结算的销售与租赁事件。社区歌曲播放产生的流媒体分成将在触发播放事件后写入同一账本。',
            },
        },
        checkout: {
            successTitle: '支付已到账',
            successDescription: '我们正在核验你的商城订单并刷新访问权限。',
            pendingTitle: '支付处理中',
            pendingDescription: '支付回调已到达 VocalCentric。我们正在等待订单最终状态。',
            failureTitle: '结账未完成',
            failureDescription: '支付流程未完成。你可以返回歌曲页重试或查看订单历史。',
            loadStatusFailed: '无法加载结账状态',
            canceledReason: '你在完成前关闭了支付流程。',
            accessExpires: '访问到期',
            viewOrders: '查看订单',
            viewPurchases: '查看购买记录',
        },
        songDetail: {
            listingDetail: '上架详情',
            notFound: '未找到商城歌曲',
            loadFailed: '加载商城歌曲失败',
            checkoutInitialized: '结账已初始化',
            checkoutFailed: '无法发起结账',
            songReported: '歌曲已举报',
            reportFailed: '举报歌曲失败',
            marketplaceSong: '商城歌曲',
            premiumEligible: '可使用高级权益',
            reported: '已举报',
            report: '举报',
            information: '信息',
            licensing: '授权',
            total: '合计',
            openInPlayer: '在播放器中打开',
            previewInPlayer: '在播放器中试听',
            openPlayer: '打开播放器',
            upgrade: '升级',
            rentNow: '立即租赁',
            buyNow: '立即购买',
            unlisted: '该歌曲当前未在商城上架。',
            purchase: '购买',
            multitracks: '多轨',
            masterRental: '主轨租赁',
            daysAccess: '{{days}} 天访问',
            timedAccess: '限时访问',
            masterTrack: '主轨',
            fullMasterPreview: '完整主轨试听',
            masterBuy: '购买主轨',
            masterStemsBuy: '购买主轨 + 分轨',
            permanentAccess: '永久访问',
            permanentFullAccess: '永久完整访问',
            masterOnly: '仅主轨',
            masterStems: '主轨 + 分轨',
            included: '已包含',
            includedWithPremium: '已包含在高级权益中',
            alreadyUnlocked: '已解锁',
            premiumUnlockHint: '高级用户会自动解锁该上架内容。',
            usageTerms: '使用条款',
            notes: '说明',
            marketplaceAccess: '商城访问',
            unlocked: '已解锁',
            previewOnly: '仅试听',
            accessExpiresOn: '访问将于 {{date}} 到期。',
            noTags: '暂无标签。',
            timed: '限时',
            rentalAccess: '{{days}} 租赁访问',
            permanentLicenseAccess: '永久授权访问',
            masterPlaybackOnly: '仅主轨播放',
            masterStemsAccess: '主轨 + 分轨访问',
            premiumInclusionAvailable: '支持高级权益包含',
            premiumInclusionDisabled: '未启用高级权益包含',
            sharedPlayerPreviewFlow: '共享播放器试听流程',
            artworkAlt: '{{song}} 封面',
            metadata: {
                published: '发布时间',
                songTitle: '歌曲标题',
                artistName: '艺术家',
                creator: '创建者',
            },
            stems: {
                readyInSharedPlayer: '可在共享播放器中使用',
                lockedUntilAccess: '在获取访问权限前处于锁定状态',
                masterOnlyNotice: '该上架为仅主轨。可解锁主轨，但分轨将保持隐藏。',
                noneAvailable: '该上架当前没有额外多轨可用。',
            },
            reasons: {
                creator: '你是该歌曲创建者，因此你的账号已自动解锁商城播放权限。',
                entitlement: '你已解锁该歌曲。可在共享播放器中打开，或查看购买历史。',
                premium: '该创作者启用了高级权益访问，因此你可通过高级计划直接使用。',
                purchaseRequired: '你现在可以先试听主轨，再通过租赁或购买解锁完整上架内容。',
                unlisted: '该歌曲当前未开放商城访问。',
                default: '下方可查看商城访问详情。',
            },
        },
    },
    notifications: {
        title: '通知',
        subtitle: '管理你的通知并及时关注重要更新。',
        markAllAsRead: '全部标为已读',
        empty: '暂无通知',
        timeAgo: '{{time}}前',
    },
    requestSongs: {
        title: '歌曲请求',
        subtitle: '为你希望在平台上看到的歌曲投票',
        addSongRequest: '添加歌曲请求',
        searchPlaceholder: '搜索歌曲（例如："Way Maker by Sinach"）',
        songTitle: '歌曲标题',
        enterSongTitle: '输入歌曲标题',
        artistName: '歌手名称',
        enterArtistName: '输入歌手名称',
        albumName: '专辑名称',
        enterAlbumName: '输入专辑名称',
        mediaLink: '媒体链接',
        mediaLinkPlaceholder: '建议使用 Spotify、Apple Music、AudioMac、Youtube',
        thumbnailLink: '封面链接',
        thumbnailLinkPlaceholder: '歌曲封面或图片',
        save: '保存',
        cancel: '取消',
        songRequestCreated: '歌曲请求已创建',
        songRequestFailed: '歌曲请求失败',
        tableTitle: '标题',
        tableGenres: '风格',
        tableVotes: '票数',
        tableActions: '操作',
        songVotedSuccessfully: '投票成功',
        songVotingFailed: '投票失败',
        notSpecified: '未指定',
        voted: '已投票',
        vote: '投票',
        iconAlt: '图标',
    },
    requestRole: {
        title: '角色申请',
        subtitle: '选择你偏好的角色以便进入候选名单。',
        applyWhitelisted: '申请白名单',
        applyDirector: '申请成为指挥',
        fillToApply: '请完整填写后提交申请。',
        noApplicationFound: '未找到申请记录',
        goBack: '返回',
        goToDashboard: '前往仪表盘',
        reApply: '重新申请',
        uploadHelp: '上传一段展示你技能与能力水平的视频（教学/演奏/演唱）。时长应在 2-5 分钟内。该视频将用于评估你的演唱能力。',
        socialMediaPlaceholder: '输入社交媒体主页 *',
        socialMediaHandle: '社交媒体账号',
        reasonPlaceholder: '你为什么申请这个角色？ *',
        reason: '原因',
        websiteLink: '网站链接',
        websiteLinkOptional: '网站链接（可选）',
        apply: '申请',
        cancel: '取消',
        whitelistSubmitted: '白名单申请提交成功',
        directorSubmitted: '指挥申请提交成功',
        status: {
            director: {
                approved: '你已被批准成为指挥',
                pending: '你的指挥申请仍在审核中',
                rejected: '你的指挥申请已被拒绝',
            },
            whitelisted: {
                approved: '你已被批准加入白名单',
                pending: '你的白名单申请仍在审核中',
                rejected: '你的白名单申请已被拒绝',
            },
            joinChoir: {
                approved: '你加入合唱团的申请已通过',
                pending: '你加入合唱团的申请仍在审核中',
                rejected: '你加入合唱团的申请已被拒绝',
            },
        },
    },
    rehearsal: {
        all: '全部',
        allDescription: '所有个人排练歌曲',
        rehearsed: '已排练',
        rehearsedDescription: '已排练歌曲',
        new: '最新',
        newDescription: '排练中的新歌曲',
        startRehearsal: '开始排练',
        startingRehearsal: '正在开始排练',
        tableTitle: '标题',
        tableAlbum: '专辑',
        tableGenre: '风格',
        tableVotes: '票数',
        tableDuration: '时长',
        tableAction: '操作',
        empty: '暂未找到你的排练内容，立即创建一个吧！',
        loading: '加载中...',
        searchToAdd: '搜索音乐、艺术家和专辑以添加到排练',
        generateShareLink: '生成分享链接',
        chat: {
            noMessages: '暂无聊天消息',
            typeMessage: '输入消息',
            avatarAlt: '头像',
            participantFallback: 'John Doe',
            participants: '{{count}} 位参与者',
        },
        scoreSheet: '乐谱',
        songSlides: {
            selectSlide: '选择幻灯片',
        },
        songMeta: {
            artist: '艺术家',
            writer: '作者',
            label: '厂牌',
            theme: '主题',
            genre: '风格',
            album: '专辑',
            bpm: 'BPM',
            timeSig: '拍号',
            duration: '时长',
            key: '调号',
            originalKey: '原始调号',
            rehearsalKey: '排练调号',
            publicDomain: '公有领域',
            gospel: '福音',
            na: '__',
            rehearsedBy: '排练人数',
            votes: '{{count}} 票',
            coverArtAlt: '{{title}} 封面',
        },
        tabs: {
            lyrics: '歌词',
            lyricsDescription: '这首歌的歌词',
            slides: '幻灯片',
            slidesDescription: '这首歌的幻灯片',
            practice: '练习',
            practiceDescription: '练习这首歌',
            customHarmonies: '自定义和声',
            customHarmoniesDescription: '此合唱排练的自定义和声列表',
            reviewPractice: '复查练习',
            reviewPracticeDescription: '合唱排练练习复查',
            practise: '练习',
            practiseDescription: '合唱排练练习',
            addAnotherFile: '再添加一个文件',
            noSlides: '暂无幻灯片',
            addSlidesToStart: '添加幻灯片后即可开始',
        },
    },
    rehearsalPractice: {
        subtitle: '选择一个片段，检查录音，查看辅导建议，然后无缝进入下一句。',
        personalRehearsal: '个人排练',
        sectionFeedback: '片段反馈',
        closeFeedback: '关闭反馈',
        previousSection: '上一片段',
        nextSection: '下一片段',
        takePreview: '录音预览',
        lock: '锁定',
        submitted: '已提交',
        countIn: '预备拍',
        playbackOnly: '仅播放',
        stopClickPreview: '停止节拍预听',
        previewClick: '预听节拍',
        click: '节拍',
        singAlongGuide: '跟随引导轨演唱',
        recordWithoutGuide: '不使用引导轨录制',
        singAlongEnabled: '跟唱已开启',
        singAlongDisabled: '跟唱已关闭',
        pauseTake: '暂停录音',
        playTake: '播放录音',
        viewFeedback: '查看反馈',
        stopRecording: '停止录制',
        cancelCountIn: '取消预备拍',
        recordTake: '录制片段',
        discardTake: '丢弃录音',
        submitForAiReview: '提交 AI 评审',
        recommendedNextStep: '推荐下一步',
        retryRecording: '重新录制',
        aiNoteTitle: 'AI 评语',
        aiNoteFallback: '为该片段录制一次演唱，即可获得 VocalCentric 教练的针对性反馈。',
        overallScore: '总体评分',
        performanceBreakdown: '表现分解',
        performanceBreakdownSubtitle: '展开后可在同一处对比指标摘要与雷达分析。',
        nextStepRetryFocus: '请重录这一段，并重点关注 {{metric}}。{{description}}',
        nextStepDefault: '录制或重新录制该片段，然后查看更新后的评语，再进入下一句。',
        scoreSummary: {
            strongPass: '表现优秀',
            gettingCloser: '越来越接近',
            needsAnotherTake: '还需再录一次',
        },
        status: {
            reviewed: '已评审',
            submitted: '已提交',
            needsWork: '需要改进',
            retry: '重试',
            awaitingReview: '等待评审',
            notStarted: '未开始',
        },
        sectionNavigator: {
            practiceProgress: '练习进度',
            title: '片段导航',
            subtitle: '可跳转到任意片段，查看状态，并在不离开网格的情况下打开反馈。',
            reviewed: '已评审',
            pending: '待处理',
            needsWork: '需改进',
            vocal: '声部',
        },
        metrics: {
            pitch: {
                label: '音高',
                description: '更稳定地贴合目标音高。',
            },
            rhythm: {
                label: '节奏',
                description: '让你的时值与律动更贴合。',
            },
            energy: {
                label: '能量',
                description: '更均匀地控制音量与气息支撑。',
            },
            chroma: {
                label: '色度',
                description: '在整个乐句中保持稳定的调性感。',
            },
            swass: {
                label: 'SWASS',
                description: '关注音色的清晰度与一致性。',
            },
            zcr: {
                label: 'ZCR',
                description: '减少噪声起音与辅音过硬的问题。',
            },
        },
    },
    choirRehearse: {
        common: {
            loading: '加载中...',
            goBack: '返回',
        },
        unsavedLeavePrompt: '你有未保存的和声更改，确定要离开此页面吗？',
        sectionKeySaved: '分组调性已更新',
        sectionKeySaveFailed: '无法更新分组调性',
        selectedHarmonyResource: '已选择排练编曲',
        openHarmonyResource: '打开编曲',
        harmonyResourceOpenFailed: '无法打开所选编曲。',
        dryRun: {
            title: '排练模拟练习',
            backToRehearsal: '返回排练',
            audioNotFound: '找不到该排练音频。',
            lyrics: '歌词和备注',
            practiceLoadFailed: '无法加载练习提交。',
            microphoneFailed: '无法使用麦克风。',
            practiceSubmitted: '练习已提交',
            practiceSubmitFailed: '无法提交练习。',
            submissions: '练习提交',
            submissionProgress: '{{submitted}} / {{total}} 位成员已提交',
            searchMembers: '搜索成员',
            filterAll: '全部',
            filterSubmitted: '已提交',
            filterPending: '待提交',
            nudgeAll: '提醒所有待提交成员',
            nudge: '提醒',
            nudgeSent: '已向 {{count}} 位成员发送提醒。',
            nudgeFailed: '无法发送练习提醒。',
            pending: '待提交',
            noMatchingMembers: '没有匹配当前筛选的成员。',
            takes: '{{count}} 次录音',
            playbackFailed: '无法播放练习录音。',
            feedbackPlaceholder: '该录音的可选反馈',
            needsImprovement: '需要改进',
            approve: '通过',
            reviewSaved: '练习评审已保存',
            reviewFailed: '无法保存该评审。',
            yourPractice: '你的练习',
            part: '合唱声部',
            selectPart: '选择你的声部',
            startRecording: '开始录音',
            stopRecording: '停止录音',
            recordAgain: '重新录制',
            discardTake: '放弃录音',
            submit: '提交练习',
            resubmit: '重新提交练习',
            submitting: '正在提交…',
            status: {
                pending: '待评审',
                approved: '已通过',
                needs_improvement: '需要改进',
            },
        },
        metadataEditor: {
            editButton: '编辑歌曲元数据',
            title: '编辑歌曲元数据',
            description: '更新本次排练的调性、速度与拍号。',
            tempoRangeError: '速度必须在 40 到 240 BPM 之间。',
            timeSignatureFormatError: '拍号格式必须有效，例如 4/4。',
            partialSaveError: '部分歌曲元数据未能保存，请重试。',
            saveSuccess: '歌曲元数据已更新',
            saveFailure: '更新歌曲元数据失败',
        },
        lyrics: {
            mixed: '混合',
            solfa: '首调',
            solfaMain: '主旋律首调',
            solfaTenor: '男高音首调',
            solfaAlto: '女低音首调',
            solfaSoprano: '女高音首调',
            chordProgression: '和弦进行',
            rehearsalFallbackTitle: '排练',
            comingSoon: '即将推出！',
            referenceAudioUpload: '上传音频',
            referenceAudioReplace: '替换音频',
            referenceAudioRemove: '删除音频',
            referenceAudioSaving: '正在保存音频...',
            referenceAudioUploading: '正在上传音频 {{percent}}%',
            referenceAudioProcessing: '正在处理音频...',
            referenceAudioSaveSuccess: '该诗班的参考音频已更新',
            referenceAudioUploadFailed: '上传参考音频失败',
            referenceAudioRemoveSuccess: '参考音频已删除',
            referenceAudioRemoveFailed: '删除参考音频失败',
        },
        lyricsEditor: {
            title: '编辑外部歌曲内容',
            description: '添加分段标题和内容行，然后生成结构化分段并仅保存到本次排练的该内容。',
            placeholder: '先添加“主歌 1”之类的标题，再在下方输入每一行歌词。',
            generate: '生成结构化分段',
            generated: '已生成 {{sectionCount}} 个分段，共 {{lineCount}} 行。',
            noSections: '未找到分段。请先添加“主歌 1”或“副歌”等标题后再生成。',
            addCta: '添加歌词',
            editCta: '编辑歌词',
            emptyState: '此外部歌曲尚未添加歌词。',
            addTarget: '添加{{target}}',
            editTarget: '编辑{{target}}',
            emptyStateFor: '此外部歌曲尚未添加{{target}}。',
            saveSuccess: '已更新本次排练的歌词',
            saveSuccessFor: '已更新本次排练的{{target}}',
            saveFailure: '歌词更新失败',
        },
        lyricsSync: {
            title: '同步外部歌曲时间',
            description: '将排练音频与结构化歌词对齐，然后把这些时间用于本次排练的首调和和弦进行。',
            button: '同步时间',
            recommended: '推荐',
            recommendedNote: '主歌词完成一次定时后，这些时间戳会应用到本次排练的所有其他结构化版本。',
            synced: '已同步',
            save: '保存同步',
            saveSuccess: '已同步本次排练的歌词时间',
            saveFailure: '同步歌词时间失败',
        },
        submissions: {
            goToRehearsal: '前往排练',
            empty: '暂无提交',
        },
        practicePage: {
            performanceTab: '表现',
            recentPerformance: '最近表现',
            submitAll: '全部提交',
            submissionAnalyzing: '你的提交正在分析中。准备好后会通过仪表盘通知你。',
            performedVocalLabel: '演唱声部：',
            alto: '女低音',
            slideSheetAlt: '幻灯片乐谱',
            toasts: {
                noRecordings: '没有可上传的录音',
                uploadSuccess: '录音上传成功',
                uploadError: '上传录音时出错',
            },
            metrics: {
                accuracyTitle: '准确度评分：',
                accuracyDescription: '你相对于原始录音的演唱准确程度。',
                pitchTitle: '音高准确度：',
                pitchDescription: '你与原始声部音高的匹配程度。',
                timingTitle: '节拍与节奏：',
                timingDescription: '你在整个演唱中保持正确节拍与节奏的能力。',
                dynamicRangeTitle: '动态范围：',
                dynamicRangeDescription: '评估你表达不同音量和力度层次的能力，这对还原原始声部细节非常重要。',
                noteArticulationTitle: '音符咬字：',
                noteArticulationDescription: '对你音符清晰度与准确性的反馈，这对花腔与乐句处理很重要。',
                vocalToneTitle: '音色质量：',
                vocalToneDescription: '评估你复现所选声部目标音色与音质特征的能力。',
            },
        },
        reviewEntry: {
            userPracticeTab: '{{username}} 的练习',
            toasts: {
                correctionSuccess: '修正音频上传成功',
                correctionError: '上传修正音频时出错',
            },
        },
        songListCard: {
            playAlt: '播放',
            remove: '移除',
            noHarmoniesForKey: '调性 {{key}} 暂无和声',
            generateHarmonies: '从原调 {{originalKey}} 生成 {{key}} 的和声',
            transposeHint: '我们将使用 {{originalKey}} 下现有的 {{section}} 声部并进行移调。',
            addHarmonyPart: '+ 添加和声声部',
            uploadAllForSection: '上传 {{section}} 的全部和声声部',
            moveUp: '向上移动分段',
            moveDown: '向下移动分段',
            expand: '展开 {{section}}',
            collapse: '收起 {{section}}',
            reorderFailed: '无法重新排序和声分段，请重试。',
            deleteSectionTitle: '删除分段',
            deleteSectionDescription: '删除整个 {{section}} 分段及其所有声部？此操作不可撤销。',
            deleteSectionConfirm: '删除分段',
            visibility: {
                private: '私有',
                choir_only: '仅合唱团',
                public: '公开',
                mixed: '混合',
            },
        },
        reuseHarmonies: {
            entryTitle: '复用现有和声',
            entryDescription: '从其他已录制调性为 {{targetKey}} 生成缺少的声部。',
            title: '复用现有和声',
            description: '选择用于为 {{targetKey}} 生成缺少声部的录制调性。',
            targetKey: '工作调性',
            selectSource: '选择源调性',
            coverage: '{{sections}} 个分段中的 {{parts}} 个声部',
            generate: '生成和声',
            generating: '正在生成...',
            queued: '正在生成 {{targetKey}} 的和声',
            alreadyAvailable: '此调性的全部和声均已可用',
            failed: '无法复用现有和声',
        },
        harmonyLibrary: {
            entryTitle: '社区和声',
            entryDescription: '浏览其他歌手和合唱团分享的编排。',
            title: '社区和声',
            description: '预览并将编排添加到该合唱团的自定义和声中。',
            search: '搜索社区和声',
            searchAction: '搜索',
            retry: '重新加载社区和声',
            empty: '暂无社区和声',
            untitled: '未命名编排',
            community: 'Vocal Centric 社区',
            noKey: '未设置调性',
            preview: '预览',
            add: '添加',
            adding: '正在添加...',
            unlock: '解锁',
            added: '和声已添加到自定义和声',
            alreadyAdded: '此和声已在自定义和声中',
            addFailed: '无法添加社区和声',
            unlockFailed: '无法解锁此社区和声',
        },
        partRow: {
            midiTag: '• MIDI',
            pickExisting: '选择已有',
            pickExistingOption: '{{name}}（{{section}}）在 {{songKey}} {{midiTag}}',
            pauseAudioTooltip: '暂停此音频声部',
            playAudioTooltip: '播放此音频声部',
            pauseAudioAria: '暂停音频声部',
            playAudioAria: '播放音频声部',
            pauseMidiTooltip: '暂停此 MIDI 声部',
            playMidiTooltip: '播放此 MIDI 声部',
            pauseMidiAria: '暂停 MIDI 声部',
            playMidiAria: '播放 MIDI 声部',
            stopRecordingTooltip: '停止录制此和声声部',
            recordNewTakeTooltip: '录制新的音频片段',
            failedStartRecording: '无法访问麦克风。请检查浏览器权限并确保使用 HTTPS。',
            stopRecordingAria: '停止录制',
            recordTakeAria: '录制音频片段',
            uploadTooltip: '上传音频或 MIDI 文件',
            uploadAria: '上传文件',
            convertToMidiTooltip: '将此音频片段转换为可编辑 MIDI',
            convertToMidiAria: '将录音转换为 MIDI',
            undoConvertTooltip: '恢复转换前的原始音频',
            undoConvertAria: '撤销 MIDI 转换',
            duplicateMidiTooltip: '将此 MIDI 复制到另一个和声声部',
            duplicateMidiAria: '复制 MIDI 到其他声部',
            closeMidiEditorTooltip: '关闭 MIDI 编辑器',
            openMidiEditorTooltip: '打开钢琴 MIDI 编辑器',
            collapseMidiEditorAria: '折叠 MIDI 编辑器',
            openMidiEditorAria: '打开 MIDI 编辑器',
            removePartTooltip: '移除此和声声部',
            removePartAria: '移除和声声部',
            renameTooltip: '重命名此移调和声声部',
            renameAria: '重命名 {{part}}',
            renameSuccess: '和声声部已重命名',
            renameFailed: '无法重命名和声声部',
            ready: '准备',
            beats: '拍',
            bpm: 'BPM',
            clickDuringTake: '录制期间点击声',
            countInOnly: '仅前导计拍',
            clickOff: '关闭点击声',
            loadingWaveform: '正在加载波形...',
            align: '对齐',
            earlier: '提前',
            later: '延后',
            reset: '重置',
            uploadOrSelectBeforeSave: '保存前请先为该声部上传或选择文件。',
            convertingToMidi: '正在将音频转换为 MIDI 旋律…',
            deletePartTitle: '删除和声声部',
            deletePartDescription: '要从此分段中移除 {{part}} 吗？此操作不可撤销。',
            deletePartConfirm: '删除声部',
            midiEditorTitle: 'MIDI 编辑器',
            midiEditorDescription: '在更大的空间中编辑并播放该和声声部。',
            closeMidiEditorAria: '关闭 MIDI 编辑器',
            saveMidiChangesTitle: '保存 MIDI 修改？',
            saveMidiChangesDescription: '你有未保存的 MIDI 编辑。请在关闭编辑器前保存，或放弃修改。',
            keepEditing: '继续编辑',
            discard: '放弃',
            save: '保存',
            recordingSetupTitle: '录制设置',
            recordingSetupSubtitle: '在录制此声部前设置点击声与前导计拍。',
            closeRecordingSetupAria: '关闭录制设置',
            referenceTrack: '参考轨',
            none: '无',
            lockTakeToReference: '将片段锁定到参考轨',
            playReferenceInTake: '录制时播放参考轨',
            referenceVolume: '参考音量',
            clickMode: {
                off: '关闭',
                'count-in-only': '仅前导计拍',
                'count-in-and-record': '前导计拍 + 录制',
            },
            timeSignature: '拍号',
            tempo: '速度',
            countInLabel: '前导计拍',
            bar: '小节',
            bars: '小节',
            countInOption: '{{bars}} {{unit}}（{{beats}} 拍）',
            preview: '预览',
            previewClickTrack: '预览点击轨',
            compoundFeelNote: '复合拍已启用。点击声将按附点四分音符脉冲分组，获得更自然的起拍。',
            referenceModeNote: '参考模式已启用。速度和拍号将锁定为所选参考轨，以保持本次录制一致。',
            startRecording: '开始录制',
            uploadedPercent: '已上传 {{percent}}%',
            toasts: {
                noClearMelody: '未检测到清晰旋律。请尝试更干净的单旋律录音。',
                convertedToMidi: '录音已转换为 MIDI',
                failedConvertToMidi: '录音转换为 MIDI 失败',
                restoredAudio: '已恢复 MIDI 转换前的音频',
                duplicatedMidi: '已将 MIDI 复制到 {{targetPart}}（{{intervalLabel}}）',
                failedDuplicateMidi: '复制 MIDI 声部失败',
            },
        },
    },
    setlist: {
        yourSetlists: '你的曲目单',
        tabs: {
            mine: '我的曲目单',
            explore: '探索',
        },
        deletedSuccessfully: '曲目单删除成功',
        linkCopied: '链接已复制到剪贴板！',
        songCount: '{{count}} 首歌曲',
        updatedDate: '更新时间：{{date}}',
        empty: '你还没有创建任何曲目单。',
        sharedToChoir: '曲目单已分享至合唱团',
        explore: {
            title: '探索公开曲目单',
            subtitle: '发现其他团队分享的敬拜和演出曲目单及实用资源。',
            searchPlaceholder: '搜索曲目单',
            creatorFallback: 'VocalCentric 创作者',
            free: '免费',
            paid: '付费',
            premium: 'Premium',
            mixed: '混合',
            resources: '{{count}} 个资源',
            empty: '未找到公开曲目单。',
            loadFailed: '无法加载公开曲目单',
            access: {
                all: '全部访问',
                free: '免费',
                paid: '付费',
                premium: 'Premium',
                mixed: '混合',
            },
        },
        owned: {
            back: '返回曲目单',
            loadFailed: '无法加载曲目单',
            notFound: '找不到此曲目单。',
            personalEyebrow: '你的曲目单',
            choirEyebrow: '合唱团曲目单',
            share: '分享曲目单',
            editDetails: '编辑详情',
            setlistName: '曲目单名称',
            nameRequired: '请输入至少两个字符的曲目单名称。',
            scheduledFor: '计划时间',
            editDetailsDescription: '更新曲目单名称、可见性、日程和分享信息。',
            detailsSaved: '曲目单详情已保存',
            detailsSaveFailed: '无法保存曲目单详情',
            shareLink: '分享链接',
            loadingVideo: '正在加载视频…',
            videoUnavailable: '无法加载此视频。',
            seekBackward15Seconds: '后退 15 秒',
            seekForward15Seconds: '前进 15 秒',
            playSetlist: '播放曲目单',
            nowPlaying: '正在播放',
            listen: '收听',
            songs: '曲目单歌曲',
            addSong: '添加歌曲',
            addSongDescription: '选择来源、检查歌曲并添加到此曲目单。',
            songRequired: '请选择歌曲并添加曲目单标签。',
            songLabel: '曲目单标签',
            songSources: {
                search: '曲库',
                youtube: 'YouTube',
                public: '公共领域',
            },
            playSong: '播放歌曲',
            pauseSong: '暂停歌曲',
            dockPlayer: '停靠播放器',
            noPlayableMedia: '无视频',
            noSongs: '尚未添加歌曲。',
            deleteSongConfirm: '从曲目单中移除此歌曲？',
            listenTarget: '收听目标',
            listenTypes: {
                entire: '整首歌曲',
                segment: '片段',
            },
            listenStart: '开始',
            listenEnd: '结束',
            invalidListenSegment: '请输入有效的收听片段。',
            entireTarget: '收听整首歌曲',
            segmentTarget: '收听 {{start}} 至 {{end}}',
            prepare: '准备',
            resources: '曲目单资源',
            resourcesDescription: '此曲目单的乐谱、文档、链接、分轨、参考音频和分组声乐编排。',
            noResources: '尚未添加资源。',
            manageResources: '管理资源',
            manageResourcesDescription: '创建单项资源或分组声乐编排，并控制其分享方式。',
            addResource: '添加资源',
            editResource: '编辑资源',
            deleteResource: '删除资源',
            deleteResourceConfirm: '从曲目单中删除此资源？',
            resourceType: '资源类型',
            resourceTypes: {
                document: '文档',
                audio: '音频',
                stem: '分轨',
                chart: '乐谱',
                link: '链接',
                other: '其他',
                vocal_arrangement: '声乐编排',
            },
            arrangementEditorDescription: '选择歌曲、添加段落，并分别上传每个声部的音频。',
            arrangementSong: '歌曲',
            selectArrangementSong: '选择歌曲',
            arrangementKey: '歌曲调性',
            arrangementKeyOptional: '未选择调性',
            arrangementSections: '编排段落',
            sectionName: '段落名称',
            addSection: '添加段落',
            removeSection: '删除段落',
            arrangementSectionRequired: '请至少添加一个编排段落。',
            arrangementPart: '声部',
            selectArrangementPart: '选择声部',
            addPart: '添加声部',
            removePart: '删除声部',
            arrangementPartRequired: '请为此段落至少添加一个声部。',
            partAudio: '上传声部音频',
            replacePartAudio: '替换声部音频',
            arrangementRequired: '请选择歌曲，并至少添加一个段落，且为每个声部上传音频文件。',
            noArrangementParts: '没有可播放的声部。',
            selectPart: '选择 {{part}}',
            resourceTitle: '标题',
            resourceDescription: '描述',
            resourceAccess: '访问权限',
            premiumAccess: 'Premium 订阅用户',
            resourceUrl: '资源 URL',
            uploadResource: '上传资源',
            audioFilesSupported: '支持 MP3、WAV、M4A 或 AAC',
            documentFilesSupported: '支持 PDF 或 DOCX',
            resourcePrice: '价格',
            resourceCurrency: '币种',
            resourcePublic: '在公开曲目单中显示此资源',
            resourceRequired: '请添加标题以及资源文件或 URL。',
            resourceSaved: '资源已保存',
            resourceSaveFailed: '无法保存资源',
            resourceDeleted: '资源已删除',
            resourceDeleteFailed: '无法删除资源',
            resourcePreview: '资源预览',
            audioUnavailable: '无法加载此音频。',
            openResourceDescription: '此资源将在新浏览器标签页中打开。',
            saving: '正在保存…',
            listenAudit: '收听审计',
            auditDescription: '查看谁已收听以及哪些歌曲获得关注。',
            auditLoadFailed: '无法加载收听审计',
            loadingAudit: '正在加载收听审计…',
            listeners: '听众',
            listens: '收听次数',
            songsHeard: '已听歌曲',
            noAudit: '尚未记录收听活动。',
            nudgeMembers: '提醒尚未收听的成员',
            sendingNudge: '正在发送提醒…',
            nudgeSent: '已向 {{count}} 位成员发送提醒',
            nudgeFailed: '无法发送收听提醒',
        },
        public: {
            fallbackTitle: '曲目单',
            ogDescription: 'VocalCentric 上精心整理的曲目单，共 {{count}} 首歌曲。',
            copyShareLink: '复制分享链接',
            labelPrefix: '标签：',
            listenOnSpotify: '在 Spotify 收听',
            watchOnYoutube: '在 YouTube 观看',
            listen: '收听',
            resources: '资源',
            free: '免费',
            paid: '付费',
            premium: 'Premium',
            openResource: '打开资源',
            unlockResource: '解锁资源',
            upgradeForPremium: '升级到 Premium',
            resourceCheckoutFailed: '无法启动资源结账',
        },
    },
    transactions: {
        historyTitle: '交易记录',
        detailsTitle: '交易详情',
        tableDate: '日期',
        tableOrderNumber: '订单号',
        tablePrice: '价格',
        viewDetails: '查看详情',
    },
    profile: {
        aboutTitle: '关于',
        noSummary: '尚未添加个人简介。',
        experience: '经验',
        years: '{{count}} 年',
        notSpecified: '未指定',
        availability: '可用状态',
        availableForProjects: '可参与项目',
        notCurrentlyAvailable: '当前不可用',
        location: '位置',
        timezone: '时区',
        skillsTitle: '技能',
        addSkill: '添加技能',
        noSkills: '尚未添加任何技能。',
        editSkill: '编辑技能',
        deleteSkill: '删除技能',
        portfolioTitle: '作品集',
        addItem: '添加项目',
        noPortfolioItems: '暂无作品集项目。',
        previewMedia: '预览媒体',
        editPortfolioItem: '编辑作品项目',
        deletePortfolioItem: '删除作品项目',
        previewPortfolioItem: '预览 {{title}}',
        reviewsTitle: '评价',
        reviewsSubtitle: '来自过往合作的评分与信任信号。',
        rating: '评分',
        reviews: '评价',
        completed: '已完成',
        repeatHires: '再次雇佣',
        compactReviews: '（{{count}} 条评价）',
        uploading: '上传中 {{progress}}%',
        uploadAvatar: '上传头像',
        profileAvatar: '个人头像',
        defaultHeadline: 'VocalCentric 上的创意专业人士。',
        shareProfile: '分享资料',
        editProfile: '编辑资料',
        addPortfolioItem: '添加作品项目',
        follow: '关注',
        unfollow: '取消关注',
        inviteToProject: '邀请到项目',
        contact: '联系',
        locationUnavailable: '位置不可用',
        memberSince: '加入时间 {{date}}',
        page: {
            inviteDisabledReason: '你至少需要拥有一个项目才能发送邀请。',
            unavailable: {
                title: '资料不可用',
                needsInitialization: '你的专业资料尚未创建。请先创建，然后根据需要更新可见性。',
                ineligible: '你的账号暂无资格管理专业资料。',
                ownerPrivate: '你的专业资料当前为私密。请先设为公开后再在此路由查看。',
                viewerPrivateOrMissing: '该专业资料是私密的或不存在。',
            },
            options: {
                profileType: {
                    creative: '创作者',
                    owner: '项目所有者',
                    both: '两者',
                },
                visibility: {
                    public: '公开',
                    private: '私密',
                },
                skillType: {
                    voice_part: '声部',
                    instrument: '乐器',
                    role: '角色',
                    specialty: '专长',
                },
                proficiency: {
                    beginner: '初级',
                    intermediate: '中级',
                    advanced: '高级',
                    expert: '专家',
                },
                availability: {
                    'true': '可参与项目',
                    'false': '暂不可用',
                },
            },
            quickInfo: {
                title: '快速信息',
                type: '类型',
                visibility: '可见性',
                defaultPart: '默认声部',
            },
            payout: {
                title: '收款账户',
                description: '用于项目收益转账。',
                loading: '正在加载收款账户...',
                empty: '尚未配置收款账户。',
                accountFallback: '收款账户',
                defaultTag: '默认',
                noAccountNumber: '无账号',
                noBankName: '无银行名称',
                swiftPrefix: 'SWIFT',
            },
            actions: {
                createProfile: '创建资料',
                makeProfilePublic: '设为公开',
                applyForWhitelist: '申请白名单',
                add: '添加',
                save: '保存',
                close: '关闭',
                edit: '编辑',
                remove: '移除',
                delete: '删除',
                copyEmail: '复制邮箱',
                openEmailApp: '打开邮箱应用',
                openMedia: '打开媒体',
            },
            share: {
                fallbackText: '在 VocalCentric 查看 {{title}}。',
            },
            contact: {
                mailSubject: 'VocalCentric 资料联系：{{name}}',
                mailBody: '你好 {{name}}，\n\n我在 VocalCentric 看到了你的资料，想与你建立联系。',
            },
            modals: {
                editProfile: {
                    title: '编辑资料',
                    description: '更新专业身份信息与作品集偏好设置。',
                    headline: '标题',
                    displayNameOverride: '公开显示名',
                    displayNamePlaceholder: '你的名字在公开页面的显示方式',
                    portfolioSummary: '作品集摘要',
                    summaryPlaceholder: '摘要',
                    profileType: '资料类型',
                    timezone: '时区',
                    selectTimezone: '选择时区',
                    visibility: '可见性',
                    availabilityForProjects: '项目可参与状态',
                    city: '城市',
                    state: '省/州',
                    country: '国家',
                    selectCountry: '选择国家',
                    experienceYears: '经验（年）',
                    experiencePlaceholder: '从业年限',
                    websiteUrl: '网站 URL',
                    instagramUrl: 'Instagram URL',
                    youtubeUrl: 'YouTube URL',
                    tiktokUrl: 'TikTok URL',
                    linkedinUrl: 'LinkedIn URL',
                    urlPlaceholder: 'https://...',
                    primaryCategory: '主类别',
                    selectCategory: '选择类别',
                    currency: '币种',
                    selectCurrency: '选择币种',
                    minRate: '最低报价',
                    maxRate: '最高报价',
                    numberPlaceholder: '0',
                    rateNotes: '报价备注',
                    notesPlaceholder: '备注',
                },
                payoutAccount: {
                    editTitle: '编辑收款账户',
                    addTitle: '添加收款账户',
                    description: '添加用于收款的银行转账信息。',
                    country: '国家',
                    accountName: '账户名称',
                    accountNamePlaceholder: '账户持有人姓名',
                    accountNumber: '账号',
                    accountNumberPlaceholder: '0123456789',
                    bankName: '银行名称',
                    bankNamePlaceholder: '银行名称',
                    loadingBanks: '正在加载银行列表...',
                    selectBank: '选择银行',
                    swiftCode: 'SWIFT 代码（可选）',
                    swiftCodePlaceholder: '用于国际转账',
                    defaultLabel: '设为默认',
                    saving: '保存中...',
                    save: '保存',
                    toast: {
                        requiredFields: '国家、账户名称、账号和银行名称为必填项。',
                        selectBank: '请从列表中选择银行。',
                        updated: '收款账户已更新。',
                        added: '收款账户已添加。',
                        saveFailed: '无法保存收款账户',
                    },
                },
                skill: {
                    editTitle: '编辑技能',
                    addTitle: '添加技能',
                    skillType: '技能类型',
                    skillName: '技能名称',
                    skillNamePlaceholder: '技能名称',
                    proficiency: '熟练度',
                    yearsExperience: '经验年限',
                    numberPlaceholder: '0',
                    markPrimary: '设为主要技能',
                },
                portfolio: {
                    editTitle: '编辑作品项',
                    addTitle: '添加作品项',
                    title: '标题',
                    projectName: '项目名称',
                    projectNamePlaceholder: '项目名称',
                    rolePerformed: '担任角色',
                    rolePlaceholder: '角色',
                    category: '类别',
                    mediaUrl: '媒体 URL',
                    thumbnailUrl: '缩略图 URL',
                    externalUrl: '外部 URL',
                    urlPlaceholder: 'https://...',
                    creditedArtist: '署名艺人',
                    artistNamePlaceholder: '艺人名称',
                    yearCompleted: '完成年份',
                    yearPlaceholder: '2026',
                    featureThisWork: '将此作品设为精选',
                    description: '描述',
                    describeWorkPlaceholder: '描述该作品',
                },
                invite: {
                    title: '邀请加入项目',
                    description: '选择你的一个项目和一个开放角色来发送邀请。',
                    project: '项目',
                    selectProject: '选择项目',
                    role: '角色',
                    loadingRoles: '正在加载角色...',
                    selectRole: '选择角色',
                    noOpenRoles: '该项目当前没有开放角色。请新增角色或开放更多名额后再发送邀请。',
                    inviteeEmail: '被邀请人邮箱',
                    inviteeEmailPlaceholder: 'user@example.com',
                    sending: '发送中...',
                    sendInvite: '发送邀请',
                },
                contact: {
                    title: '联系',
                    description: '使用下方资料邮箱直接联系对方。',
                    emailPlaceholder: 'user@example.com',
                },
                preview: {
                    title: '作品预览',
                    externalMediaSource: '该条目指向外部媒体来源。',
                    noMedia: '此作品项未附带可预览的媒体内容。',
                },
                deleteSkill: {
                    title: '删除技能',
                    description: '从你的资料中移除“{{name}}”？此操作不可撤销。',
                    thisSkill: '该技能',
                },
                deletePortfolio: {
                    title: '删除作品项',
                    description: '删除“{{name}}”？此操作不可撤销。',
                    thisPortfolioItem: '该作品项',
                },
            },
            toast: {
                loadPayoutAccountsFailed: '无法加载收款账户',
                loadProjectRolesFailed: '无法加载项目角色',
                profilePublic: '资料已设为公开。',
                updateVisibilityFailed: '无法更新资料可见性',
                profileCreated: '专业资料已创建。你现在可以完善详细信息。',
                initializeProfileFailed: '无法初始化专业资料',
                profileVisibilityUpdated: '资料已设为{{visibility}}。',
                profileUpdated: '资料已更新。',
                updateProfileFailed: '无法更新资料',
                skillSaved: '技能已保存。',
                saveSkillFailed: '无法保存技能',
                skillRemoved: '技能已删除。',
                removeSkillFailed: '无法删除技能',
                portfolioSaved: '作品项已保存。',
                savePortfolioFailed: '无法保存作品项',
                payoutRemoved: '收款账户已删除。',
                removePayoutFailed: '无法删除收款账户',
                portfolioRemoved: '作品项已删除。',
                removePortfolioFailed: '无法删除作品项',
                userContactUnavailable: '用户联系方式不可用。',
                noContactEmail: '未找到该资料的联系邮箱。',
                contactWorkflowFailed: '无法打开联系流程',
                createProjectToInvite: '请先创建项目再从资料页发送邀请。',
                userUnavailableForInvite: '该资料用户当前无法邀请。',
                noInviteEmail: '该资料没有可用的邀请邮箱。',
                createProjectBeforeInvite: '发送邀请前请先创建项目。',
                prepareInviteFailed: '无法准备邀请流程',
                selectProjectRole: '发送邀请前请先选择项目和角色。',
                inviteSent: '邀请发送成功。',
                sendInviteFailed: '无法发送邀请',
                profileFollowed: '已关注该资料。',
                profileUnfollowed: '已取消关注该资料。',
                toggleFollowFailed: '当前无法{{action}}该资料。',
                emailCopied: '邮箱已复制。',
                copyEmailFailed: '无法复制邮箱。',
                shareProfileFailed: '当前无法分享该资料。',
                profileLinkCopied: '资料链接已复制。',
                shareProfileLinkFailed: '无法分享资料链接。',
                avatarUpdated: '头像已更新。',
                coverUpdated: '封面图已更新。',
                updateImageFailed: '无法更新图片。',
                uploadImageFailed: '无法上传图片。',
            },
        },
    },
    error: {
        pageNotFound: '你访问的页面不存在。',
        goHome: '返回首页',
        goBack: '返回',
        emptyDefault: '这里暂无内容，请返回上一页。',
        comingSoon: '请稍候，我们正在开发该功能',
        somethingWentWrong: '出现错误',
        tryAgain: '重试',
        loadPageFailed: '加载此页面时出现错误。',
        pageUpdateDetected: '检测到页面更新',
        pageRefreshHint: '此页面未能完成加载。应用代码更新后，刷新通常可以解决问题。',
        unexpectedRenderError: '意外错误导致此页面无法渲染。',
        refreshApp: '刷新应用',
    },
    public: {
        layout: {
            gotoDashboard: '前往仪表盘',
            createSetlistsPrompt: '想创建你自己的歌单吗？',
            copyright: '© {{year}} VocalCentric。保留所有权利。',
            about: '关于',
            privacy: '隐私',
            terms: '条款',
            contact: '联系',
        },
        cookieNotice: {
            label: 'Cookie 提示',
            message: '我们使用 Cookie 来改进 VocalCentric。',
            dismiss: '关闭 Cookie 提示',
        },
        resourceHandoff: {
            fallbackTitle: '共享资源',
            signInTitle: '登录后打开此资源',
            signInDescription: '贡献链接仅对已登录的 VocalCentric 成员开放。',
            signIn: '登录并继续',
            unavailableTitle: '资源不可用',
            unavailableDescription: '此资源可能已取消发布、被删除或不再与你共享。',
            eyebrow: '共享贡献',
            openApp: '在 VocalCentric 中打开',
            openAppHint: '预览或使用此资源需要 VocalCentric 应用。',
        },
        communityThreadHandoff: {
            fallbackTitle: '社区讨论串',
            signInTitle: '登录后打开此讨论串',
            signInDescription: '社区讨论串链接仅对已登录的 VocalCentric 成员开放。',
            signIn: '登录并继续',
            unavailableTitle: '讨论串不可用',
            unavailableDescription: '此讨论串可能已被删除，或你需要先加入相应房间。',
            eyebrow: '共享社区讨论串',
            openApp: '在 VocalCentric 中打开',
            openAppHint: '查看并参与此讨论需要 VocalCentric 应用。',
        },
        contact: {
            title: '联系我们',
            subtitle: '需要帮助、反馈建议，或希望与 VocalCentric 合作？给我们留言。',
            intercomTitle: '与支持团队聊天',
            intercomSubtitle: '打开 Messenger，开始与 VocalCentric 团队沟通。',
            openMessenger: '打开支持聊天',
            intercomFallback: '支持聊天暂时不可用。请发送邮件至 support@vocalcentric.com。',
            submitted: '消息已收到，我们会尽快回复。',
            namePlaceholder: '你的姓名',
            emailPlaceholder: '你@示例.com',
            subjectPlaceholder: '请选择主题…',
            messagePlaceholder: '请输入你的消息…',
            sending: '...发送中',
            send: '发送消息',
            preferEmail: '更喜欢邮件联系？请发送至',
            responseTime: '响应时间：通常为 24–72 小时（工作日）。',
                subject: {
                    support: '支持 / 帮助',
                    billing: '账单 / 订阅',
                    bug: '错误反馈',
                feedback: '功能建议 / 反馈',
                partnership: '合作 / 授权',
                accountDeletion: '账号删除',
                other: '其他',
            },
            error: {
                nameRequired: '姓名为必填项。',
                emailRequired: '邮箱为必填项。',
                invalidEmail: '请输入有效的邮箱地址。',
                subjectRequired: '请选择一个主题。',
                messageRequired: '消息内容为必填项。',
                messageTooShort: '消息过短（至少 10 个字符）。',
                unexpected: '发生未知错误。',
            },
            toast: {
                sent: '消息已发送！我们会尽快回复你。',
            },
        },
        waitlist: {
            title: '加入候补名单',
            subtitle: '获取专属抢先体验，并及时了解我们的上线动态。',
            submitted: '你已成功加入候补名单！',
            firstName: '名字',
            lastName: '姓氏',
            phonePlaceholder: '输入手机号（+212 34567890）',
            emailPlaceholder: '你@示例.com',
            loading: '...加载中',
            getNotified: '接收通知',
            gotEarlyAccess: '已有抢先访问权限？',
            logIn: '登录',
            joinedCount: '已有超过 ~1.4k+ 人加入',
            days: '天',
            hours: '小时',
            minutes: '分钟',
            seconds: '秒',
            toast: {
                joined: '感谢你加入候补名单！',
            },
            error: {
                emailRequired: '邮箱为必填项。',
                invalidEmail: '请输入有效的邮箱地址。',
                invalidPhone: '请输入有效的手机号。',
                unexpected: '发生未知错误。',
            },
        },
        invitation: {
            pageTitle: '接受合唱团邀请',
            joinChoir: '加入 {{name}} 合唱团',
            confirmJoin: '确认并加入 VocalCentric 上的 {{name}}',
            completeRegistration: '完成注册以接受邀请',
            firstName: '名字',
            firstNamePlaceholder: '输入你的名字',
            lastName: '姓氏',
            lastNamePlaceholder: '输入你的姓氏',
            username: '用户名',
            usernamePlaceholder: '输入你偏好的用户名',
            password: '密码',
            passwordPlaceholder: '创建密码',
            accept: '接受邀请',
            decline: '拒绝',
            accepted: '邀请接受成功！',
            declined: '邀请已拒绝。',
            error: {
                firstNameRequired: '名字不能为空',
                lastNameRequired: '姓氏不能为空',
                usernameRequired: '用户名不能为空',
                passwordRequired: '密码不能为空',
                invalidEmail: '请输入有效的邮箱地址',
                usernameTaken: '用户名已被占用',
                failedUsernameCheck: '用户名校验失败',
                failedDecline: '拒绝邀请失败',
            },
        },
        schedule: {
            loadFailed: '加载公开排期失败',
            missingToken: '缺少排期令牌',
            unavailable: '公开排期不可用',
            couldNotLoad: '该排期无法加载。',
            publicChoirSchedule: '公开合唱排期',
            serviceCount: '{{count}} 场活动',
        },
        harmony: {
            mixerView: '混音视图',
            mixerViewInfo: '（推荐在电脑端使用）在混音视图中，你可以调节各个音轨的音量与声像，获得更个性化的听感。',
            loadingWaveform: '正在加载波形...',
            mute: '静音',
            unmute: '取消静音',
            solo: '独奏',
            unsolo: '取消独奏',
            titleFallback: '和声',
            setlistFallback: '曲目单',
            ogDescription: 'VocalCentric 上精心整理的曲目单，包含不同声部与乐器的定制和声。',
            playPause: '播放或暂停',
            restart: '重新开始',
        },
        privacy: {
            gotoDashboard: '前往仪表盘',
            policyTitle: '{{companyName}} 隐私政策',
            lastUpdated: '最后更新：{{lastUpdated}}',
            intro: '在 {{companyName}}，我们重视你的隐私并致力于保护你的个人信息。本隐私政策说明当你使用我们的平台、移动应用或相关服务时，我们如何收集、使用和保护你提供的数据。',
            section1Title: '1. 我们收集的信息',
            section1Intro: '我们可能会收集以下类型的信息：',
            personalInfoLabel: '个人信息',
            personalInfoBody: '包括姓名、邮箱、电话号码、头像以及你在创建账号时提供的其他信息。',
            usageDataLabel: '使用数据',
            usageDataBody: '包括你在平台上的使用方式，例如歌曲播放、排练参与以及与其他用户的互动。',
            mediaFilesLabel: '媒体文件',
            mediaFilesBody: '你上传或分享的音频、视频及其他内容。',
            deviceInfoLabel: '设备信息',
            deviceInfoBody: 'IP 地址、浏览器类型、设备型号、操作系统以及应用版本。',
            cookiesLabel: 'Cookie 与跟踪数据',
            cookiesBody: '用于改善你的使用体验并记住偏好设置。',
            section2Title: '2. 我们如何使用你的信息',
            section2Item1: '提供并改进我们的服务。',
            section2Item2: '支持合唱排练、歌曲播放及社区互动。',
            section2Item3: '个性化内容与推荐。',
            section2Item4: '在你同意的前提下，向你发送更新、支持或推广信息。',
            section2Item5: '确保安全并遵守我们的服务条款。',
            section3Title: '3. 我们如何共享你的信息',
            section3Intro: '我们不会出售你的个人信息。仅在以下情况下共享数据：',
            section3ConsentLabel: '经你同意',
            section3ConsentBody: '当你选择与其他用户分享录音或个人资料信息时。',
            section3ProvidersLabel: '服务提供商',
            section3ProvidersBody: '与帮助我们运营平台的第三方供应商共享（例如云服务、支付处理）。',
            section3LegalLabel: '法律义务',
            section3LegalBody: '在法律要求或响应有效法律请求时。',
            section4Title: '4. 数据安全',
            section4Body: '我们采取技术、管理和物理措施保护你的数据，防止未经授权的访问、使用或披露。但互联网传输与电子存储无法保证 100% 安全。',
            section5Title: '5. 你的权利',
            section5Intro: '根据你所在地区，你可能享有以下权利：',
            section5Item1: '访问、更新或删除你的个人信息。',
            section5Item2: '限制或反对我们处理你的数据。',
            section5Item3: '请求我们持有的你的数据副本。',
            section5ContactIntro: '如需行使这些权利，请联系',
            section6Title: '6. 数据保留',
            section6Body: '除法律要求更长保留期限外，我们仅在提供服务及实现本政策所述目的所需的期间内保留你的个人数据。',
            section7Title: '7. 儿童隐私',
            section7Body: '{{companyName}} 不面向 13 岁以下儿童（或你所在国家/地区规定的最低法定年龄）。未经监护人同意，我们不会主动收集儿童个人信息。',
            section8Title: '8. 政策变更',
            section8Body: '我们可能不时更新本隐私政策。若发生重大变更，我们会通过邮件或应用内通知告知你。',
            section9Title: '9. 联系我们',
            emailLabel: '邮箱：',
            websiteLabel: '网站：',
            rightsReserved: '© {{year}} VocalCentric。保留所有权利。',
            navAbout: '关于',
            navPrivacy: '隐私',
            navTerms: '条款',
            navContact: '联系',
        },
        accountDeletion: {
            title: 'Google 账号删除',
            subtitle: '本页面说明如何删除你的 VocalCentric 账号（包括 Google 登录账号）、会删除哪些内容以及如何联系我们。',
            signedInAs: '你当前登录为',
            instantDeleteHint: '你可以在此立即删除账号。',
            deleting: '删除中…',
            deleteNow: '立即删除我的账号',
            submitted: '你的请求已提交。删除完成后我们会发送邮件通知你。',
            howToRequest: '如何申请删除',
            howToRequestItems: {
                inAppOrForm: '使用应用内选项（账户 → 设置 → 删除账户），或提交下方表单。',
                verifyOwnership: '我们会通过你的邮箱地址或应用内会话验证账户归属。',
                deleteAfterVerification: '验证通过后，我们将永久删除你的账号及个人数据；但在防欺诈、安全或法律义务需要时，会保留最少量记录。',
            },
            whatWillBeDeleted: '将被删除的内容',
            deletedItems: {
                profile: '账户资料（姓名、邮箱、用户名、头像）。',
                submissions: '练习提交记录、排练参与元数据，以及与你身份绑定的社区帖子（若删除会破坏对话结构，内容可能会匿名化处理）。',
                history: '播放历史、偏好设置和设备关联信息。',
            },
            retentionLabel: '数据保留：',
            retentionBody: '在法律要求下，我们可能保留最少量日志或财务记录，并保留无法识别个人身份的汇总/匿名分析数据。',
            googleUsers: 'Google 登录用户',
            googleUsersBody: '如果你通过 Google 注册，删除 VocalCentric 账号不会删除你的 Google 账号。我们只会撤销本应用的访问权限并删除你在 VocalCentric 上的数据。你也可以在 Google 账号 → 安全性 → 第三方访问中查看或移除 VocalCentric 的访问权限。',
            emailPlaceholder: '你@示例.com',
            reasonPlaceholder: '可选：告诉我们你离开的原因（帮助我们改进）',
            confirmLabel: '我确认我拥有该邮箱，并希望永久删除我的 VocalCentric 账号及相关数据。',
            submitting: '提交中…',
            submitRequest: '提交删除请求',
            needHelp: '需要帮助？请发送邮件至',
            toast: {
                requestReceived: '我们已收到你的账号删除请求。',
                deleted: '你的账号已成功删除。',
            },
            error: {
                emailRequired: '邮箱为必填项。',
                invalidEmail: '请输入有效的邮箱地址。',
                confirmRequired: '你必须确认账号归属及删除意图。',
                unexpected: '发生未知错误。',
                unableDeleteNow: '当前无法删除账号。',
            },
        },
    },
    uploads: {
        communityUpload: '社区上传',
        title: '上传商城歌曲',
        subtitle: '该流程与内部歌曲配置一致，但会将内容提交到社区商城流程（仅限白名单创作者）。',
        duplicateTitle: '你已经提交过同名社区歌曲',
        steps: {
            information: '信息',
            vocals: '人声',
            lyrics: '歌词',
            sync: '同步',
            files: '文件',
        },
        actions: {
            previous: '上一步',
            next: '下一步',
            preview: '预览',
        },
        toast: {
            submitted: '社区歌曲提交成功',
            submitFailed: '歌曲提交失败',
        },
        submission: {
            saved: '提交已保存',
            sentForProcessing: '{{title}} 已发送至商城处理流程。',
            processingNote: '歌曲已成功创建。音频打包和商城可用性会在后台继续处理，预览或上架控制可能需要一点时间才会生效。',
            goToListings: '前往我的上架',
            uploadAnother: '再上传一首',
            id: '提交 ID：{{id}}',
        },
        stepOne: {
            songOwnershipType: '歌曲归属类型',
            original: '原创',
            cover: '翻唱',
            songTitle: '歌曲标题',
            artistName: '艺术家名称',
            writers: '作者',
            album: '专辑',
            genre: '风格',
            label: '厂牌',
            themeLabel: '主题',
            chooseTheme: '选择主题',
            theme: {
                praise: '赞美',
                worship: '敬拜',
                thanksgiving: '感恩',
                prayer: '祷告',
                adoration: '颂赞',
                faith: '信心',
                healing: '医治',
                salvation: '救恩',
                grace: '恩典',
                mercy: '怜悯',
            },
            bpm: 'BPM',
            timeSignature: '拍号',
            chooseTimeSignature: '选择拍号',
            durationSeconds: '时长（秒）',
            duration: '时长',
            key: '调号',
            chooseKey: '选择调号',
            year: '年份',
            tags: '标签',
            tagPlaceholder: '输入标签后按空格或逗号',
        },
        stepTwo: {
            whichStem: '你要上传哪个 stem？',
            uploadStem: '上传 {{stem}}',
            uploadHint: '点击从电脑或手机上传预录 stem',
        },
        stepThree: {
            tabs: {
                lyrics: '歌词',
                mainSolfa: '主旋律 solfa',
                tenorSolfa: '男高音 solfa',
                altoSolfa: '女低音 solfa',
                sopranoSolfa: '女高音 solfa',
            },
            optionalNote: '社区歌曲的歌词是可选项。若希望按段落选择预览，请添加分段；否则可留空并在下一步设置自定义预览区间。',
            startTyping: '开始输入 {{target}}...',
            uploadMainStemHint: '请先上传主 stem，以便在整理歌词时预览波形。',
        },
        stepFour: {
            previewWindow: '预览窗口',
            previewDescription: '选择买家首先听到的内容。若歌曲有分段可直接选段，否则请设置自定义区间。',
            previewSource: '预览来源',
            customInterval: '自定义区间',
            previewStart: '预览开始',
            previewEnd: '预览结束',
            defaultStart: '00:00',
            defaultEnd: '00:20',
            useCurrent: '使用当前时间',
            noLyricsNote: '社区歌曲歌词可选。若不填写歌词，请直接在上方设置预览区间。',
            adjusting: '正在调整',
            selectLineToSync: '选择一行歌词开始同步',
            uploadMainStemToSync: '上传主 stem 以对齐时间戳与波形。',
        },
        stepFive: {
            imageUploadFailed: '图片上传失败',
            title: '上传封面与辅助文件',
            subtitle: '这些视觉素材将用于商城卡片和歌曲详情页。',
            artistImage: '艺术家图片',
            uploadArtistImage: '点击上传艺术家图片',
            coverArt: '封面图',
            uploadCoverArt: '点击上传封面图',
        },
        document: {
            title: '上传乐谱或辅助文档',
            description: '支持 PDF 和 DOCX（最大 20MB）',
            timeout: '文档上传超时，处理未完成',
            failed: '文档上传失败',
        },
        preview: {
            customInterval: '自定义区间',
            song: '歌曲',
            album: '专辑',
            genre: '风格',
            theme: '主题',
            duration: '时长',
            stemCount: 'Stem 数量',
            previewWindow: '预览窗口',
            lyrics: '歌词',
            sectionsCount: '{{count}} 个分段',
            optionalNone: '可选，尚未添加',
            previewSource: '预览来源',
            uploadedStems: '已上传 Stems',
            noStems: '尚未上传 Stem',
            submitting: '提交中...',
            submit: '提交',
        },
    },
    exercises: {
        actions: {
            backToExercises: '返回练习',
            backToSkill: '返回技能',
            continue: '继续',
            continueWithoutMic: '不使用麦克风继续',
            exit: '退出',
            gotIt: '明白了',
            keepPracticing: '继续练习',
            listenBack: '回听',
            locked: '已锁定',
            pausePlayback: '暂停播放',
            play: '播放',
            playAgain: '再玩一次',
            playExample: '播放示例',
            practice: '练习 {{title}}',
            replay: '重练',
            retry: '重试',
            saving: '正在保存...',
            skipStep: '跳过步骤',
            start: '开始',
            startBreathCheck: '开始呼吸检测',
            startPlan: '开始计划',
            startPulse: '开始节拍',
            startRecording: '开始录音',
            startTimer: '开始计时',
            stopExample: '停止示例',
            tryAgain: '再试一次',
            viewPath: '查看章节',
        },
        status: {
            comingSoon: '即将推出',
            complete: '已完成',
            counting: '正在计数...',
            endlessPractice: '无限练习',
            loadingPianoSamples: '正在加载钢琴采样...',
            listening: '正在聆听...',
            noDrillsYet: '暂无练习',
            recording: '正在录音...',
            recordingSaved: '录音已保存',
            running: '正在运行...',
        },
        units: {
            bpmPulse: '{{bpm}} BPM · 数节拍',
            drillCount: '{{count}} 个练习',
            drillCount_other: '{{count}} 个练习',
            drills: '练习',
            min: '{{count}} 分钟',
            secondEcho: '{{count}} 秒回唱',
            skillsDrills: '{{skills}} 个技能 - {{drills}} 个练习',
            stars: '星星',
            stepCount: '{{count}} 个步骤',
            steps: '步骤',
            stepOfTotal: '第 {{step}} 步，共 {{total}} 步',
            unitsDrills: '{{units}} 个单元 - {{drills}} 个练习',
        },
        skillTree: {
            benefits: {
                default: '一个简短的 VocalCentric 练习游戏。',
                warmupFoundation: '在更高强度练习前，用短暂的声乐重置进入演唱状态。',
                breathControl: '建立更稳定的气流，让乐句更平稳、更可控。',
                pitchAccuracy: '提升音高匹配能力，让耳朵反应更快。',
                noteRecognition: '通过快速、低压力回合建立音名快速反应。',
                keyboardNotes: '直接在钢琴式键盘上找到音符。',
                intervalBasics: '通过命名和配对练习学习音符之间的距离。',
                theoryTerms: '把常见音乐词汇练成快速、自信的反应。',
                earTrainingBasics: '聆听、比较并识别简短的音符和音程参考。',
            },
            directGames: {
                scaleChoices: {title: '音阶选择', tag: '音阶', purpose: '听一个音阶模式，然后选择答案。'},
                modeChoices: {title: '调式选择', tag: '调式', purpose: '听一个调式模式，然后选择答案。'},
                listenAndChoose: {title: '听辨选择', tag: '听觉', purpose: '听一个音，然后选择答案。'},
                hearAndPlay: {title: '听后弹奏', tag: '琴键', purpose: '听一个音，然后在键盘上找到它。'},
                hearChords: {title: '听辨和弦', tag: '听觉', purpose: '听一个和弦，然后说出它的性质。'},
                findNotesOnKeys: {title: '在琴键上找音', tag: '琴键', purpose: '直接在键盘上点击目标音。'},
                hearIntervals: {title: '听辨音程', tag: '听觉', purpose: '听两个音，然后说出音程。'},
                noteNameSprint: {title: '音名冲刺', tag: '音符', purpose: '快速回答音名提示。'},
                theoryQuickfire: {title: '乐理快答', tag: '乐理', purpose: '练习核心音乐词汇。'},
            },
            empty: '暂无可用的练习技能。',
            error: '目前无法加载练习。',
            fallbackModuleDescription: '用于音高、节奏、乐理和听觉训练的短练习。',
            fallbackModuleTitle: '核心技能',
            games: '游戏',
            gamesDescription: '直接进入无限练习，不改变课程进度。',
            headings: {
                browseLibrary: '课程章节',
                choosePath: '音乐理论课程',
                continuePractice: '继续练习',
                recommendedPractice: '推荐练习',
            },
            libraryDescription: '打开章节，查看其中四个菱形单元。',
            loading: '正在加载你的音乐理论课程...',
            moduleAudience: {
                course: '把这四个单元作为一个课程章节完成。',
                default: '想要专注练习路径时选择这个。',
                musicianship: '想要快速、可重复的音乐游戏时选择这个。',
                voice: '唱歌或排练前选择这个。',
            },
            moduleBenefit: {
                course: '通过短课程、检查题和可玩的练习建立乐理知识。',
                default: '选择一组专注的 VocalCentric 短练习。',
                musicianship: '通过快速游戏训练音符、音程、节奏和听觉反应。',
                voice: '排练前热身、控制呼吸并提升音准。',
            },
            moreStartedSkills: '还有已开始、值得继续完成的技能。',
            progress: '进度',
            progressCleared: '已完成 {{cleared}}/{{total}}',
            prompts: {
                dailyPlan: '今日计划：{{label}}。',
                dailyPlanFallback: '今日计划根据你最近的练习进度调整。',
                finishNext: '趁状态还新鲜，完成下一个练习。',
                replaySkill: '重练这个技能，提升速度、准确度和信心。',
                startFocused: '从一个专注练习开始，建立实用的音乐直觉。',
            },
            quickGame: {
                buildKeyboard: '建立键盘记忆。',
                ear: '听觉',
                keys: '琴键',
                notes: '音符',
                practice: '练习',
                replayImprove: '重练以提升。',
                runFocused: '进行一个简短专注的练习。',
                speed: '速度',
                theory: '乐理',
                trainListening: '训练听觉反应。',
                practiceMusicIdeas: '练习核心音乐概念。',
            },
            viewAll: '查看全部 {{title}}',
            showFewer: '收起 {{title}}',
        },
        skillDetail: {
            exerciseNumber: '练习 {{number}}',
            fallbackDescription: '一组快速练习，用来提升音乐直觉。',
            loadError: '无法加载此技能。',
            loading: '正在加载技能...',
            missing: '未找到技能。',
            shortFocused: '简短且专注。',
            skill: '技能',
        },
        runner: {
            empty: '此技能暂无可播放步骤。',
            fallbackPrompt: '聆听、选择，并相信你的耳朵。',
            messages: {
                patternSeen: '已看完模式。',
                readyNext: '准备进入下一步。',
                referenceHeard: '参考已听完。继续。',
                resetComplete: '重置完成。',
                skippedForWeb: '已在网页端跳过。',
            },
            result: {
                complete: '本组完成',
                earnedStars: '本轮你获得了 {{count}} 颗星。',
                fallback: '继续练习，下次会更顺畅。',
                niceRun: '完成得不错',
                savedLocally: '你的结果暂时已保存在本地。网络稳定后再试一次这组练习。',
                youFinished: '你完成了 {{title}}。',
            },
        },
        generated: {
            chooseBest: '选择最佳答案。',
            chooseHeard: '选择你听到的内容',
            namePattern: '说出{{label}}名称',
            recallTerm: '回忆术语',
            scale: '音阶',
            mode: '调式',
            tapNote: '点击 {{note}}。',
            whatTermMean: '{{term}} 是什么意思？',
            whichNote: '你听到了哪个音？',
            whichPattern: '你听到了哪个{{label}}？',
        },
        steps: {
            animation: {
                watchPulse: '观察 {{count}} 拍的脉冲。',
            },
            audioReference: {
                chooseHeard: '点击播放，仔细聆听，然后选择你听到的内容。',
                fallbackCopy: '点击播放，先听音色再继续。',
                heading: '听参考音',
                noSource: '此参考尚未包含可在网页播放的音频源。',
                pianoUnavailable: '此浏览器不支持钢琴播放。',
                samplesLoading: '钢琴采样仍在加载。',
                playFailed: '无法播放此参考。',
            },
            meter: {
                breathSkipped: '已跳过呼吸引导。',
                countPulse: '节拍已锁定。',
                exhale: '呼气',
                followCue: '跟随提示，然后保持呼气平稳。',
                inhaleSeconds: '吸气 {{count}} 秒',
                holdSeconds: '保持 {{count}} 秒',
                keepAirflow: '保持气流稳定。',
                listeningLevel: '正在监听你的呼吸强度。',
                micFeedback: '麦克风反馈会测量呼气稳定度。',
                micNeeded: '呼吸反馈需要麦克风权限。',
                micUnavailable: '此浏览器无法使用麦克风输入。',
                phase: '阶段',
                phaseReady: '准备',
                phaseInhale: '吸气',
                phaseHold: '保持',
                phaseExhale: '呼气',
                smoothExhale: '呼吸有波动。试着更平稳地呼气。',
                steadyAirflow: '气流保持稳定。',
                liveFeedbackUnavailable: '此浏览器不支持实时呼吸反馈。',
            },
            multipleChoice: {
                chooseBest: '选择最佳答案。',
                close: '接近了。再试一次。',
                correct: '答对了。',
            },
            pairs: {
                answer: '匹配答案',
                complete: '配对完成。下次可以更干净。',
                perfect: '完美配对。',
                prompt: '点击提示',
            },
            piano: {
                missed: '这个音没有命中目标。',
                playHeard: '在键盘上弹出你听到的内容。',
                right: '这个音是正确的。',
                tapTarget: '点击 {{note}}。',
                targetNote: '目标音',
                unavailable: '此浏览器不支持钢琴播放。',
                useReference: '使用标记的 {{note}} 键作为八度参考。',
            },
            record: {
                challenge: {
                    echoMelody: '模唱旋律',
                    holdSteady: '稳定保持 {{note}}',
                    singBack: '唱回来',
                },
                coaching: {
                    melody: '保持轻松，让音符顺畅连接。',
                    steady: '轻声演唱，并保持音高稳定。',
                },
                guide: {
                    close: '你已经接近旋律。',
                    focus: '关注旋律形状，而不是音量。',
                    listening: '正在聆听你的声音...',
                    moveToward: '保持柔和，并向旋律靠近。',
                },
                labels: {
                    flow: '聆听 → 演唱 → 回顾',
                    melodyNotes: '旋律音符：{{notes}}',
                },
                messages: {
                    capturedNoTarget: '已捕获录音。此步骤需要明确目标音后，网页端才能评分。',
                    detectFailed: '未能检测到稳定的目标音高。请再录一次。',
                    drifted: '检测到了音高，但它偏离了旋律。',
                    matched: '这与旋律走向匹配。',
                },
                errors: {
                    micNeeded: '此步骤需要麦克风权限。',
                    playbackUnavailable: '此浏览器不支持参考播放。',
                    recordingUnavailable: '此浏览器不支持录音。',
                },
            },
            text: {
                fallback: '接收这个提示，然后继续。',
            },
            timer: {
                reset: '呼吸、重置，然后清晰回来。',
            },
            unsupported: {
                body: '你可以继续本轮练习。',
                title: '此练习步骤尚未在网页端可用。',
            },
        },
        controls: {
            accidentals: '变音',
            accidentalsDescription: '在音符选项中加入升号。',
            alphabet: '字母唱名',
            challenge: '挑战',
            difficulty: '难度',
            difficulty_auto: '自动',
            difficulty_easy: '简单',
            difficulty_expert: '专家',
            difficulty_hard: '困难',
            difficulty_normal: '普通',
            gameSettings: '游戏设置',
            mixed: '混合',
            notation: '记谱',
            pad: '持续音 {{note}}',
            solfege: '固定/首调唱名',
            tonic: '主音 {{note}}',
        },
    },
    training: {
        eyebrow: '学校与诗班训练', title: '学校', subtitle: '管理课程、班级、作业、学生进度和直播训练，可关联或不关联诗班。', choirEyebrow: '诗班发展', choirTitle: '训练', choirDescription: '为指定成员安排结构化练习、作业、反馈和直播指导。', choirTab: '训练', choirTabDescription: '课程与成员培养', workspaces: '学校', myCohorts: '我的班级', courses: '课程', courseDescription: '可关联到多个班级的可复用课程内容。', curriculum: '课程计划', curriculumDescription: '使用自定义练习和学习材料创建有序课程。', cohorts: '班级', cohortsDescription: '创建有日期的学习群组，每个班级可关联一个或多个课程。', mappedCourses: '已关联课程', courseClassMappingDescription: '班级属于学校，并可使用多个课程。', classCurriculumDescription: '此班级所关联全部课程的课程计划。', assignments: '作业', sessions: '课程安排', progress: '学习进度', staff: '教学团队', students: '学生', submissions: '提交记录', submissionsDescription: '查看每次尝试并提供可执行的反馈。', exerciseAssignment: '练习作业', exerciseAssignmentDescription: '完成已配置的练习。最多可提交 {{count}} 次。', learningMaterials: '学习材料', myAttempts: '我的尝试', attemptNumber: '第 {{count}} 次尝试', previewTitle: '练习预览', pendingReviews: '待审核', upcomingSessions: '即将开始的课程', pendingInvitations: '待处理邀请', workspaceSettings: '学校设置', courseSettings: '课程设置', cohortSettings: '班级设置', cohortStaff: '班级教师', assignmentSettings: '作业设置',
        actions: {
            accept: '接受', addCourse: '添加课程', addCurriculum: '添加课程内容', addStudents: '添加学生', applyInstructor: '申请创建学校', approve: '通过', archiveCohort: '归档班级', archiveCourse: '归档课程', archiveWorkspace: '归档学校', assignStaff: '分配教师', back: '返回', backToCohort: '返回班级', backToTeaching: '返回学校', cancel: '取消课程', checkIn: '登记出席', createCohort: '创建班级', createCourse: '创建课程', decline: '拒绝', edit: '编辑', editCurriculum: '编辑课程内容', endSession: '结束课程', enroll: '加入现有用户', inviteNewStudent: '邀请新学生', inviteStaff: '邀请教师', join: '加入', lowerHand: '放下手', manageClasses: '管理班级', manageTraining: '管理训练', moveDown: '下移', moveUp: '上移', needsImprovement: '需要改进', newCohort: '新建班级', newCourse: '新建课程', newWorkspace: '新建学校', open: '打开', openChoir: '打开诗班', openCourse: '打开课程', openSchool: '打开学校', preview: '预览练习', publishAssignment: '发布作业', raiseHand: '举手', remove: '移除', resend: '重新发送', revoke: '撤销', scheduleSession: '安排课程', send: '发送消息', sendInvite: '发送邀请', share: '共享', start: '开始', startAssignment: '开始作业', submit: '提交', submitApplication: '提交申请',
        },
        fields: {
            assignmentSource: '作业来源', assignmentTitle: '作业标题', attemptsAllowed: '允许尝试次数', audioResponse: '音频回答（可选）', choirMembers: '选择合唱团成员', choirPart: '诗班声部', cohortTitle: '班级名称', course: '课程', courseTitle: '课程名称', description: '说明', dueAt: '截止时间', email: '邮箱', ends: '结束', enrollmentMode: '加入方式', exerciseTemplate: '练习模板', feedback: '反馈', instructions: '要求', itemType: '内容类型', level: '级别', locationMode: '上课方式', materialUrl: '材料链接', passStars: '通过星级', responseNote: '你的回答', role: '角色', sessionTitle: '课程标题', starts: '开始', status: '状态', studentEmails: '学生邮箱', title: '标题', verifiedScore: '已验证分数', verifiedStars: '已验证星级', workspaceName: '学校名称',
        },
        roles: {owner: '所有者', instructor: '教师', assistant: '助教', learner: '学生'}, statuses: {active: '进行中', archived: '已归档', closed: '已关闭', completed: '已完成', draft: '草稿', enrolling: '招生中', published: '已发布'}, enrollmentModes: {invite: '仅限邀请', open: '开放加入'}, itemTypes: {exercise: '练习', material: '学习材料'}, assignmentSources: {curriculum: '课程计划', adhoc: '一次性自定义练习'}, locationModes: {virtual: '线上', physical: '线下', hybrid: '混合'}, units: {assignments: '项作业', attempts: '次尝试', cohorts: '个班级', curriculumItems: '项课程内容', learners: '名学生', pending: '待处理', submissions: '次提交'},
        placeholders: {choirPart: '例如：女高音', emails: '用逗号或空格分隔邮箱', level: '例如：初级', optionalCurriculumTitle: '可选——默认使用课程计划标题'},
        empty: {
            assignmentsTitle: '暂无作业', assignmentsDescription: '已发布的作业会显示在这里。', attemptsTitle: '暂无尝试', attemptsDescription: '准备好后即可开始作业。', choirTrainingTitle: '尚未设置训练', choirTrainingDescription: '诗班指挥或管理员可以创建诗班学校。', classCurriculumDescription: '请将带课程计划的课程关联到此班级。', cohortsTitle: '暂无班级', cohortsDescription: '你的活跃班级会显示在这里。', courseCohortsDescription: '请从学校内的班级关联此课程。', coursesTitle: '暂无课程', coursesDescription: '创建可复用课程，再关联到一个或多个班级。', curriculumTitle: '课程计划为空', curriculumDescription: '添加第一个自定义练习或学习材料。', invitationsDescription: '暂无待处理邀请。', noCourses: '未关联课程', noDescription: '未提供说明。', noInstructions: '没有额外要求。', progressTitle: '暂无学习进度', progressDescription: '加入学生并发布作业后即可查看进度。', sessionsTitle: '暂无课程安排', sessionsDescription: '即将开始和正在直播的课程会显示在这里。', submissionsTitle: '暂无提交', submissionsDescription: '学生的尝试会显示在这里供你审核。', workspacesTitle: '暂无学校', workspacesDescription: '为你的学生、学院或工作室创建学校。',
        },
        errors: {
            archiveCohort: '无法归档班级。', archiveCourse: '无法归档课程。', archiveWorkspace: '无法归档学校。', assignStaff: '无法分配教师。', attendance: '无法登记出席。', createAssignment: '无法发布作业。', createCohort: '无法创建班级。', createCourse: '无法创建课程。', createSession: '无法安排课程。', createWorkspace: '无法创建学校。', endSession: '无法结束课程。', enroll: '无法加入学生。', instructorApplication: '无法提交教师申请。', invalidInvitation: '此邀请链接无效。', invitation: '无法回应此邀请。', invite: '无法发送邀请。', inviteFirst: '请先邀请以下学生：', load: '无法加载学校。', loadAssignment: '无法加载作业。', loadChoirTraining: '无法加载诗班训练。', loadCohort: '无法加载班级。', loadCourse: '无法加载课程。', loadSession: '无法加载课程安排。', loadWorkspace: '无法加载学校。', mapCourse: '无法更新班级关联的课程。', preview: '无法生成预览。', removeCurriculum: '无法移除课程内容。', removeStaff: '无法移除教师。', reorder: '无法调整课程顺序。', resendInvitation: '无法重新发送邀请。', review: '无法保存审核。', revokeInvitation: '无法撤销邀请。', saveCurriculum: '无法保存课程内容。', saveWorkspace: '无法保存学校。', startSession: '无法开始课程。', submit: '无法提交作业。', updateAssignment: '无法更新作业。', updateCohort: '无法更新班级。', updateCourse: '无法更新课程。', updateEnrollment: '无法更新学生状态。', updateSession: '无法更新课程安排。', updateStaff: '无法更新教师。',
        },
        confirm: {archiveAssignment: '确定归档此作业吗？现有提交将被保留。', archiveCohort: '确定归档此班级吗？', archiveCourse: '确定归档此课程吗？', archiveWorkspace: '确定归档此学校吗？', cancelSession: '确定取消此课程吗？', endSession: '确定结束直播课程吗？', removeCourseFromClass: '确定从班级移除此课程吗？', removeCurriculum: '确定移除此课程内容吗？', removeStaff: '确定从班级移除此教师吗？', removeStudent: '确定从班级移除此学生吗？'},
        attendanceStatuses: {present: '出席', late: '迟到', absent: '缺席', excused: '请假'},
        classroom: {attendance: '出席记录', cancelledDescription: '此课程已取消。', cancelledTitle: '课程已取消', chat: '课堂聊天', chatFailed: '无法发送消息。', checkedIn: '已登记', clearContext: '清除共享内容', completedDescription: '此课程已结束。', completedTitle: '课程已完成', context: '课堂内容', contextFailed: '无法共享课堂内容。', handRaiseFailed: '无法更新举手状态。', joinFailed: '无法加入课堂。', joinMedia: '加入音视频', joiningMedia: '正在加入…', leaveMedia: '离开音视频', enableAudio: '开启声音', listenOnly: '你当前为仅收听模式。教师控制谁可以发布音视频。', liveRoom: '直播课堂', mediaJoinFailed: '无法加入音视频课堂。', mediaPresenceFailed: '你已加入课堂，但出席状态更新失败。', mediaReady: '准备好后即可加入。发言时需要麦克风权限，摄像头仅供教师使用。', mediaRenewFailed: '无法续期课堂媒体令牌。', message: '消息', muteMicrophone: '麦克风静音', noContext: '当前未共享作业或材料。', noMessages: '暂无消息。', notCheckedIn: '未登记', participants: '参与者', physicalSession: '这是线下课程。课堂聊天、出席登记和共享作业仍可使用。', present: '已出席', selfCheckInDescription: '登记参加本次班级课程。', turnCameraOff: '关闭摄像头', turnCameraOn: '打开摄像头', unmuteMicrophone: '取消麦克风静音', waitingInstructor: '准备好后开始课程。系统会通知已加入的学生。', waitingLearner: '教师尚未开始课程。此页面会自动更新。', waitingTitle: '等待课程开始', you: '你', joinStates: {idle: '等待加入', joined: '已连接课堂控制', joining: '正在加入课堂'}, mediaStates: {idle: '媒体未连接', joined: '音视频已连接', joining: '正在连接音视频', reconnecting: '正在重新连接音视频'}},
        instructorApplication: {title: '认证教师申请', description: '创建独立学校需要教师审批。请上传简短的教学或表演视频并说明经验。', pending: '你的申请正在审核中。', rejected: '之前的申请未获批准。请更新材料后重新提交。', video: '教学或表演视频', reason: '为什么应当批准你的申请？'},
        invitation: {eyebrow: '教学邀请', title: '加入此教学空间', description: '接受后将以教师、助教或学生身份加入。邀请仅可使用一次，并与当前账户绑定。'},
        openEnrollment: {title: '加入此班级', description: '报名后即可接收作业、反馈和已安排的训练课次。', unavailable: '此班级目前不接受你的报名，请向教师索取邀请。'},
    },
    vocalContributions: {
        title: '人声贡献',
        addVocal: '添加人声',
        tags: {
            popular: '热门',
            popularDescription: '最热门专辑',
            new: '最新',
            newDescription: '新加入',
        },
        table: {
            title: '标题',
            dateCreated: '创建日期',
            plays: '播放量',
            votes: '票数',
            vocal: '声部',
            actions: '操作',
        },
        actions: {
            editEntry: '编辑条目',
            delete: '删除',
        },
        toast: {
            addedToRehearsals: '歌曲已加入排练',
        },
    },
};

export default zh;
